// en, de, fr, pt
export default {
  addNewSkill: {
    ans1: "Back",
    ans2: "Next",
    ans3: "Submit",
    data: {
      ed: {
        characteristic: "Enthusiasm and Drive",
        wdd: "Consistently achieving results and meeting goals and targets; being motivated to achieve career advancement; sticking to a course of action despite obstacles and seeing things through to the end; taking initiative and demonstrate a positive can-do attitude.",
        icon: require("@/assets/Iconography/Characteristics/07_Energetic Driver.svg"),
        competencies: [
          {
            id: "ed-0",
            icon: require("@/assets/Iconography/Attributes/07-01_Achieving Goals.svg"),
            comp: "Achieving goals",
            wdd: "Consistently achieves results and meets goals and targets",
            progressMeasures: [
              {
                id: "ed-0-0",
                pm: "I achieve the goals and performance targets for myself",
                pmMap: "Achieve the goals and performance targets for myself",
              },
              {
                id: "ed-0-1",
                pm: "I want to do well and set a high standard for myself",
                pmMap: "Strive to do well and set a high standard for myself",
              },
              {
                id: "ed-0-2",
                pm: "I do not let my energy get drained by obstacles",
                pmMap: "Not let my energy get drained by obstacles",
              },
              {
                id: "ed-0-3",
                pm: "I know how to step back and recharge before tackling tasks that appear insurmountable",
                pmMap:
                  "Know how to step back and recharge before tackling tasks that appear insurmountable",
              },
            ],
            developmentActions: [
              {
                id: "ed-0:1-a",
                da: "As a rule, first do the things you do not want to do. You will have to do them anyway, and often they prevent you from working productively because you spend too much energy trying to avoid these few tasks. Write down what they are and enlist a co-worker to keep you on track.",
              },
              {
                id: "ed-0:1-b",
                da: "Focus on doing the things that matter most so that you spend your time wisely. If time overtakes you, you will at least have taken care of the items that have the most impact. Be specific about what these things are and create a priority list. Confirm with an appropriate person that you have prioritized accurately.",
              },
              {
                id: "ed-0:1-c",
                da: "Tackle the task in palatable increments. Work on things during breaks you may have between your commitments and appointments. It will ensure the amount of work is manageable and you will see increasing progress.",
              },
              {
                id: "ed-0:1-d",
                da: "Anticipate that everything will take longer to complete than you expected. Whatever the deadline, subtract time from it to give yourself impetus to start. Reward yourself every time you meet the deadline.",
              },
              {
                id: "ed-0:1-e",
                da: "Take action immediately. Limit the time between getting the assignment and starting to work. Sitting still too long without taking action can harm your motivation.",
              },
              {
                id: "ed-0:1-f",
                da: "If you perform best or are motivated by working with others, recruit peers with whom you can collaborate to get you started. They will also be able to help keep you on track, especially if your performance is tied to others.",
              },
              {
                id: "ed-0:2-a",
                da: "Limit the time you spend on a given assignment. Set points at which you will confer with your superior for feedback on the level of detail you should be achieving. This will help to keep your expectations of yourself realistic.",
              },
              {
                id: "ed-0:2-b",
                da: "Reframe your expectations. Aim for completing a task or assignment well, not making it perfect.",
              },
              {
                id: "ed-0:3-a",
                da: "Build flexibility into your schedule so that you can tackle a particular project at a time that makes sense for you. Many people mark specific time blocks off to work on an assignment, but if you are burnt out this may backfire because your inspiration and motivation will be inconsistent ” they cannot be scheduled. Take advantage of the times you feel ready to work on a project, even if it is just for a short period. Conversely, move on to something else if you are not producing anything. Spinning your wheels will build frustration and increase negative associations with the work at hand.",
              },
              {
                id: "ed-0:3-b",
                da: "Review and reward your progress continually. Break down the project into smaller tasks and reward yourself every time you accomplish a step.",
              },
              {
                id: "ed-0:3-c",
                da: "Be honest with your superior. They may be able to assist you by doing something simple such as helping you to delegate some of your work. Often, people do not like to inform their superior of problems because they do not want to appear as if they cannot handle the situation. Inevitably, though, burnout will show in your performance, so act before it does.",
              },
              {
                id: "ed-0:3-d",
                da: "Shake things up ” if you are chronically feeling burnt out it may be time to look for another position within the company or try something completely new. Spend time to investigate your options and set your goal.",
              },
              {
                id: "ed-0:4-a",
                da: "Focus on doing the things that matter most. Be specific about what they are and create a priority list. Confirm with your superior that you have prioritized well and accurately. require you to extend yourself.",
              },
              {
                id: "ed-0:4-b",
                da: "Which activities take up most of your time? Create a list of your activities and assign the approximate times you are spending on each category. Then divide the categories into essential and â€œneed to do. What does your time allotment look like? mistake, write a list of the benefits of having made the mistake â€” the specifics of what you have learned, who you met in the process and so forth.",
              },
              {
                id: "ed-0:4-c",
                da: "Are you delegating appropriately? In which tasks can you involve others? theme of risk taking among them.",
              },
              {
                id: "ed-0:5-a",
                da: "Slowly raise your risk comfort level by taking on smaller assignments that require you to extend yourself.",
              },
              {
                id: "ed-0:5-b",
                da: "View mistakes as opportunities to learn and reflect. Every time you make a mistake, write a list of the benefits of having made the mistake â€” the specifics of what you have learned, who you met in the process and so forth.",
              },
              {
                id: "ed-0:5-c",
                da: "Read biographies of business or public leaders who you admire. Look for a common theme of risk taking among them.",
              },
              {
                id: "ed-0:5-d",
                da: "You may have taken more risk than you have thought or given yourself credit for. Document your accomplishments. What risks did each of these accomplishments involve? Write them down, regardless how small the risk was. Ask people who know you well to help you. The objective is to show that all careers are based on a combination of challenges to which we are continuously called upon to rise. You may already be more of a risk taker than you think.",
              },
              {
                id: "ed-0:6-a",
                da: "If you do not have a work plan yet, meet with your superior to develop one with specific goals and targets for each year. Agree to reassess your work plan occasionally to make any changes necessary.",
              },
              {
                id: "ed-0:6-b",
                da: "Be prepared to ask your supervisor and peers about your performance and whether you are meeting their expectations.",
              },
              {
                id: "ed-0:6-c",
                da: "Take a cue from peers that are known high performers. Compare your standard of work to theirs â€” do not rely on your own perception. Use their assessment as a yardstick to measure your level of accomplishment.",
              },
            ],
          },
          {
            id: "ed-1",
            icon: require("@/assets/Iconography/Attributes/07-02_Advancing My Career.svg"),
            comp: "Advancing my career",
            wdd: "Is motivated to achieve career advancement",
            progressMeasures: [
              {
                id: "ed-1-0",
                pm: "I usually feel confident that I can succeed in any role or position I choose to do",
                pmMap:
                  "Feel confident that I can succeed in any role or position I choose to do",
              },
              {
                id: "ed-1-1",
                pm: "I am clear about what I need to do to advance my career",
                pmMap: "Be clear about what I need to do to advance my career",
              },
              {
                id: "ed-1-2",
                pm: "I am taking the necessary action to work towards career advancement",
                pmMap:
                  "Take the necessary action to work towards career advancement",
              },
              {
                id: "ed-1-3",
                pm: "I discuss my future plans with my people who can help me achieve them",
                pmMap:
                  "Discuss my future plans with my people who can help me achieve them",
              },
            ],
            developmentActions: [
              {
                id: "ed-1:1-a",
                da: " Every day, visualize the things you want in your life and career. A growing movement believes in the power of visualization to attract what we need in our lives. Read The Secret by Rhonda Byrne.",
              },
              {
                id: "ed-1:1-b",
                da: " Positive affirmation can help to rewire your thinking. Be vigilant against negative thoughts about yourself and practice to replace them with positive ones immediately.",
              },
              {
                id: "ed-1:1-c",
                da: " Identify a few people who you admire for their self-confidence and talk to them about their views on the world. Note the differences in your thinking styles.",
              },
              {
                id: "ed-1:1-d",
                da: " Do not give mistakes more importance than they deserve. Write down the worst-case scenarios and analyze them. Unless your life or someone else's is at stake, the worst is never as bad as you might think.",
              },
              {
                id: "ed-1:1-e",
                da: " Read about people who have made mistakes but still succeeded, such as Thomas Edison. It took 10 000 failures to make the light bulb!",
              },
              {
                id: "ed-1:1-f",
                da: " You do not need to have all the answers. Work the part of your plan that you can, and ask for help with the rest.",
              },
              {
                id: "ed-1:1-g",
                da: " Extend your comfort zone. You are building confidence every time you take on a new challenge or task. Keep score of the new challenges you have overcome.",
              },
              {
                id: "ed-1:1-h",
                da: " Understand what your challenges will be if you were to move to a new position or role. List the things you are potentially uncomfortable doing. It could be managing people for the first time, networking more than usual or learning more about a specific technical area. Be as detailed as possible with your list. Which items on the list are perceived challenges and which ones are real? For example, you may not have supervised people before but work well with others, are approachable, patient, manage conflict well etcetera. All these behaviors point to your likely success as a leader.",
              },
              {
                id: "ed-1:1-i",
                da: " Learn more about the position you are interested in by spending time with the incumbent or someone in a similar role. Find out what they regard as the greatest challenges of the position. The more you know the better equipped you will be to start the job without being blindsided by unexpected demands.",
              },
              {
                id: "ed-1:1-j",
                da: " If you believe you truly lack the skills critical to getting a promotion, talk to your supervisor about devising a development plan that involves key assignments and experiences to help build your skills set. Make sure you communicate both your interest and your concern about shortcomings.",
              },
              {
                id: "ed-1:1-k",
                da: " In the end, no amount of preparation will guarantee you are 100% ready for a position. If the opportunity is available and you want to do it, stop thinking and take action.",
              },
              {
                id: "ed-1:1-l",
                da: " If you find that your lack of self-confidence is affecting your ability to function and advance in your career, seek the help of a professional coach or counselor as part of your development plan. A trained therapist can help you to challenge deep-rooted thinking patterns.",
              },
              {
                id: "ed-1:2-a",
                da: " Revisit your career goals. Are you still on track? Is your lack of motivation due to your current assignment or another temporary circumstance, or is the problem your position itself?",
              },
              {
                id: "ed-1:2-b",
                da: " Identify the specific needs that are not being met by your position. Assessment tools such as the Birkman method scrutinizes individuals' less obvious needs that are not met in their work environment and professional relationships. Other factors may be more obvious, such as salary, your relationship with your boss or a lack of challenging assignments. The app has a motivation survey which addresses motivational areas.",
              },
              {
                id: "ed-1:2-c",
                da: " Talk to your supervisor about the role you envision for yourself and how the opportunity can be created. Be honest - your supervisor may be thinking you are perfectly content with your situation.",
              },
              {
                id: "ed-1:2-d",
                da: " It is important to keep the momentum going when you are unmotivated. Identify three actions to complete in the next month that could help you to regain interest in your career.",
              },
              {
                id: "ed-1:2-e",
                da: " Try to visualize yourself doing something new. What would be your dream position in the organization? It makes sense to create a vision of your future then focus strategically on how to get there.",
              },
              {
                id: "ed-1:2-f",
                da: " Continue to look for opportunities within the company by networking and trying new roles until you find a project, assignment or job that motivates you.",
              },
              {
                id: "ed-1:3-a",
                da: " Put a plan in place for your career advancement. Let your supervisor help to identify the competencies, experience and technical skills you will need to get promoted.",
              },
              {
                id: "ed-1:3-b",
                da: " Take the initiative to find out about positions open in your company.",
              },
              {
                id: "ed-1:3-c",
                da: " Become knowledgeable about the skills considered scarce in your industry. Companies make extra efforts to retain employees with these skills.",
              },
              {
                id: "ed-1:3-d",
                da: " Try to visualize yourself doing something new. What would your dream opportunity in the organization be? It makes sense to create a vision of your future then focus strategically on how to get there.",
              },
              {
                id: "ed-1:3-e",
                da: " Make time to network. Talking to people and getting more exposure increase your chances of discovering new ways to raise your visibility and advance your career.",
              },
              {
                id: "ed-1:3-f",
                da: " Take growth one small step at a time if you are not comfortable with drastic changes or do not really know which step to take next. Experiment with new assignments that test different skills. It may surprise you to discover other things at which you are really talented. You will find yourself getting more comfortable doing different assignments the more diverse your experiences become.",
              },
              {
                id: "ed-1:3-g",
                da: " Inquire about short-term opportunities in your company, perhaps in a new department, if this could help you to advance towards your long-term goals.",
              },
              {
                id: "ed-1:3-h",
                da: " Read The Leadership Pipeline by Ram Charan and Stephen Drotter, which describes the competencies necessary to function successfully throughout different organizational levels.",
              },
              {
                id: "ed-1:4-a",
                da: " Can you pinpoint the reasons why you are feeling so burnt out? Which things within your control can change and which cannot? You will be surprised to see how changing one or two factors can provide the room you need to re-energize. Get feedback from family, peers or a coach about what those factors could be. Sometimes we find it hard to see what seem obvious to those around us.",
              },
              {
                id: "ed-1:4-b",
                da: " Is your workload reasonable and realistic? Talk to the relevant people about your work distribution if that contributes greatly to your burnout.",
              },
              {
                id: "ed-1:4-c",
                da: " Make sure you recharge daily with exercise or a hobby that helps to take your mind off work.",
              },
              {
                id: "ed-1:4-d",
                da: " Which aspects of the opportunity being offered do you like and which ones put you off? Which terms are negotiable? Typically, there are ways to tailor a promotion to better fit your needs.",
              },
              {
                id: "ed-1:4-e",
                da: " Observe successful people in your organization who have demanding jobs but keep a balance between their professional and private lives. Learn how they do it.",
              },
              {
                id: "ed-1:4-f",
                da: " Take a breather before making a decision. Take some time off to relax and think clearly. Whatever your decision upon your return, it will be based on a better perspective.",
              },
              {
                id: "ed-1:5-a",
                da: " Write down the pros and cons of staying in the same position.",
              },
              {
                id: "ed-1:5-b",
                da: " Identify a position that truly piques your interest and for which you would be willing to make sacrifices. Keep searching if you cannot identify something now.",
              },
              {
                id: "ed-1:5-c",
                da: " Even if you are not ready for a promotion, keep discussing possibilities with your peers and supervisor to demonstrate your interest.",
              },
              {
                id: "ed-1:5-d",
                da: " Talk to people in other positions a level or two above yours. Ask how they like their jobs and what the principal benefits are.",
              },
              {
                id: "ed-1:5-e",
                da: " Find out as much as possible about the position under consideration. It is common to make incorrect assumptions about the responsibilities a position entails. Talk to the incumbent, if possible, or others who have been in a similar role.",
              },
              {
                id: "ed-1:5-f",
                da: " Engage a coach to examine in depth the reasons why you are not interested in taking on more responsibility.",
              },
              {
                id: "ed-1:6-a",
                da: " Approach your self-promotion like you would any other business endeavor and create a personal marketing plan. Establish the actions you will undertake and hold yourself accountable weekly.",
              },
              {
                id: "ed-1:6-b",
                da: " Create a weekly status report to inform your boss about your accomplishments.",
              },
              {
                id: "ed-1:6-c",
                da: " Communicate your efforts to all your stakeholders, not just your peers or manager. If appropriate, consider informing your clients, senior management and business network.",
              },
              {
                id: "ed-1:6-d",
                da: " Learn to create a brief statement that communicates the highlights of your success without providing unnecessary details.",
              },
              {
                id: "ed-1:6-e",
                da: " Be wary of being too modest. Are you deflecting praise too quickly? Accept welldeserved praise graciously and with pride.",
              },
              {
                id: "ed-1:6-f",
                da: " Do not accept blame too quickly. You are accountable for your actions, not other people's mistakes. Taking blame when it is undeserved dilutes perceptions of your contribution.",
              },
              {
                id: "ed-1:6-g",
                da: " You may be more comfortable promoting your group's effort, which gives you a chance to highlight your role but share the accolades.",
              },
              {
                id: "ed-1:6-h",
                da: " Prepare well for your performance reviews. You must be able to highlight accomplishments and provide supporting documentation for the less obvious goals you have met.",
              },
            ],
          },
          {
            id: "ed-2",
            icon: require("@/assets/Iconography/Attributes/07-03_Being Determined.svg"),
            comp: "Being determined",
            wdd: "Sticks to a course of action despite obstacles and sees things through to the end",
            progressMeasures: [
              {
                id: "ed-2-0",
                pm: "I rarely quit before I have completed a task or project",
                pmMap: "Rarely quit before I have completed a task or project",
              },
              {
                id: "ed-2-1",
                pm: "I recover quickly from emotional setbacks during a project",
                pmMap:
                  "Recover quickly from emotional setbacks during a project",
              },
              {
                id: "ed-2-2",
                pm: "I have completed long-term projects successfully",
                pmMap: "Completing long-term projects successfully",
              },
              {
                id: "ed-2-3",
                pm: "I do not like leaving anything incomplete",
                pmMap: "Not leave things incomplete",
              },
            ],
            developmentActions: [
              {
                id: "ed-2:1-a",
                da: " Ensure that new initiatives are introduced in a manner that creates buy-in from all stakeholders and that the infrastructure and resources exist to facilitate the appropriate follow-through.",
              },
              {
                id: "ed-2:1-b",
                da: " Celebrate small goals or milestones along the way. It may take a while to realize the project completely, and acknowledging the steps needed to get there will keep you motivated.",
              },
              {
                id: "ed-2:1-c",
                da: " Make progress, not inspiration, your primary goal. It means you must focus on the steps necessary to mature an existing product or service instead of trying to generate new ones. Make a detailed plan of the steps necessary to translate the idea into practice. Once you have identified these steps in your plan, you can apply the same framework for future ideas.",
              },
              {
                id: "ed-2:1-d",
                da: " Be sure to monitor your work processes. Once distracted by new initiatives, it is easy to abandon the monitoring of existing projects' progress. Why compromise the hard work and resources that have been invested because of a lack of oversight?",
              },
              {
                id: "ed-2:1-e",
                da: " Find a trusted peer that can cheer you on when you are struggling. An external perspective to remind you how close you are to your goal, or simply someone to listen to your feelings can be just the life vest you need when you are least inspired.",
              },
              {
                id: "ed-2:1-f",
                da: " Have you lost sight of your vision? Occasionally, reflect on the bigger picture and what it was that excited you about the work in the first place.",
              },
              {
                id: "ed-2:1-g",
                da: " First complete the things you least like doing and get them out of the way while your motivation is highest. It will be easier to tackle the less complex tasks when you have less energy.",
              },
              {
                id: "ed-2:1-h",
                da: " If you simply cannot get excited about working on a particular assignment or task, you may need some time to recharge by focusing on something else. Taking a break from the task at hand will give you a chance to recharge. Can you ask for assistance?",
              },
              {
                id: "ed-2:1-i",
                da: " If you are not a detail-oriented person, you are likely to lose interest quickly and prefer to move on to something new. Make sure there are people on your team who are more analytical or concerned with detail and can drive that aspect of the project.",
              },
              {
                id: "ed-2:1-j",
                da: " Certainly, some aspects of everyone's jobs are less interesting than others, but if nothing holds your interest or you are chronically bored, you should consider whether your position is right for you.",
              },
              {
                id: "ed-2:2-a",
                da: " Keep things as simple as possible by narrowing your focus to one or two core drivers of the problem. Articulate what those drivers are.",
              },
              {
                id: "ed-2:2-b",
                da: " Focus on the starting point and not the finishing line. What is most important as a first course of action? List all the possibilities and choose only a few avenues on which to focus for now. There is never a perfect place from which to start. Once you have accomplished the initial steps, begin again.",
              },
              {
                id: "ed-2:2-c",
                da: " Assemble a strong team that has multiple skills and can tackle all the various angles of the project. You do not have to be an expert in every aspect.",
              },
              {
                id: "ed-2:2-d",
                da: " Do not linger on a problem too long before addressing it. The longer you leave an issue unaddressed the more overwhelming it becomes.",
              },
              {
                id: "ed-2:3-a",
                da: " Often, once you gain a better perspective or have more information, obstacles are not as difficult to overcome as they first appeared. Ask a trusted colleague or expert to provide a different perspective. Someone else might be able to see an obvious solution that you cannot just then.",
              },
              {
                id: "ed-2:3-b",
                da: " Use obstacles as opportunities to have fun while being creative. There are always multiple ways to approach an issue. Do you need to start over again or simply change your course of action? Many plans have failed not because they were not good, but because they were inflexible.",
              },
              {
                id: "ed-2:3-c",
                da: " Your biggest obstacle may be your emotions or attitude. Examine the real reasons why you are contemplating giving up and make sure the reasons are based on logic, not emotion.",
              },
              {
                id: "ed-2:3-d",
                da: " Reflect on your original purpose for embarking on this route and become motivated again. Sometimes a shot of energy is all you need to get you over the hurdle.",
              },
              {
                id: "ed-2:4-a",
                da: " Always add to your timelines to allow for contingencies. You want to start with a realistic timeframe for completion and mitigate unnecessary frustration.",
              },
              {
                id: "ed-2:4-b",
                da: " Do you have other things on your plate? There is no reason not to move on to another project if you are simply not able to focus on a specific task at the moment, but be sure to return at a later stage to address what you had left behind.",
              },
              {
                id: "ed-2:4-c",
                da: " Rather than give up altogether because things are not moving fast enough, find ways to improve the process so that it can be completed more quickly. This might involve recruiting additional resources to help.",
              },
              {
                id: "ed-2:4-d",
                da: " Does the whole task have to be done from beginning to end at once? Divide it into smaller tasks on which you can work progressively.",
              },
            ],
          },
          {
            id: "ed-3",
            icon: require("@/assets/Iconography/Attributes/07-04_Taking Initiative.svg"),
            comp: "Taking initiative",
            wdd: "Takes initiative and demonstrates a positive can-do attitude",
            progressMeasures: [
              {
                id: "ed-3-0",
                pm: "I am excited about my work",
                pmMap: "Demonstrate excitement about my work",
              },
              {
                id: "ed-3-1",
                pm: "If I see things that must be done, I am proactive and get involved",
                pmMap:
                  "See things that must be done, and proactively get involved",
              },
              {
                id: "ed-3-2",
                pm: "I do not wait to be told what work to do",
                pmMap: "Not wait to be told what work to do",
              },
              {
                id: "ed-3-3",
                pm: "I take initiative even if the decision is risky",
                pmMap: "Take initiative even if the decision is risky",
              },
            ],
            developmentActions: [
              {
                id: "ed-3:1-a",
                da: " Are you assuming you lack the necessary skills before you really know what an assignment entails? If you lack confidence in your skills, you are likely to make quick judgments not necessarily based on facts. Talk to relevant people about what is really needed. Ensure your expectations of yourself compare with those your superior has of you. If you are usually hard on yourself, you are probably overestimating what you need to know to get going.",
              },
              {
                id: "ed-3:1-b",
                da: " If your skills set is insufficient for the task at hand, take initiative by recruiting someone else to work with you. You can learn from this person and contribute your strengths at the same time. Use a suitable, knowledgeable peer as a sounding board for ideas.",
              },
              {
                id: "ed-3:1-c",
                da: " Volunteer to do assignments that will challenge and extend your abilities. List the things you are least comfortable doing. Resolve to do at least one task or assignment every month that will help you to develop a weak area.",
              },
              {
                id: "ed-3:1-d",
                da: " Formulate an individual development plan with your supervisor or coach to address areas in which you particularly lack confidence. Why wait to address a weakness when you can have an ongoing development strategy designed to improve it?",
              },
              {
                id: "ed-3:1-e",
                da: " Remind yourself of other times when you were apprehensive about tackling a challenge. What was the result? Did your level of skill derail the project?",
              },
              {
                id: "ed-3:1-f",
                da: " If you do not know where to begin, take the initiative by being resourceful. Find out who can help with particular tasks; investigate the work that was done in similar projects and the reference material available to get you up to speed. Instead of spinning your wheels anxiously, start asking the right questions.",
              },
              {
                id: "ed-3:2-a",
                da: " Weigh the likelihood of the situation or decision's complete failure, and the degree of damage should the worst-case scenario materialize. Reality tends to be less severe than perception. Talk to a trusted peer or mentor who can be a sounding board for your concerns. They can help to provide perspective. Do they think the situation is as risky as you do?",
              },
              {
                id: "ed-3:2-b",
                da: " Become comfortable making decisions without complete data. Practice trusting your intuition. In his book Blink, Malcom Gladwell champions the power of using intuition in decision making. Start with small decisions and progress to ones with bigger consequences.",
              },
              {
                id: "ed-3:2-c",
                da: " Get used to making decisions regardless of conventional wisdom or the level of support they enjoy. Taking initiative will sometimes mean paving a new way all on your own.",
              },
              {
                id: "ed-3:2-d",
                da: " Pair with someone who is more risk-tolerant and can help you to take initiative in projects beyond your comfort zone.",
              },
              {
                id: "ed-3:2-e",
                da: " Identify beforehand the risks associated with your work, business, project etcetera. Having a plan to manage risk, should it become an issue, will give you a greater sense of control.",
              },
              {
                id: "ed-3:2-f",
                da: " Do reflection after projects, on your own and with your team. Review your incorrect assumptions. What worried you the most? What was the consequence of having done those things or neglecting to do them? What could you do differently next time? Were your worries justified?",
              },
              {
                id: "ed-3:3-a",
                da: " Fake it until you believe it. Talk about the assignment or task as if you were truly excited. Identify all the positive results to be gained from taking action. Roll up your sleeves and do it. The reward for hard work is just an initiative away.",
              },
              {
                id: "ed-3:3-b",
                da: " Regular exercise helps to relieve stress, builds physical and mental stamina and raises energy levels. Include exercise as one of your tools for creating more energy in your life and work.",
              },
              {
                id: "ed-3:3-c",
                da: " Be sure to balance your life with things that bring you happiness. If you are not getting recharged outside of work, your energy will be sapped and your performance will lack luster.",
              },
              {
                id: "ed-3:3-d",
                da: " Help others to become excited even if you are not. Try not to sound bored or complain in the workplace. Encourage optimistic discussions about the future. Ask people to share their vision and hopes for their own or the organization's future. Make it a ritual part of your meetings. Ensure you are not hampering other' progress by not, for example, getting work done on which they had counted.",
              },
              {
                id: "ed-3:3-e",
                da: " Observe how others do it. Identify people who are energizing and who create excitement about work. Spend time with them and tap into their energy.",
              },
              {
                id: "ed-3:3-f",
                da: " If you were once energetic but have lost your enthusiasm, examine what has changed about your situation. Is it work or something bigger? Talk to a mentor or coach who can help you to examine the factors that have led to your frame of mind, and the changes you could make.",
              },
              {
                id: "ed-3:3-g",
                da: " Would you feel more energetic if you had different responsibilities? Explore whether your position is suitable and, if not, which one would be. Consider new assignments that will begin a new chapter in your career and help you to tap into new energy.",
              },
              {
                id: "ed-3:3-h",
                da: " If your energy level is chronically low and you find it difficult to take initiative in anything, including personal issues, consider consulting a professional counselor or seeking medical advice.",
              },
              {
                id: "ed-3:4-a",
                da: " Do not wait to be told what to do or a crisis to force an issue. Look for tasks that remain incomplete or projects that could benefit from your participation.",
              },
              {
                id: "ed-3:4-b",
                da: " Talk to your supervisor about their expectations. They may feel threatened, or perhaps they are unaware that they discourage you from taking initiative. Try to uncover the reasons instead of making assumptions. You may be unfocused and they may need you to act proactively in other areas. Give them examples of concrete issues instead of generalizations.",
              },
              {
                id: "ed-3:4-c",
                da: " Share the credit with others when you can so that no one feels threatened by you taking initiative on your own.",
              },
              {
                id: "ed-3:4-d",
                da: " If you feel completely unable to take initiative in your position, consider a reassignment where your efforts will be recognized.",
              },
              {
                id: "ed-3:5-a",
                da: " Do not assume you will not be successful. If you lack resources, talk to the relevant people about making them available. If you are convincing enough, you will get the support you need.",
              },
              {
                id: "ed-3:5-b",
                da: " If you cannot do it on your own, mobilize others to take interest and share the project with you.",
              },
              {
                id: "ed-3:5-c",
                da: " Look for inspiration from within rather than outside. Others may not be motivated to provide direction, so be the one who stands out. The issue may not be a priority for others, but you can see the impact it will have, so remain determined and resilient.",
              },
              {
                id: "ed-3:5-d",
                da: " Make a case for the benefits of pursuing the course of action you are suggesting. Your efforts may not receive the appreciation you wanted, but at least you did your best. Perhaps your plan of action will be implemented when the timing is better.",
              },
              {
                id: "ed-3:6-a",
                da: " Do not assume you cannot make certain decisions. Find out what your level of authority is and within which parameters you need to work.",
              },
              {
                id: "ed-3:6-b",
                da: " Be proactive. If you have ideas about addressing a problem, consult the relevant people and explain how you propose to do it.",
              },
              {
                id: "ed-3:6-c",
                da: " Take charge of the situation first then stop at checkpoints along the way to ensure you are moving in the right direction.",
              },
              {
                id: "ed-3:7-a",
                da: " Spend time familiarizing yourself with the types of tools on which you can rely to do your job. Most organizations have made sizeable investments in resources such as software, trade journals and reference material. Set aside some time after work or during weekends, if necessary, to peruse your reference material.",
              },
              {
                id: "ed-3:7-b",
                da: " Ask peers and colleagues what they used to accomplish similar jobs. Conversations like these expose you to resources that may be available but of which you were unaware or never thought to utilize.",
              },
              {
                id: "ed-3:7-c",
                da: " If you do not have the resources you need at your disposal, cast the net wider. Look beyond your group or division or even your company to find the necessary ones.",
              },
              {
                id: "ed-3:7-d",
                da: " Enquire about training available from your human resources department and schedule time to attend it.",
              },
              {
                id: "ed-3:7-e",
                da: " Suggest informal gatherings, at lunch perhaps, where you and colleagues can share your know-how and train others informally.",
              },
              {
                id: "ed-3:7-f",
                da: " Immediately tell colleagues if you cannot take advantage of a resource or even use it. There is no shame in not knowing, but shame on you for not asking!",
              },
            ],
          },
        ],
      },
      fc: {
        characteristic: "Flexibility",
        wdd: "Adapting behaviour to the interpersonal style and needs of others; is open to feedback and aware of strengths and weaknesses.",
        icon: require("@/assets/Iconography/Characteristics/08_Flexible Character.svg"),
        competencies: [
          {
            id: "fc-0",
            icon: require("@/assets/Iconography/Attributes/08-02_Adapting To Others.svg"),
            comp: "Adapting to others",
            wdd: "Adapts behaviour to the interpersonal style and needs of others",
            progressMeasures: [
              {
                id: "fc-0-0",
                pm: "I can identify suitable styles that work better with different people",
                pmMap:
                  "Identify suitable styles that work better with different people",
              },
              {
                id: "fc-0-1",
                pm: "I can identify the style needed to work in different situations",
                pmMap:
                  "Identify the style needed to work in different situations",
              },
              {
                id: "fc-0-2",
                pm: "I understand there is more than one way to act around people without losing my authenticity",
                pmMap:
                  "Adapt my behavior around people without losing my authenticity",
              },
              {
                id: "fc-0-3",
                pm: "I adapt to others so that they can relate to me",
                pmMap: "Adapt to others so that they can relate to me",
              },
              {
                id: "fc-0-4",
                pm: "I feel comfortable among diverse groups of people",
                pmMap: "Feel comfortable among diverse groups of people",
              },
            ],
            developmentActions: [
              {
                id: "fc-0:1-a",
                da: "Become a better observer of other people's behavior. Try to mimic the behaviors of the group or other person. For example, if the person appears withdrawn and quiet, tone down your behavior. Lower your voice and be reserved and composed instead of energetic and animated, until you get to know them better. The key is to pay attention to the other person too, not just yourself.",
              },
              {
                id: "fc-0:1-b",
                da: "Research the group with whom you will be interacting. Knowing people's backgrounds can provide much information about their styles.",
              },
              {
                id: "fc-0:1-c",
                da: "Ask others what you need to do differently to improve your relationship with them.",
              },
              {
                id: "fc-0:1-d",
                da: "Be honest about being unsure about whether your style could be offensive in any way. This applies particularly if you are working with groups from other nationalities. People will appreciate your concern.",
              },
              {
                id: "fc-0:1-e",
                da: "Does your behavior fit the organization's values or expectations? Try to define what these are and consider how suitable your behavior is.",
              },
              {
                id: "fc-0:2-a",
                da: "Investigate different interpersonal styles to recognize the types with whom you interact.",
              },
              {
                id: "fc-0:2-b",
                da: "Consider the person's background and discipline or field and how these may differ from yours. If you are interacting with accountants, for example, they may prefer to keep the conversation quite structured and may want you to share more details.",
              },
              {
                id: "fc-0:2-c",
                da: "Gauge the emotional state a person might be in: sad, irritated, nervous etcetera. It is important to respect people's mental state and accommodate it.",
              },
              {
                id: "fc-0:2-d",
                da: "Consider first how the person may be different from you and only then look for similarities. This will help you to avoid projecting on others.",
              },
              {
                id: "fc-0:2-e",
                da: "People's reactions and body language can help to guide your behavior. Look for changes in facial expression, tone of voice, posture. You can adapt accordingly.",
              },
              {
                id: "fc-0:2-f",
                da: "Some of us have a natural talent for picking up clues about others. If you think you cannot read other people, think again. The key is to really observe them â€”- how they communicate, their demeanor, expressions, body language. Clues about people and who they really are, are written all over them and you can use these clues to help you adapt to their interpersonal needs. Simply raise your level of awareness.",
              },
              {
                id: "fc-0:2-g",
                da: "Get to know people on a personal level. There is no better way to understand people than to spend time with them.",
              },
              {
                id: "fc-0:3-a",
                da: "Identify the mutual goals among you and the person or group and use that as the bridge to common ground.",
              },
              {
                id: "fc-0:3-b",
                da: "Get to know the person better to challenge your assumptions about them. Typically, meetings in social settings away from the pressures of work give you a fresh perspective of others, so try to arrange them, if possible.",
              },
              {
                id: "fc-0:3-c",
                da: "Lack of flexibility on your part might stem from bias towards a group. Consider the hidden biases you may harbor and try to challenge the assumptions on which they are based.",
              },
              {
                id: "fc-0:3-d",
                da: "Recognize the other person's interpersonal style and its strengths and contributions, even if it is different from yours. For example, you may be dealing with someone who is forward and talkative, very different from you. But these traits may add real value in, for example, the sales role with which you are uncomfortable.",
              },
              {
                id: "fc-0:4-a",
                da: "Try to put yourself in the other person's shoes.",
              },
              {
                id: "fc-0:4-b",
                da: "Consider the pros, for both of you, of adapting your behavior.",
              },
              {
                id: "fc-0:4-c",
                da: "Ask yourself whether you would like someone to do the same for you. More than likely, you would appreciate such an effort.",
              },
            ],
          },
          {
            id: "fc-1",
            icon: require("@/assets/Iconography/Attributes/08-01_Being Self-Aware.svg"),
            comp: "Being self-aware",
            wdd: "Is open to feedback and aware of strengths and weaknesses",
            progressMeasures: [
              {
                id: "fc-1-0",
                pm: "I know what my best qualities and my weaknesses are",
                pmMap: "Know what my best qualities and my weaknesses are",
              },
              {
                id: "fc-1-1",
                pm: "I regularly ask for feedback",
                pmMap: "Regularly ask for feedback",
              },
              {
                id: "fc-1-2",
                pm: "I do not become defensive when given constructive criticism",
                pmMap: "Not become defensive when given constructive criticism",
              },
              {
                id: "fc-1-3",
                pm: "I routinely question my motives, values and opinions",
                pmMap: "Routinely question my motives, values and opinions",
              },
              {
                id: "fc-1-4",
                pm: "I enjoy reading about human behavior and psychology",
                pmMap: "Enjoy reading about human behavior and psychology",
              },
            ],
            developmentActions: [
              {
                id: "fc-1:1-a",
                da: " Participate in a 360° feedback evaluation. It is the most effective way to get collective results from your peers. The 360° assessment methodology uses a forced ranking method that reduces rater bias and assesses your relative strengths and weaknesses.",
              },
              {
                id: "fc-1:1-b",
                da: " If you find yourself becoming defensive or hostile when receiving feedback, you may be tempted to give an emotionally charged response. Practice stress-management techniques such as deep breathing. Take time to let the feedback sink in and repeat it in your mind several times, each time followed by the words 'self-aware'. This allows you a moment to consciously defuse anger or hostility and helps to put things into perspective.",
              },
              {
                id: "fc-1:1-c",
                da: " Do not get caught up in trying to defend yourself. Let the person know that you will take their suggestions or feedback into consideration. If you are not too emotional, ask for concrete examples so that you can better consider what they have said.",
              },
              {
                id: "fc-1:1-d",
                da: " Be approachable. People avoid giving feedback to those who have little time for them or do not listen. You make it clear that you are open to feedback through your body language and facial expressions, and because you encourage it, of course.",
              },
              {
                id: "fc-1:1-e",
                da: " Not all feedback is 100% accurate but, if you pay attention, there is always something revealing about either yourself or the other person. You will not be able to detect these nuances if you are being defensive. Even if you disagree with the feedback, it is being given for a reason. What do you think the reason is? What can you learn about yourself and the other party?",
              },
              {
                id: "fc-1:1-f",
                da: " If more than one person is giving you the same feedback, chances are there is some truth to it. You would be wise to pay attention to it.",
              },
              {
                id: "fc-1:2-a",
                da: " Meditation describes a state of concentrated attention focused on an object of thought or awareness. It usually involves turning attention inwards to a single point of reference. It is a good technique to tap into our inner motives and emotions. Choose from the numerous meditation techniques available and add them to your daily routine.",
              },
              {
                id: "fc-1:2-b",
                da: " Single out someone in the company who is both successful and well liked. Which soft skills would you attribute to that person? Use them as a role model for your behavior.",
              },
              {
                id: "fc-1:2-c",
                da: " Consciously try to be more open with people. It may be awkward and difficult at first, but being comfortable enough to share personal information helps you to practice communicating your feelings.",
              },
              {
                id: "fc-1:2-d",
                da: " Put yourself in the other person's shoes when presented with problematic situations. How would you feel in the same position? How would you like to be treated?",
              },
              {
                id: "fc-1:3-a",
                da: " Challenge your values. Read about practices, religions or philosophies with which you are unfamiliar and see if you find more admirable values, perhaps.",
              },
              {
                id: "fc-1:3-b",
                da: " If you are reluctant to discover yourself, try to discover the world. Expose yourself to completely different people, experiences and hobbies. You will learn a great deal about yourself in the process.",
              },
              {
                id: "fc-1:3-c",
                da: " Create a self-awareness library and schedule time at least once a week for selfdevelopment in a variety of areas. There is a world of interesting reading available.",
              },
              {
                id: "fc-1:3-d",
                da: " Numerous psychological assessments are available to effectively assess people from a variety of angles. Try a different angle. Ask the human resources department for a recommendation.",
              },
              {
                id: "fc-1:3-e",
                da: " Self-analysis is the key. Always ask yourself questions: Why did you make the decision you did? Why are you really feeling a particular way? What would have been the consequences of a different choice? Do not obsess, just ask.",
              },
              {
                id: "fc-1:3-f",
                da: " Meditation is a proven, effective way to tap into inner motives and emotions. Meditation techniques include breathing and mantra exercises as well as yoga. Research the options and make meditation a part of your daily ritual.",
              },
              {
                id: "fc-1:3-g",
                da: " Share what you do know or think about yourself with others. Compare your selfassessment with their feedback and find your blind spots and hidden strengths.",
              },
              {
                id: "fc-1:4-a",
                da: " Make it a habit to stay in touch with your behavior by soliciting feedback from others when appropriate. Ask: What am I doing well? What can I improve? What do I need to change?",
              },
              {
                id: "fc-1:4-b",
                da: " Participate in a formal 360Âº evaluation process. It is a great way to gauge how people really perceive you.",
              },
              {
                id: "fc-1:4-c",
                da: " Engage a coach who can help to you interpret the results and understand the benefits of changing your behavior.",
              },
            ],
          },
        ],
      },
      im: {
        characteristic: "Imagination",
        wdd: "Creating new ideas by seeing new connections between different and sometimes unrelated concepts; being open to different and sometimes conflicting ideas or concepts and willing to change accordingly.",
        icon: require("@/assets/Iconography/Characteristics/09_Imaginative Mind.svg"),
        competencies: [
          {
            id: "im-0",
            icon: require("@/assets/Iconography/Attributes/09-01_Keeping An Open Mind.svg"),
            comp: "Keeping an open mind",
            wdd: "Is open to different and sometimes conflicting ideas or concepts and willing to change accordingly",
            progressMeasures: [
              {
                id: "im-0-0",
                pm: "I do not feel uncomfortable about new or different ideas",
                pmMap: "Not feel uncomfortable about new or different ideas",
              },
              {
                id: "im-0-1",
                pm: "I value the importance of views and beliefs that differ from mine",
                pmMap:
                  "Value the importance of views and beliefs that differ from mine",
              },
              {
                id: "im-0-2",
                pm: "I am open to new experiences",
                pmMap: "Be open to new experiences",
              },
              {
                id: "im-0-3",
                pm: "I have, previously, altered my view on a strong personal belief after exposure to a different perspective",
                pmMap:
                  "Be prepared to alter my view on a strong personal belief after exposure to a different perspective",
              },
              {
                id: "im-0-4",
                pm: "I think few situations are simply black or white",
                pmMap:
                  'Not consider situations as simply "black or white", and keep an open mind',
              },
            ],
            developmentActions: [
              {
                id: "im-0:1-a",
                da: " When you feel challenged or tested by someone, take a deep breath and acknowledge your feelings, be they defensive, angry, self-conscious or irritated. Acknowledging your emotions allows you to address your feelings, instead of lashing out at the other person.",
              },
              {
                id: "im-0:1-b",
                da: " Regardless of your feelings, remind yourself your goal is to find solutions, not to be right.",
              },
              {
                id: "im-0:1-c",
                da: " Imagine how you would feel if you wanted to share your opinions and your boss was not receptive.",
              },
              {
                id: "im-0:1-d",
                da: " Ask people what they think before you give your recommendations.",
              },
              {
                id: "im-0:1-e",
                da: " If you suspect you have established a 'yes-man' culture, ask trusted peers whether you indeed seem too authoritative.",
              },
              {
                id: "im-0:1-f",
                da: " Establish and foster a culture of open-mindedness ask others opinions as a matter of routine, both informally and in meetings; assign people to the role of devil's advocate; provide incentives to those who challenge the status quo; be consistent, supportive and patient with those who learn from you.",
              },
              {
                id: "im-0:1-g",
                da: " People will need to see evidence that you are genuinely open-minded. This means not just paying lip service to it, but actually following through on ideas generated by others.",
              },
              {
                id: "im-0:1-h",
                da: " Be generous and give credit to others good suggestions, even if they are different from yours.",
              },
              {
                id: "im-0:2-a",
                da: " Be open to others feedback, ideas and ways of thinking.",
              },
              {
                id: "im-0:2-b",
                da: " Reserve your judgment until you can fully assess the value of a proposal.",
              },
              {
                id: "im-0:2-c",
                da: " Ask exploratory questions instead of lashing out defensively. Sincerely try to understand the other person's position. Use inclusive language, for example, 'Let's see how we can improve this idea together', 'Can you tell me more?' and 'This has been my belief, so how do I justify a change?'",
              },
              {
                id: "im-0:2-d",
                da: " Do you have a reputation for being stubborn? Ask colleagues whether beliefs you may cling to are not serving the team or organization. Be sure to not become defensive when others give you the truth.",
              },
              {
                id: "im-0:2-e",
                da: " Do research about the evolution of various products and companies, from their original idea to what they have become. Which changes in belief systems or cultures enabled their advance?",
              },
              {
                id: "im-0:2-f",
                da: " Compare how your current beliefs or values differ from those you held when you were younger. You are likely to find that some have shifted, even if you did not realize it at the time.",
              },
              {
                id: "im-0:3-a",
                da: " Immerse yourself in things different. Try foods from unfamiliar cultures. Visit art galleries with exhibits you would not normally want to see - swap sculpture for photography, ceramics for abstract art and so forth. Listen to new types of music - classical instead of bluegrass, jazz instead of rap, country instead of new age. Watch movies from genres you normally ignore - documentaries, foreign films with subtitles, animation, suspense.",
              },
              {
                id: "im-0:3-b",
                da: " Commit to learning something new about a culture or lifestyle different to yours each month. Try to experience it first-hand.",
              },
              {
                id: "im-0:3-c",
                da: " Take classes at a community college, attend webinars, listen to podcasts or read articles and books about various unfamiliar topics, for example, nutrition, pop culture, art, history, swing dancing, greening the earth, scuba diving, auto mechanics, cooking, foreign languages, gardening, astronomy, first aid training and more.",
              },
              {
                id: "im-0:3-d",
                da: " Ask for assignments that allow you to work with people from different backgrounds or in completely different markets. Look for similarities between your experience and theirs. Differences exist, but there are also commonalities that bind.",
              },
              {
                id: "im-0:4-a",
                da: " Take advantage of the diverse backgrounds and viewpoints of others when planning or improving processes or solving a problem. Consider feedback from various sources, for example, line personnel, both internal and external customers etcetera.",
              },
              {
                id: "im-0:4-b",
                da: " Establish a walk in my shoes initiative during which you and other leaders in your workgroup perform each other's duties for one day or several hours, at least. Choose an unfamiliar job, or one that will provide a better understanding of others needs. Choose the job of someone who reports to you, for example. Share the lessons learnt and modify your perceptions and processes accordingly.",
              },
              {
                id: "im-0:4-c",
                da: " Do not begin a conversation with the goal of proving your point. Instead, listen for information that could improve or perhaps even trounce your ideas.",
              },
              { id: "im-0:4-d", da: " Listen first then speak." },
              {
                id: "im-0:4-e",
                da: " Use specialized groups or so-called 'tiger teams' to challenge your ideas and recommend change.",
              },
            ],
          },
          {
            id: "im-1",
            icon: require("@/assets/Iconography/Attributes/09-02_Being Creative.svg"),
            comp: "Being creative",
            wdd: "Creates many new ideas by seeing new connections between different and sometimes unrelated concepts",
            progressMeasures: [
              {
                id: "im-1-0",
                pm: "I enjoy brainstorming and have many ideas to share with others",
                pmMap:
                  "Participate in brainstorming and have many ideas to share with others",
              },
              {
                id: "im-1-1",
                pm: "I like thinking about novel ways of doing things",
                pmMap: "Consider novel ways of doing things",
              },
              {
                id: "im-1-2",
                pm: "I routinely entertain “what if” scenarios in my mind",
                pmMap:
                  "Routinely entertain “what if” scenarios and discuss them with others",
              },
              {
                id: "im-1-3",
                pm: "I like to speculate and reflect",
                pmMap: "Speculate and reflect on myself",
              },
              {
                id: "im-1-4",
                pm: "People tend to approach me for new ideas",
                pmMap: "Encourage people to approach me for new ideas",
              },
            ],
            developmentActions: [
              {
                id: "im-1:1-a",
                da: " If you get an impulse to act, do it without too much thought or judgment. Try to act spontaneously at least once every week. Forget about whether it is practical or not.",
              },
              {
                id: "im-1:1-b",
                da: " Spark your creativity by routinely asking yourself 'what if' questions.",
              },
              {
                id: "im-1:1-c",
                da: " Challenge your practical nature by contemplating simple scenarios involving your personal life: 'What if I took a vacation next week to that place I have always wanted to go?' Notice the kind of negative thoughts or objections that instantly appear. Which objections are impossible to overcome? Do the same when thinking about solutions at work. An idea may seem impractical at first, but look more closely at the validity of your objections to it.",
              },
              {
                id: "im-1:1-d",
                da: " Collect new ideas; ask others what their approach would be.",
              },
              {
                id: "im-1:1-e",
                da: " Use an incremental approach to creativity. Not everything has to be done radically different - perhaps you can concentrate on one or two areas first.",
              },
              {
                id: "im-1:1-f",
                da: " Ensure there are creative people in your team.",
              },
              {
                id: "im-1:1-g",
                da: " Become involved in hobbies that encourage the use of imagery and the creative side of your brain, such as art classes or photography.",
              },
              { id: "im-1:1-h", da: " Spend more time with creative people." },
              {
                id: "im-1:2-a",
                da: " Allow yourself time to reconsider an idea that has not been realized in the past. If you are impatient, you do not give creative, novel ideas time to form.",
              },
              {
                id: "im-1:2-b",
                da: " Make a pact with yourself to not take a decision until you have entertained at least three different approaches.",
              },
              {
                id: "im-1:2-c",
                da: " Choose, on purpose, to use a different, unfamiliar technique or methodology every once in a while.",
              },
              {
                id: "im-1:2-d",
                da: " Partner with someone who is creative and can encourage you to think outside the box.",
              },
              {
                id: "im-1:2-e",
                da: " Let others give their ideas before you offer yours.",
              },
              {
                id: "im-1:2-f",
                da: " Opt for quantity instead of quality. The more ideas generated the more likely something innovative is to emerge. You want to collect as many ideas as possible.",
              },
              {
                id: "im-1:2-g",
                da: " Keep ahead of the pack. Seek training and attend conferences that showcase the latest technology or trends in your industry.",
              },
              {
                id: "im-1:2-h",
                da: " Be sure to balance your team with creative, innovative thinkers.",
              },
              {
                id: "im-1:3-a",
                da: " Create a list that identifies possible improvements in the item or issue at hand. It will make you more receptive to the need for change.",
              },
              {
                id: "im-1:3-b",
                da: " From your perspective things may be working fine, but ask other people - even outside your team - what they perceive as problematic and why something needs to be redesigned.",
              },
              {
                id: "im-1:3-c",
                da: " Try to suspend judgment, not only of others' ideas but also your own. Refrain from using statements such as 'It's a good idea but ...' or 'I don't think it is realistic'¦' Instead, withhold commentary until you have digested the idea. It will give you time to properly consider the possibilities and implications before making a judgment.",
              },
              {
                id: "im-1:3-d",
                da: " Let someone else practice pitching their idea to you. The stronger their argument the more likely you are to be receptive to it. This will benefit both of you. Remember to remain open-minded.",
              },
              {
                id: "im-1:4-a",
                da: " Find alternative ways to communicate your ideas if a group setting prohibits your creativity. Discuss your ideas individually with your mentor or team leader instead. Sharing your thoughts is more productive than keeping them to yourself.",
              },
              {
                id: "im-1:4-b",
                da: " Try to become comfortable selling or promoting your ideas. Practice with a peer or someone with whom you feel comfortable. Note their objections. Each time you talk to another person, your pitch will become stronger. You just have to convince the right person who can champion your ideas.",
              },
              {
                id: "im-1:4-c",
                da: " Grow a habit to float ideas by people with whom you feel comfortable. Do not discount ideas before you have done so. You may not think they are worthwhile, but let others be your sounding board.",
              },
              {
                id: "im-1:4-d",
                da: " Translate your creativity into the language of business. Put together a business scenario that details the idea as thoroughly as possible. Define the problem, what went wrong previously, your solution, the return on investment etcetera. Your ideas are more likely to be credible if they are well organized and presented in a way that clearly demonstrates their benefit.",
              },
              {
                id: "im-1:4-e",
                da: " Even if it is not encouraged by other leaders, promote and reward creativity in your team.",
              },
            ],
          },
        ],
      },
      cl: {
        characteristic: "Learning Continuously",
        wdd: "Continuously develop new skills and enhance existing capabilities; having a good general knowledge and making an effort to stay up to date with current affairs; have the functional and technical knowledge with skills to get the job done.",
        icon: require("@/assets/Iconography/Characteristics/05_Constant Learner.svg"),
        competencies: [
          {
            id: "cl-0",
            icon: require("@/assets/Iconography/Attributes/05-03_Being Knowledgeable.svg"),
            comp: "Being knowledgeable",
            wdd: "Has a good general knowledge and makes an effort to stay up to date with current affairs",
            progressMeasures: [
              {
                id: "cl-0-0",
                pm: "I regularly read periodicals and literature about my industry",
                pmMap:
                  "Regularly read periodicals and literature about my industry",
              },
              {
                id: "cl-0-1",
                pm: "I ensure that I attend events such as conferences and network to stay in touch with new ideas",
                pmMap:
                  "Attend events such as conferences and network to stay in touch with new ideas",
              },
              {
                id: "cl-0-2",
                pm: "I actively seek out and collect information about what is going on in my field",
                pmMap:
                  "Actively seek out and collect information about what is going on in my field",
              },
              {
                id: "cl-0-3",
                pm: "I can speak comfortably about several areas related to my industry",
                pmMap:
                  "Speak comfortably about several areas related to my industry",
              },
              {
                id: "cl-0-4",
                pm: "I like to stay up to date about current and future trends in my industry",
                pmMap:
                  "Stay up to date about current and future trends in my industry",
              },
            ],
            developmentActions: [
              {
                id: "cl-0:1-a",
                da: " Be proactive and show interest in assignments that could expose you to areas of the business other than yours.",
              },
              {
                id: "cl-0:1-b",
                da: " Register for after-hours or weekend courses that will increase your knowledge about different aspects of business. Ensure you are exposed to information pertaining to customer service, the financial side of business as well as marketing and sales.",
              },
              {
                id: "cl-0:1-c",
                da: " Participate in initiatives beyond your regular scope, such as total quality management (TQM",
              },
              {
                id: "cl-0:1-d",
                da: " Read business case studies and learn what worked or failed in different companies. You can find this information in the library and on the internet.",
              },
              {
                id: "cl-0:1-e",
                da: " Read your company's annual report and ensure you can interpret it. Which trends are affecting your company's growth? Do you understand the financials? Ask a financial advisor to point out the important factors.",
              },
              {
                id: "cl-0:1-f",
                da: " Get a feel for your company's strategic plan. Discuss with your boss the reasons for the particular direction your company has chosen. What drives the business? How are the priorities determined?",
              },
              {
                id: "cl-0:2-a",
                da: " Know your competitors: their products, strengths and weaknesses, market share, how they reach their customers.",
              },
              {
                id: "cl-0:2-b",
                da: " Consider your customer base carefully and thoroughly. Understand exactly who your customers are: their demographics, needs, patterns and preferences, as well as how your company reaches them and the trends which may affect them in the future.",
              },
              {
                id: "cl-0:2-c",
                da: " Compare your company's financial report to those of others in the same market.",
              },
              {
                id: "cl-0:2-d",
                da: " Think about strategic partnerships that could let you take advantage of trends with less risk or investment on your part, or strengthen your business in an area in which your competitor enjoys a bigger market share.",
              },
              {
                id: "cl-0:3-a",
                da: " Identify one or two relevant topics each month and become knowledgeable enough about them to converse intelligently. Try to understand the causes and consequences of an issue.",
              },
              {
                id: "cl-0:3-b",
                da: " Stay informed. Read trade magazines and business books. Ask your peers and boss to recommend books or websites to read.",
              },
              {
                id: "cl-0:3-c",
                da: " The media provides numerous ways of getting information. Watch or listen to the many business channels and programs available on television or radio. Listen to business news on your way to work and so take advantage of your commute. Subscribe to wellrespected business newspapers and magazines such as the Wall Street Journal, Fortune 500 and the Harvard Business Review.",
              },
              {
                id: "cl-0:3-d",
                da: " Regularly have lunch with people in the company who are experts in their field, and ask them questions.",
              },
              {
                id: "cl-0:3-e",
                da: " Meet people and get to know what they do. You will be surprised how much information you can gain from a casual conversation about issues and trends that have an impact on others' line of work.",
              },
            ],
          },
          {
            id: "cl-1",
            icon: require("@/assets/Iconography/Attributes/05-02_Being Technically Competent.svg"),
            comp: "Being technically competent",
            wdd: "Has the functional and technical knowledge and skills to get the job done",
            progressMeasures: [
              {
                id: "cl-1-0",
                pm: "I have the necessary technical skills to do my job",
                pmMap: "Have the necessary technical skills to do my job",
              },
              {
                id: "cl-1-1",
                pm: "I upgrade my skills if and when necessary",
                pmMap: "Upgrade my skills if and when necessary",
              },
              {
                id: "cl-1-2",
                pm: "I routinely utilize relevant training and coaching opportunities",
                pmMap:
                  "Routinely utilize relevant training and coaching opportunities",
              },
              {
                id: "cl-1-3",
                pm: "I read widely about topics related to my work to increase my knowledge",
                pmMap:
                  "Read widely about topics related to my work to increase my knowledge",
              },
              {
                id: "cl-1-4",
                pm: "I actively find people who know more than I do to learn from",
                pmMap:
                  "Actively find people who know more than I do to learn from",
              },
            ],
            developmentActions: [
              {
                id: "cl-1:1-a",
                da: " Decide in which field you would like to become a technical expert. Make your choice based on market demand for specific skills, current or future job requirements, your personal strengths and weaknesses and so forth.",
              },
              {
                id: "cl-1:1-b",
                da: " Become educated, be it formally or informally. If you can afford the time or money to go to college, do so.",
              },
              {
                id: "cl-1:1-c",
                da: " Undertake as much training as you can. It will improve your CV as well as your skills, knowledge and expertise. Pay attention to online classes, distance learning and other training opportunities available through your organization or elsewhere.",
              },
              {
                id: "cl-1:1-d",
                da: " One of the most affordable ways to improve your technical skills is by reading books. Visit book sites such as www.amazon.com, search for a book on the topic you wish to learn and check the reviews and ratings.",
              },
              {
                id: "cl-1:1-e",
                da: " Read online tutorials. They are accessible, up to date and free. They usually offer additional references, user comments and interactive demonstrations.",
              },
              {
                id: "cl-1:1-f",
                da: " Subscribe to printed or online technical magazines.",
              },
              {
                id: "cl-1:2-a",
                da: " Identify training and courses available through your organization that can help you to gain knowledge in specific areas.",
              },
              {
                id: "cl-1:2-b",
                da: " Ask your supervisor and colleagues to recommend literature to help you get up to speed.",
              },
              {
                id: "cl-1:2-c",
                da: " Find a coach or mentor experienced in your field of specialization and follow their instructions. Being mentored or coached is critical to becoming a technical expert, because there are numerous nuances and details specific to different careers that you cannot learn in a classroom.",
              },
              {
                id: "cl-1:2-d",
                da: " Spend time in the company of technical gurus. If you observe and engage with them, some of their knowledge is bound to rub off on you.",
              },
              {
                id: "cl-1:2-e",
                da: " Tackle your assignments - in the end, hands-on training will give you expertise that textbooks cannot teach you.",
              },
              {
                id: "cl-1:3-a",
                da: " Discuss your career ambitions and development options with your supervisor, and show your willingness to learn new skills to maximize your performance.",
              },
              {
                id: "cl-1:3-b",
                da: " Identify the functional or technical knowledge you need to manage others. Prioritize to gain better knowledge in these areas.",
              },
              {
                id: "cl-1:3-c",
                da: " Exploit your experiences to give you technical learning opportunities. Always seek assignments that could develop some of the technical skills you need.",
              },
              {
                id: "cl-1:3-d",
                da: " If you enjoy learning in groups, look for college extension courses and other classroom, workshop or lecture offerings in your area. The opportunity to interact with people from varied backgrounds is a key advantage of classroom learning.",
              },
              {
                id: "cl-1:4-a",
                da: " Identify the operational and technical knowledge you need to gain to conduct your business properly. Prioritize to gain knowledge in the areas that will have the greatest impact on your ability to perform business now.",
              },
              {
                id: "cl-1:4-b",
                da: " With the help of a coach or manager, formulate a development plan with specific actions aimed at increasing your functional knowledge and requisite experience.",
              },
              {
                id: "cl-1:4-c",
                da: " Improve your business acumen by subscribing to relevant publications in your field. Use them to stay abreast of trends and increase your general knowledge.",
              },
              {
                id: "cl-1:4-d",
                da: " Exploit your social nature - attend conferences and association meetings to provide new insights and perspectives.",
              },
              {
                id: "cl-1:4-e",
                da: " Ask peers to share literature or articles they come across which they find insightful.",
              },
              {
                id: "cl-1:4-f",
                da: " Consider your motivation, in other words, how driven you are to grow in challenging areas and achieve goals.",
              },
              {
                id: "cl-1:5-a",
                da: " Use blogs, newsletters, books, e-books, magazines, articles, whatever resources to present yourself to the world.",
              },
              {
                id: "cl-1:5-b",
                da: " Register as a speaker or presenter at conferences or association meetings.",
              },
              {
                id: "cl-1:5-c",
                da: " If your schedule permits, consider a part-time teaching assignment at a local college or university.",
              },
              {
                id: "cl-1:5-d",
                da: " Volunteer to mentor or train others in your organization to establish yourself as an expert internally.",
              },
            ],
          },
          {
            id: "cl-2",
            icon: require("@/assets/Iconography/Attributes/05-01_Developing myself.svg"),
            comp: "Developing myself",
            wdd: "Continuously develops new skills and enhances existing capabilities",
            progressMeasures: [
              {
                id: "cl-2-0",
                pm: "I am currently working on developing one skill or competency",
                pmMap:
                  "Working on developing one skill or competency currently",
              },
              {
                id: "cl-2-1",
                pm: "I volunteer for assignments that I know will challenge me",
                pmMap:
                  "Volunteer for assignments that I know will challenge me",
              },
              {
                id: "cl-2-2",
                pm: "I am keenly aware of my strengths and weaknesses",
                pmMap: "Accurately understand my strengths and weaknesses",
              },
              {
                id: "cl-2-3",
                pm: "I have a personal development plan which I follow",
                pmMap: "Following a personal development plan",
              },
              {
                id: "cl-2-4",
                pm: "I am eager for opportunities to learn and develop",
                pmMap: "Appear eager for opportunities to learn and develop",
              },
            ],
            developmentActions: [
              {
                id: "cl-2:1-a",
                da: " Reprioritize your self-development. If you consider it an item that you will get to later when you have time, it will not get done. Enter into a personal contract with yourself to act on self-development items weekly.",
              },
              {
                id: "cl-2:1-b",
                da: " Consider ways to improve your time management and organize yourself better to make room for self-development. Try to list all the activities that tend to waste your time, both at work and in your private life. Which of these can be replaced with selfdevelopment activities?",
              },
              {
                id: "cl-2:1-c",
                da: " Add self-development endeavors to your everyday schedule. For example, carry a trade magazine or newspaper with you to read while you are queuing or at lunch. Get CD books to listen to during your commute, or invite an expert to dinner and discuss issues of interest.",
              },
              {
                id: "cl-2:1-d",
                da: " It is difficult to set aside large chunks of time for self-development, so commit to short periods instead. Just half an hour a day, every weekday, gives you two and a half hours to pursue your development goal.",
              },
              {
                id: "cl-2:1-e",
                da: " We tend to make time for the things we consider fun or interesting. Self-development can be fun! For example, if you need to read more, go do it somewhere you enjoy, such as a park or coffee shop. If you have to improve your network, invite people you must get to know better to a restaurant you have always wanted to try. Sign up for a course with a friend or peer with whom you do not get to spend enough time.",
              },
              {
                id: "cl-2:2-a",
                da: " The more you know your strengths and weaknesses, the more targeted your development focus will be. Investigate the assessment methodologies available, such as a 360Â° evaluation that could provide objective feedback from colleagues who know you well. Utilize interest and career tests or computer programs that analyze skills and interests. Get help from a coach or your human resources department to administer the tests and aid their interpretation.",
              },
              {
                id: "cl-2:2-b",
                da: " Ensure you have a development plan for your current position. Identify the development items that would have the greatest impact on improvement in your skills.",
              },
              {
                id: "cl-2:2-c",
                da: " Be sure to consider multiple development angles and not just technical skills. For example, how well does your leadership style fit in with your team? What must you do to be better aligned with the company strategy? Does your relationship with your boss need improvement? Are you prepared for the cultural differences and demands of an imminent international assignment?",
              },
              {
                id: "cl-2:2-d",
                da: " Ensure that your development supports your long-term goals. Write down a personal mission or vision statement which helps to define where you want to take your career in the future. It will help you to focus on the right development choices.",
              },
              {
                id: "cl-2:2-e",
                da: " Read professional journals and trade magazines to remain up to date on the latest developments in your field.",
              },
              {
                id: "cl-2:2-f",
                da: " Find a mentor who can give you support, advice and assistance in directing your career.",
              },
              {
                id: "cl-2:2-g",
                da: " Let a coach help you with an individual development plan that outlines your learning needs and goals. A plan will help you to stick to your goals. Ensure that the plan has specific actions you must complete and measurable goals. Discuss a plan for follow-up - who will track your progress and how? Most development plans fail because they lacked follow-up.",
              },
              {
                id: "cl-2:3-a",
                da: " Concentrate on the things you do less well. We all have strengths and weaknesses, so aim for experience and assignments in areas in which you are less proficient than others.",
              },
              {
                id: "cl-2:3-b",
                da: " Go from good to great. A top athlete does not stop trying to improve, even if they have broken a world record. If you are already very good at something, find an expert skills coach to help you use your strengths to achieve excellence.",
              },
              {
                id: "cl-2:3-c",
                da: " The more you know about yourself the better. Investigate the assessment methodologies available, such as a 360Â° evaluation that could provide objective feedback from colleagues who know you well. Get help from a coach or your human resources department to help interpret the assessment.",
              },
              {
                id: "cl-2:3-d",
                da: " Watch for overuses, blind spots, knock-out factors and so-called derailers. These are the four horsemen of self-awareness, yet people are typically ignorant about them. Identify whether you match any of these profiles.",
              },
              {
                id: "cl-2:3-e",
                da: " Become involved in professional organizations where you can learn from others and network with peers. It is always an eye opener to see how much there is to learn when you expose yourself to other experts' knowledge.",
              },
              {
                id: "cl-2:4-a",
                da: " Partner with someone who is strong in the area you need to develop for the duration of a project or task. You can learn from that person and have great support along the way, instead of forging ahead on your own.",
              },
              {
                id: "cl-2:4-b",
                da: " Think of learning something new as a form of play or exploration. This mindset promotes creativity and enthusiasm.",
              },
              {
                id: "cl-2:4-c",
                da: " Spend more time with people who are naturally curious, who try new things with abandon and without fears of looking silly or foolish. What is different about their approach to situations?",
              },
              {
                id: "cl-2:4-d",
                da: " Offer to help someone with tasks in which you are skilled or are comfortable doing. Do it in exchange for their support with tasks you have not mastered.",
              },
              {
                id: "cl-2:4-e",
                da: " Draw from your experience of learning a hobby, sport or doing a project at home. How satisfied did you feel when you were able to complete it? Were there times when you thought you were not up to the task? Why did you persevere?",
              },
              {
                id: "cl-2:4-f",
                da: " Engage a coach for added support and encouragement, especially when you are being too hard on yourself.",
              },
              {
                id: "cl-2:4-g",
                da: " There is no shame in letting people know you are actively trying to improve, but you do not have to publicize everything. If you are uncomfortable with people knowing, continue to work privately on certain items with the approval of your leader and the assistance of a coach.",
              },
              {
                id: "cl-2:5-a",
                da: " Read trade journals unrelated to your specific discipline.",
              },
              {
                id: "cl-2:5-b",
                da: " Gain a general understanding of how other divisions in your company operate. Go to lunch with people from other departments and ask questions about their work.",
              },
              {
                id: "cl-2:5-c",
                da: " Develop a network of contacts in a wide variety of disciplines.",
              },
              {
                id: "cl-2:5-d",
                da: " Familiarize yourself with tools that can help you to gather information. Tools such as news aggregators, Topix, Google News etcetera can all help to keep your finger on the pulse of different subjects.",
              },
              {
                id: "cl-2:5-e",
                da: " Take note and do further research when someone makes reference to a topic or book with which you are unfamiliar.",
              },
              {
                id: "cl-2:5-f",
                da: " Take continuing education courses in general business areas. Your company may sponsor some of them.",
              },
              {
                id: "cl-2:5-g",
                da: " Get involved in as many cross-departmental meetings as possible or assignments that involve multiple disciplines.",
              },
              {
                id: "cl-2:5-h",
                da: " Listen to business webcasts available through work.",
              },
              {
                id: "cl-2:5-i",
                da: " Find a mentor with extensive business acumen. Arrange to meet periodically to discuss various subjects.",
              },
              {
                id: "cl-2:6-a",
                da: " Have an open discussion with your team lead and peers about what they think your weaknesses are. Be sure to include some of these items as part of your development plan.",
              },
              {
                id: "cl-2:6-b",
                da: " Be aware of the competencies, technical skills and experiences critical to your current position and any future promotion.",
              },
              {
                id: "cl-2:6-c",
                da: " Investigate the opportunities available in the organization to undertake rotational assignments.",
              },
              {
                id: "cl-2:6-d",
                da: " Sign up for courses available through your company that will broaden your skills set.",
              },
              {
                id: "cl-2:6-e",
                da: " Ask to be included in interdisciplinary meetings to increase your general knowledge about all business units.",
              },
              {
                id: "cl-2:6-f",
                da: " Be aware of what is happening outside your field. Read news magazines or articles from other business fields at least once a week.",
              },
              {
                id: "cl-2:6-g",
                da: " Test and extend your strengths. For example, if you have been working in accounting, grab opportunities to work in financial forecasting. Both draw on your analytical skills and require working with numbers, but they involve different types of application. If you are skilled at technical writing, try penning a feature article for a magazine. You will draw on your natural ability in written communication but will broaden your skills.",
              },
              {
                id: "cl-2:6-h",
                da: " Try to begin a new hobby completely unrelated to your work or your perceived talents. You may be surprised by how much you enjoy it and it will make it easier to pursue activities that do not necessarily draw on your strengths.",
              },
            ],
          },
        ],
      },
      wrt: {
        characteristic: "Risk Taking",
        wdd: "Comfortable working in a changing and uncertain environment; enjoy trying new things and is willing to experiment, taking calculated risks.",
        icon: require("@/assets/Iconography/Characteristics/18_Willing Risk Taker.svg"),
        competencies: [
          {
            id: "wrt-0",
            icon: require("@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg"),
            comp: "Being comfortable with uncertainty",
            wdd: "Is comfortable working in a changing and uncertain environment with uncertainty",
            progressMeasures: [
              {
                id: "wrt-0-0",
                pm: "I am optimistic that things will work out, even if the future is uncertain",
                pmMap:
                  "Be optimistic that things will work out, even if the future is uncertain",
              },
              {
                id: "wrt-0-1",
                pm: "I am prepared to test new approaches",
                pmMap: "Be prepared to test new approaches",
              },
              {
                id: "wrt-0-2",
                pm: "I can make decisions and take action without knowing all the details",
                pmMap:
                  "Make decisions and take action without knowing all the details",
              },
              {
                id: "wrt-0-3",
                pm: "I can change my course of action quickly",
                pmMap: "Change my course of action quickly",
              },
              {
                id: "wrt-0-4",
                pm: "I thrive in an unstructured environment",
                pmMap: "Thrive in an unstructured environment",
              },
            ],
            developmentActions: [
              {
                id: "wrt-0:1-a",
                da: " Tell your boss and colleagues that you prefer a framework in which to operate, or when a greater amount of guidance is needed. They cannot read your mind and may be operating on the basis of their own needs.",
              },
              {
                id: "wrt-0:1-b",
                da: " You cannot bring structure to everything, so focus on the areas where you can. Make a list of the things that are structured in your workday and you will see that not everything is beyond your control.",
              },
              {
                id: "wrt-0:1-c",
                da: " Have systems in place that allow you to quickly make the transition from one task to another without forgetting where you left off. Even a simple list can help you.",
              },
              {
                id: "wrt-0:1-d",
                da: " Ensure your approach to people and issues is adaptable. A 'one size fits all' approach does not work in a multifaceted work environment, and it will be exhausting to try to get things done your way all the time.",
              },
              {
                id: "wrt-0:1-e",
                da: " Accept that you will have to stop and go continuously. Shifting gears does not mean you will not get things done. It simply means your attention will be shared among concurrent demands. You can always get back to what you had started earlier.",
              },
              {
                id: "wrt-0:1-f",
                da: " Do not try to deal with each and every aspect of an issue or achieve complete solutions before moving on to something else. Most things cannot be resolved at once. It is acceptable to tackle things partially and move on, then return and resolve them properly. Reward yourself for taking the next logical step and not just for completing the task as a whole.",
              },
              {
                id: "wrt-0:1-g",
                da: " Practice effective transition by doing multiple activities for a limited period of time, all in one day. Select activities that require a change of skills or frame of mind and do not try to complete any one assignment at once. For example, reply to a few e-mails, then provide assistance to someone you supervise, followed by tackling a section of a proposal or document. Then stop and make a few pending calls, and so forth. Keep practicing this and observe the different hats you must wear to move forward. Take pride in the number of activities in which you were able to engage instead of how many you completed from beginning to end. Notice how much quicker you are able to address multiple tasks.",
              },
              {
                id: "wrt-0:1-h",
                da: " Observe a colleague who handles ambiguity successfully. What is different about your attitude and approach?",
              },
              {
                id: "wrt-0:1-i",
                da: " Take relaxation breaks throughout the day, particularly when you switch between projects or major tasks, by doing a few moments of deep-breathing exercises or getting away from your desk for a while.",
              },
              {
                id: "wrt-0:1-j",
                da: " Ensure you reflect on how things might have been easier in a particular situation, had you been able to switch gears more quickly and effectively.",
              },
              {
                id: "wrt-0:1-k",
                da: " If you are chronically stressed and unhappy about your environment, investigate other opportunities to work in a more structured setting within the organization.",
              },
              {
                id: "wrt-0:2-a",
                da: " Try to separate critical data from less important information. What is the minimum detail needed to understand enough to proceed with the project?",
              },
              {
                id: "wrt-0:2-b",
                da: " Although you may find it difficult, focus on improving the speed with which you get through a project rather than how well it is done.",
              },
              {
                id: "wrt-0:2-c",
                da: " Work on projects or tasks up to a point and then, before it is 100% complete, pass it on to someone else to review or take over.",
              },
              {
                id: "wrt-0:2-d",
                da: " Before tackling any task or assignment, rate how important it is to get it done perfectly. Never give something a score of 10 because nothing can be done perfectly. Get feedback if you are unsure, particularly from your manager.",
              },
              {
                id: "wrt-0:2-e",
                da: " Set a time limit for collecting information and gathering data before you actually tackle a task.",
              },
              {
                id: "wrt-0:2-f",
                da: " Reflect on past projects in which you were involved. Which details were irrelevant in the end?",
              },
              {
                id: "wrt-0:2-g",
                da: " Compare your expectations with those of your team and manager. Ensure you understand exactly how much effort or time they expect you to invest in the project.",
              },
              {
                id: "wrt-0:2-h",
                da: " Trust your decisions. You will have to make many of them throughout your career.",
              },
              {
                id: "wrt-0:3-a",
                da: " Consider whether conditions and assumptions in the current situation are the same as previously. What has changed? Do the differences warrant a new way to proceed which you should examine?",
              },
              {
                id: "wrt-0:3-b",
                da: " First consider how things could be done differently, then add the standard way of doing them to the mix. Brainstorm ideas before reaching a conclusion.",
              },
              {
                id: "wrt-0:3-c",
                da: " Ensure there are mavericks or forward-thinking people on your team. Their input will counteract yours and add balance.",
              },
              {
                id: "wrt-0:3-d",
                da: " Remain open to all options. It is easy to become defensive and territorial when you are trying to defend the standard way of doing things.",
              },
              {
                id: "wrt-0:3-e",
                da: " Remember both the good and bad about your standard procedure. List its pros and cons to create a realistic picture of how well it has worked.",
              },
              {
                id: "wrt-0:3-f",
                da: " Experiment for the sake of it. You can practice getting more comfortable with new approaches outside the work environment. Try one new thing a week, from ordering an unknown item from the menu to taking a different route home. Satisfy your curiosity about a place and take a trip there. Exploring should be fun and part of your approach to both your life and work.",
              },
              {
                id: "wrt-0:4-a",
                da: " Admit it and deal with it. You may have to improve some of your skills, but worrying or comparing yourself with others will not produce any results or change the situation. Engage a coach to set up an individual development plan to help you work on areas that need attention.",
              },
              {
                id: "wrt-0:4-b",
                da: " Instead of focusing on everything you do not know, concentrate on what you really have to know to complete the next task.",
              },
              {
                id: "wrt-0:4-c",
                da: " Remind yourself of other situations in which you were a beginner and felt overwhelmed. How did you get through those experiences? Think of what you have learned to get where you are now.",
              },
              {
                id: "wrt-0:4-d",
                da: " Consult a peer or mentor skilled in the area you need to develop and get their support when necessary.",
              },
              {
                id: "wrt-0:4-e",
                da: " Ensure your expectations of yourself compare to those of your boss or supervisor. We tend to be hardest on ourselves and, likely, you need to know less than you think.",
              },
              {
                id: "wrt-0:4-f",
                da: " Be patient with yourself and your mistakes. Success comes with experience, which is built on lessons from mistakes.",
              },
              {
                id: "wrt-0:4-g",
                da: " Be resourceful when information is unclear or you do not know how to proceed. Find out who can help you with particular tasks, examine work that was done in similar projects and secure the reference materials and resources available to get you up to speed. Be an investigator and start asking questions.",
              },
              {
                id: "wrt-0:5-a",
                da: " Before speaking, always consider whether your comments could demoralize others. If they could, refrain from sharing your opinions or try to deliver the news in a more positive manner.",
              },
              {
                id: "wrt-0:5-b",
                da: " Examine which components of work you enjoyed before your interest diminished, and what has changed. Are the changes self-imposed? Would talking to relevant people about changing the situation help to revive your interest? Would you regain your enthusiasm if you were involved in other assignments? Try to find options that will recharge your work energy.",
              },
              {
                id: "wrt-0:5-c",
                da: " Examine your definition of your value to the organization. If you feel change in the organization will diminish your value, try to reinvent yourself. Identify the skills you need to enhance to remain competitive. Consider new assignments that could mark a new chapter in your career.",
              },
              {
                id: "wrt-0:5-d",
                da: " Ensure you do not communicate your negative attitude by withholding support, encouragement or information.",
              },
              {
                id: "wrt-0:5-e",
                da: " Encourage optimistic discussions about the future. Let people share their vision and hopes for the organization's future, and refrain from pointing out the downside of what they have shared. Do this in every meeting.",
              },
              {
                id: "wrt-0:5-f",
                da: " Forget about the old days and how much better they were. Reflection is productive, but only as a means to analyze how to improve in future.",
              },
              {
                id: "wrt-0:5-g",
                da: " Ask a mentor or coach to help you examine what has led you to your frame of mind, and which changes can be made before you become the last person with whom people want to work. Or worse, before you become obsolete.",
              },
            ],
          },
          {
            id: "wrt-1",
            icon: require("@/assets/Iconography/Attributes/18-01_Being Experimental.svg"),
            comp: "Being experimental",
            wdd: "Enjoys trying new things and is willing to experiment and take calculated risks",
            progressMeasures: [
              {
                id: "wrt-1-0",
                pm: "I am not afraid to try new things to gain valuable experiences",
                pmMap:
                  "Not be afraid to try new things to gain valuable experiences",
              },
              {
                id: "wrt-1-1",
                pm: "I am open to exploring new ways of doing things",
                pmMap: "Be open to exploring new ways of doing things",
              },
              {
                id: "wrt-1-2",
                pm: "I often test new ideas, products or services to find the best solutions",
                pmMap:
                  "Test new ideas, products or services to find the best solutions",
              },
              {
                id: "wrt-1-3",
                pm: "I am a proponent of innovation and I like to invent creative ideas to improve processes and work in general",
                pmMap:
                  "Promote innovation and contribute to creative ideas to improve processes and work in general",
              },
              {
                id: "wrt-1-4",
                pm: "I think time spent experimenting is time well spent",
                pmMap: "Spend time experimenting with new ideas",
              },
            ],
            developmentActions: [
              {
                id: "wrt-1:1-a",
                da: " Start with low-impact, least-consequence experimentation and see how even small risks can pay off.",
              },
              {
                id: "wrt-1:1-b",
                da: " Document the benefits of doing things differently. What is currently not working and what does it cost the organization? Use this as motivation to experiment.",
              },
              {
                id: "wrt-1:1-c",
                da: " Find a mentor who is used to taking risks. Ask them to help you evaluate the consequences and potential reward. Ask them how they deal with the occasional failure, how much they have gained in the long run from taking chances, and what their experience have taught them.",
              },
              {
                id: "wrt-1:1-d",
                da: " Reflect carefully on what went wrong the last time you experimented. The idea may have been worthy and other factors could have played a bigger role in your failure. Did you have the right team? Were corporate politics handled well? Were sufficient resources available? Was the market ready? Understanding what worked well versus what did not will help you to reduce your risk when experimenting the next time.",
              },
              {
                id: "wrt-1:1-e",
                da: " Treat failures and mistakes as opportunities to learn. Do not be discouraged if your time and resource investment does not become successful on the first try. Be resilient and try again.",
              },
              {
                id: "wrt-1:2-a",
                da: " Be receptive to challenging the status quo and encourage others to do the same.",
              },
              {
                id: "wrt-1:2-b",
                da: " Consider the conditions and context of the problem you are trying to resolve and determine whether they have changed in any way. If they have, it may be time to consider that a different approach is in order.",
              },
              {
                id: "wrt-1:2-c",
                da: " Change your work groups or teams so that new ideas can be introduced.",
              },
              {
                id: "wrt-1:2-d",
                da: " Try experimenting with small changes instead of revamping or overhauling an entire system, policy or design.",
              },
              {
                id: "wrt-1:2-e",
                da: " Studies have shown that people work harder when they have a choice in how they try new and different things. Experiment in a manner that fits your personality and makes sense to you - but be sure to do it.",
              },
              {
                id: "wrt-1:2-f",
                da: " Be aware of your general attitude towards doing things differently, and try to stay positive about others' ideas. Always shooting down requests to try a new approach is a surefire way of discouraging a culture of experimentation.",
              },
              {
                id: "wrt-1:3-a",
                da: " Effectively communicate how your time and effort could positively affect the bottom line.",
              },
              {
                id: "wrt-1:3-b",
                da: " Anticipate objections and be prepared for the rejection or rebuttal of your ideas.",
              },
              {
                id: "wrt-1:3-c",
                da: " Support experimentation within your team or unit by publicly acknowledging and praising colleagues' efforts, regardless of their success or failure.",
              },
              {
                id: "wrt-1:3-d",
                da: " Include experimentation as part of your subordinate's performance measures.",
              },
              {
                id: "wrt-1:3-e",
                da: " Assign teams to work solely on experimental projects and innovative approaches.",
              },
              {
                id: "wrt-1:3-f",
                da: " Be politically savvy. Try to gain support from key decision makers.",
              },
              {
                id: "wrt-1:3-g",
                da: " Choose your battles. People may be more receptive to experimentation in one area than another. Start where the least resistance exists.",
              },
            ],
          },
        ],
      },
      bpt: {
        characteristic: "Thinking Big",
        wdd: "Shifting focus away from the details and gain a broader perspective; envisioning future scenarios based on a combination of intuition, trends and data; dealing with complex intellectual and cognitive concepts.",
        icon: require("@/assets/Iconography/Characteristics/01-Big Picture Thinker.svg"),
        competencies: [
          {
            id: "bpt-0",
            icon: require("@/assets/Iconography/Attributes/01-03_Thinking globally.svg"),
            comp: "Thinking globally",
            wdd: "Can shift focus away from the details and gain a broader perspective",
            progressMeasures: [
              {
                id: "bpt-0-0",
                pm: "I am knowledgeable about current and potential future trends",
                pmMap:
                  "Stay knowledgeable about current and potential future trends",
              },
              {
                id: "bpt-0-1",
                pm: "I read books and magazines outside of my field of expertise",
                pmMap:
                  "Read books and magazines outside of my field of expertise",
              },
              {
                id: "bpt-0-2",
                pm: "I am good at forecasting consequences or results",
                pmMap: "Forecast consequences or results",
              },
              {
                id: "bpt-0-3",
                pm: "I think about big picture before making decisions",
                pmMap:
                  "Take the big picture into account before making decisions",
              },
              {
                id: "bpt-0-4",
                pm: "I can see the impact of changes in other areas on my field of interest",
                pmMap:
                  "See the impact of changes in other areas on my field of interest",
              },
            ],
            developmentActions: [
              {
                id: "bpt-0:1-a",
                da: " Investigate other opportunities available in your organization that are related to your discipline but less technical. Your company perhaps offers courses or certificates in management-related fields that could help to create a balance with your technical skills.",
              },
              {
                id: "bpt-0:1-b",
                da: " Ask to be included in interdisciplinary meetings to raise your exposure to other business areas.",
              },
              {
                id: "bpt-0:1-c",
                da: " Be aware of what happens in the rest of the world. Read news magazines and articles about trades other than yours.",
              },
              {
                id: "bpt-0:1-d",
                da: " Ask to mentor new recruits in exchange for being mentored by someone in an area outside your discipline.",
              },
              {
                id: "bpt-0:1-e",
                da: " Start a 'futurist club'. Establish a group drawn from peers and friends in your field of expertise, who meets regularly to discuss ways in which your discipline or technology could affect the future of your organization and, in effect, the world.",
              },
              {
                id: "bpt-0:1-f",
                da: " Read literature about how your discipline has evolved. Which external factors have influenced the way you do business today?",
              },
              {
                id: "bpt-0:2-a",
                da: " Include future scenarios and how they may have an impact on your work when planning your assignments or projects.",
              },
              {
                id: "bpt-0:2-b",
                da: " Assemble teams in which both global thinkers and detail-oriented people are well represented. You will be exposed to the way global thinkers approach problems and achieve more balanced output.",
              },
              {
                id: "bpt-0:2-c",
                da: " Allow yourself time to explore creative options and brainstorming. Do not accept your first idea. Create at least three options before you take action. Consider how to get the same results through different means.",
              },
              {
                id: "bpt-0:2-d",
                da: " Switch between projects often so that you do not get buried too deep in the details of one only. Come up for air.",
              },
              {
                id: "bpt-0:2-e",
                da: " Delegate some of the detailed work to others to give yourself time to discuss and contemplate big-picture issues.",
              },
              {
                id: "bpt-0:3-a",
                da: " Attend diverse cultural events in your city, such as foreign films or exhibitions.",
              },
              {
                id: "bpt-0:3-b",
                da: " Take advantage of international assignments when possible.",
              },
              {
                id: "bpt-0:3-c",
                da: " Request opportunities to work with global teams. It will help to broaden your exposure to different management styles, problem-solving techniques etcetera.",
              },
              {
                id: "bpt-0:3-d",
                da: " Mentor people in your company from diverse cultural backgrounds, race and different gender, or seek a mentor who comes from a different background to you.",
              },
              {
                id: "bpt-0:3-e",
                da: " Expose your brain to new forms of stimulus regularly, for example, a different genre of books, art or music. Learn a foreign language. Visit museums.",
              },
              {
                id: "bpt-0:3-f",
                da: " Start a hobby that will introduce you to new people and skills you have not sampled, such as dancing, woodworking, cooking or pottery. Volunteer to work for groups with whom you cannot necessarily identify, such as the elderly or the poor. Choose hobbies that encourage the use of imagery and the creative side of your brain, such as art class or photography.",
              },
              {
                id: "bpt-0:4-a",
                da: " Write down the pros and cons of your various options and pay close attention to the global impact of each option - the potential influence on people, money, time and existing processes.",
              },
              {
                id: "bpt-0:4-b",
                da: " Assume there is always more than one way to solve a problem. Do not limit yourself to comfortable or familiar solutions. As a rule, ensure you have considered at least three different approaches.",
              },
              {
                id: "bpt-0:4-c",
                da: " Get input that challenges your linear thinking. Consult peers and co-workers to find scenarios you may have overlooked.",
              },
              {
                id: "bpt-0:4-d",
                da: " Check in with others. You will stay in touch with the issues that concern them.",
              },
              {
                id: "bpt-0:4-e",
                da: " Try to find value in the things that others overlook.",
              },
            ],
          },
          {
            id: "bpt-1",
            icon: require("@/assets/Iconography/Attributes/01-02_Thinking strategically.svg"),
            comp: "Thinking strategically",
            wdd: "Can envision future scenarios based on a combination of intuition, trends and data",
            progressMeasures: [
              {
                id: "bpt-1-0",
                pm: "I stay informed about trends that affect my business/job",
                pmMap: "Stay informed about trends that affect my business/job",
              },
              {
                id: "bpt-1-1",
                pm: "I have experience in formulating strategic plans",
                pmMap: "Formulate effective and accurate strategic plans",
              },
              {
                id: "bpt-1-2",
                pm: "I consider the long-term impact even when following a short-term tactical approach",
                pmMap:
                  "Consider the long-term impact even when following a short-term tactical approach",
              },
              {
                id: "bpt-1-3",
                pm: "I consider how things interrelate and what the consequences are for the future",
                pmMap:
                  "Consider how things interrelate and what the consequences are for the future",
              },
              {
                id: "bpt-1-4",
                pm: "I can talk about possibilities and scenarios for the future",
                pmMap: "Talk about possibilities and scenarios for the future",
              },
            ],
            developmentActions: [
              {
                id: "bpt-1:1-a",
                da: " Learn to delegate effectively: check carefully exactly what you can pass on to others to diminish distractions to your focus on strategy, and hand it over.",
              },
              {
                id: "bpt-1:1-b",
                da: " Develop strong, effective teams with the authority to act. You must trust them to make decisions and they must be able to help you to run the business effectively.",
              },
              {
                id: "bpt-1:1-c",
                da: " Ensure you allocate equal time to tactical concerns and strategic meetings or discussions.",
              },
              {
                id: "bpt-1:1-d",
                da: " Ensure you have included strategic goals in both your work plans and those of peers or relevant staff.",
              },
              {
                id: "bpt-1:1-e",
                da: " You must have a well-defined vision for you and your team that has been clearly articulated to all of you. Where are you heading in one or five or 10 years? If you do not consider this question regularly, you will easily revert to the here and now only.",
              },
              {
                id: "bpt-1:1-f",
                da: " Understand your own time horizon: are you working on projects with a one-year horizon, or five or 10 years? You should also know the time horizon of your supervisor and their boss.",
              },
              {
                id: "bpt-1:1-g",
                da: " Get a business or strategic plan in place that answers in detail where you are now, where you are going and how you will get there.",
              },
              {
                id: "bpt-1:1-h",
                da: " Review your strategic position regularly. Use a SWOT plan, which stands for strengths, weaknesses, opportunities and threats. These four components are necessary to assess your or a company's strategic position: you want to exploit strengths, improve weaknesses, capitalize on opportunities and identify threats.",
              },
              {
                id: "bpt-1:2-a",
                da: " Know the competitive advantage that makes your success sustainable. You must recognize what makes you stand out against your competitors, then create an advantage that remains competitive over time. What do you do best? What makes you unique? What can your organization do better than any other now and in the long term?",
              },
              {
                id: "bpt-1:2-b",
                da: " Hold futurist sessions regularly and discuss nothing but the future. Brainstorm with your team to identify the major factors that will influence your business in the next five to 10 years. What are the possible scenarios? What will the market look like in five or 10 years?",
              },
              {
                id: "bpt-1:2-c",
                da: " Review previous business plans and projects' outcomes. Which assumptions about the future were flawed and why? Are you making the same assumptions now? Which data was consulted and was it useful or misleading?",
              },
              {
                id: "bpt-1:2-d",
                da: " Professional futurists can provide invaluable insight. Look for available seminars or consider contracting a futurist to work with you or your team.",
              },
              {
                id: "bpt-1:2-e",
                da: " Many books about future trends and their influence are available. Two popular futurists among businesspeople are Faith Popcorn and John Naisbett.",
              },
              {
                id: "bpt-1:3-a",
                da: " Allow yourself to follow your hunches and intuition without editing your thoughts or judging yourself harshly.",
              },
              {
                id: "bpt-1:3-b",
                da: " Find creative people with whom you can share out-of-the-box ideas and feel safe to do so.",
              },
              {
                id: "bpt-1:3-c",
                da: " Be more playful. Ensure you have activities and people outside work that allow you to laugh and relax.",
              },
              {
                id: "bpt-1:3-d",
                da: " Do something completely impractical, just because you can. Consider the consequences afterwards. Were they nearly as bad as you expected?",
              },
              {
                id: "bpt-1:3-e",
                da: " Play devil's advocate with yourself. Challenge yourself with questions such as 'Why does it have to be like this?' and 'Why not try it their way?'",
              },
              {
                id: "bpt-1:4-a",
                da: " Be aware of what happens in the rest of the world. Read news magazines and articles from other professions too.",
              },
              {
                id: "bpt-1:4-b",
                da: " Consider how change in the political climate may affect government policy related to your field.",
              },
              {
                id: "bpt-1:4-c",
                da: " Make use of rotational opportunities that can expose you to other business functions.",
              },
              {
                id: "bpt-1:4-d",
                da: " Make the time to get away from your desk and talk to people in other departments about their work and possible changes that could affect them.",
              },
              {
                id: "bpt-1:4-e",
                da: " Attend interdepartmental meetings when possible.",
              },
              {
                id: "bpt-1:4-f",
                da: " Always look for unusual connections between your job and what people do in other fields.",
              },
              {
                id: "bpt-1:4-g",
                da: " Take advantage of conferences that will expose you to new trends and peers in your field.",
              },
              {
                id: "bpt-1:5-a",
                da: " Always ask questions: why was a decision made by higher management, what would the future consequence be if you chose a different tactic today, which assumptions are being made about the future that dictate the nature of your work today?",
              },
              {
                id: "bpt-1:5-b",
                da: " Consider ways to see things from other people's perspective. Imagine you are the customer, your supplier or the competitor.",
              },
              {
                id: "bpt-1:5-c",
                da: " Ask your supervisor whether you can attend meetings or sit in on strategic planning calls to get exposure to issues discussed and considered.",
              },
              {
                id: "bpt-1:5-d",
                da: " Ask for the opportunity to participate in cross-functional projects. Strategic initiatives and planning always involve multiple departments or business areas.",
              },
              {
                id: "bpt-1:5-e",
                da: " Ask the human resources department about courses or training in strategic-planning techniques you could attend.",
              },
              {
                id: "bpt-1:5-f",
                da: " Read books or business cases that involve strategy.",
              },
              {
                id: "bpt-1:5-g",
                da: " Keep abreast of trends and new developments that concern your field, government policy, competitors and clients.",
              },
            ],
          },
          {
            id: "bpt-2",
            icon: require("@/assets/Iconography/Attributes/01-01_Understanding complex ideas.svg"),
            comp: "Understanding complex ideas",
            wdd: "Can deal with complex intellectual and cognitive concepts",
            progressMeasures: [
              {
                id: "bpt-2-0",
                pm: "I find it easy to restate complex ideas",
                pmMap: "Restate complex ideas",
              },
              {
                id: "bpt-2-1",
                pm: "People often ask me to explain concepts that they are struggling to understand",
                pmMap:
                  "Explain concepts to others that they are struggling to understand",
              },
              {
                id: "bpt-2-2",
                pm: "I enjoy thinking about abstract concepts and formulating models that explain things",
                pmMap:
                  "Discuss abstract concepts and formulate models that explain things",
              },
              {
                id: "bpt-2-3",
                pm: "I am described as sharp or smart by others",
                pmMap: "Being sharp and smart",
              },
              {
                id: "bpt-2-4",
                pm: "I am open to new ideas and ways of thinking",
                pmMap: "Be open to new ideas and ways of thinking",
              },
            ],
            developmentActions: [
              {
                id: "bpt-2:1-a",
                da: " Focus to identify and improve the areas most challenging to you, especially if they are relevant to your career advancement.",
              },
              {
                id: "bpt-2:1-b",
                da: " If the problem seems too complex to comprehend as a whole, divide it into smaller parts and tackle them one at a time. Let one solution lead to the next.",
              },
              {
                id: "bpt-2:1-c",
                da: " Keep your mind sharp by incorporating mental puzzle materials into leisure time. Do crossword puzzles or games such as Sudoku at night before going to bed, or while you are waiting in a queue. They are fun and keep your mind nimble.",
              },
              {
                id: "bpt-2:1-d",
                da: " Explore problem-solving techniques such as visualization, storyboarding and worstcase scenario development. Having several tools on which to draw is particularly helpful when you need to see things from different perspectives.",
              },
              {
                id: "bpt-2:1-e",
                da: " Are your thoughts organized? The more complex the problem or issue, the more important it is to be able to organize it into manageable and understandable components. Use techniques such as mind mapping, flowcharting and checklists to clarify the concepts in your head.",
              },
              {
                id: "bpt-2:1-f",
                da: " Ensure you define the nature of the problem well. Quite often, people tackle problems head-on, only to realize they have wasted time analyzing the symptoms instead of the problem itself. Are you oversimplifying the problem or making it more complex than it actually is?",
              },
              {
                id: "bpt-2:1-g",
                da: " If you do not understand something, be sure to let others know. They may have to explain numerous times in different ways, but the alternative is to fall behind even further, which will make it even more difficult or impossible to catch up in future.",
              },
              {
                id: "bpt-2:1-h",
                da: " Ask for a patient explanation and verbalize how you would best understand the information. For example, you may be more visual and require diagrams, or you may need information to be organized in a particular way.",
              },
              {
                id: "bpt-2:1-i",
                da: " Be realistic and give yourself time to become more experienced in a new job.",
              },
              {
                id: "bpt-2:1-j",
                da: " Not working in your first language can make it challenging to understand others or follow their train of thought. Get a language coach to help you. Let others know that they may have to repeat things or talk slower. Ask for as much information as possible before meetings to give you a head-start.",
              },
              {
                id: "bpt-2:2-a",
                da: " Try relaxation techniques that can help you to control your emotions, such as meditation and breathing exercises.",
              },
              {
                id: "bpt-2:2-b",
                da: " Identify your emotional triggers and ensure you are aware when you react to them instead of the facts.",
              },
              {
                id: "bpt-2:2-c",
                da: " Ask a trusted peer for feedback about the issues. They can provide you with valuable perspective and let you know when you are overreacting.",
              },
              {
                id: "bpt-2:2-d",
                da: " Step away from a situation or move on to another issue. Giving yourself enough time to reconnect with your logical self can bring much needed clarity to a situation.",
              },
              {
                id: "bpt-2:2-e",
                da: " Put the problem on paper. Mapping out the issues and a possible course of action helps to engage logic, rather than emotion.",
              },
              {
                id: "bpt-2:3-d",
                da: " Refrain from interrupting others and jumping to conclusions before all the facts have been presented.",
              },
              {
                id: "bpt-2:3-a",
                da: " Challenge what you know. Expose yourself to fresh ideas and points of view. Subscribe to trade magazines, read the newspaper, attend seminars, talk to experts in your company and encourage productive debates among peers.",
              },
              {
                id: "bpt-2:3-b",
                da: " Look for hidden biases in your thinking, because they prevent you from accepting other possibilities.",
              },
              {
                id: "bpt-2:3-c",
                da: " Challenge your beliefs by playing devil's advocate. Support the 'other side' in an issue, if only for the sake of considering all options. Once you start to defend new turf, you may find yourself thinking quite differently.",
              },
              {
                id: "bpt-2:3-e",
                da: " Do not assume you know better than others. Even if you are an expert in your field, you may be missing some context or information that could change the solution entirely.",
              },
              {
                id: "bpt-2:4-a",
                da: " Establish a system to help you remember things. Different methods work for different people, but something as simple as carrying a small notepad at all times to record items is more than adequate. The important thing is to have a system and stick to it.",
              },
              {
                id: "bpt-2:4-b",
                da: " Use online tools such as Microsoft Outlook to help you remember events and meetings. Ask your IT department to familiarize you with all the tools available.",
              },
              {
                id: "bpt-2:4-c",
                da: " If you are notoriously forgetful, rely on a good assistant to notify you about your commitments.",
              },
              {
                id: "bpt-2:4-d",
                da: " Do not wait until later to jot down notes or reminders. When you record information immediately, there is no chance of forgetting.",
              },
              {
                id: "bpt-2:4-e",
                da: " Ask people to follow up with e-mails and reminders.",
              },
              {
                id: "bpt-2:4-f",
                da: " Keep your memory sharp with memory games. They are available online and there are many books on the topic as well.",
              },
              {
                id: "bpt-2:4-g",
                da: " Ensure you get enough rest and do not burn the candle at both ends. Tiredness can make you forgetful.",
              },
              {
                id: "bpt-2:4-h",
                da: " Examine your workload. If you constantly struggle to get things done, you may need to delegate or seek additional resources.",
              },
              {
                id: "bpt-2:4-i",
                da: " Watch your stress level. Chronic stress can affect your memory. Ensure that you have built in enough time to relax and recharge.",
              },
              {
                id: "bpt-2:5-a",
                da: " Identify the operational and technical knowledge you should improve to conduct your business more intelligently. Prioritize gaining knowledge in the areas that will have the greatest impact on your ability to conduct business now.",
              },
              {
                id: "bpt-2:5-b",
                da: " Engage a coach or manager to formulate a development plan, with specific actions aimed at increasing your functional knowledge and exposing you to requisite experiences.",
              },
              {
                id: "bpt-2:5-c",
                da: " Raise your business acumen by subscribing to publications in your field. Read them to stay abreast of trends and increase your general knowledge.",
              },
              {
                id: "bpt-2:5-d",
                da: " Exploit your social nature by attending conferences and association meetings where you can gain new insight about your business.",
              },
              {
                id: "bpt-2:5-e",
                da: " Ask peers to send you literature and articles they have found particularly insightful.",
              },
              {
                id: "bpt-2:5-f",
                da: " During discussions, focus less on your and other people's feelings and more on solving the problem.",
              },
              {
                id: "bpt-2:5-g",
                da: " Work on your motivational smarts, that is, how driven you are to grow in challenging areas and achieve your goals.",
              },
            ],
          },
        ],
      },
      cc: {
        characteristic: "Confronting Conflicts",
        wdd: "Handle and resolve conflict promptly; confronting underperformance quickly when individuals fail to meet expectations, taking corrective action. Challenge the status quo, even at personal risk, willing to speak out.",
        icon: require("@/assets/Iconography/Characteristics/03_Conflict Confronter.svg"),
        competencies: [
          {
            id: "cc-0",
            icon: require("@/assets/Iconography/Attributes/03-03_Acting  courageously.svg"),
            comp: "Acting courageously",
            wdd: "Challenges the status quo and is willing to speak out, even at great personal risk",
            progressMeasures: [
              {
                id: "cc-0-0",
                pm: "I feel comfortable to offer a dissenting opinion",
                pmMap: "Feel comfortable to offer a dissenting opinion",
              },
              {
                id: "cc-0-1",
                pm: "I speak up when something has to be said; I do not wait until the last minute",
                pmMap:
                  "Speak up when something has to be said; not wait until the last minute",
              },
              {
                id: "cc-0-2",
                pm: "I do not take it personally when people disagree with me",
                pmMap: "Not take it personally when people disagree with me",
              },
              {
                id: "cc-0-3",
                pm: "I do not follow the crowd when I believe otherwise",
                pmMap: "Not follow the crowd when I believe otherwise",
              },
              {
                id: "cc-0-4",
                pm: "I have stood up before for something in which I believed",
                pmMap: "Stand up for something in which I believed",
              },
            ],
            developmentActions: [
              {
                id: "cc-0:1-a",
                da: " Choose your battles wisely. As long as you are not a habitual challenger of every opinion, you will not be labeled a troublemaker.",
              },
              {
                id: "cc-0:1-b",
                da: " Are you being too diplomatic? Be sure not to sugarcoat things to the extent that no one gets your point. People need to see your conviction and passion.",
              },
              {
                id: "cc-0:1-c",
                da: " If debate or uncertainty persists, take a vote and be the arbitrator when necessary.",
              },
              {
                id: "cc-0:1-d",
                da: " If you must voice extremely sensitive information or have concerns about unethical behavior but do not feel comfortable doing so on your own, consult the human resources department for the best course of action.",
              },
              {
                id: "cc-0:2-a",
                da: " Treat what you have to say as important and give people the opportunity to hear you out.",
              },
              {
                id: "cc-0:2-b",
                da: " Prepare yourself well and know your topic. People may not agree with you, but they will respect a knowledgeable opinion.",
              },
              {
                id: "cc-0:2-c",
                da: " Instead of focusing on whether you are going to look bad, consider the consequences of not speaking out.",
              },
              {
                id: "cc-0:2-d",
                da: " Share your thoughts with a trusted peer or mentor. It can help to gain you confidence in your opinions and decisions.",
              },
              {
                id: "cc-0:3-a",
                da: " Instead of trying to challenge everything that needs attention, choose what you believe needs improvement most. What would have the biggest impact? Focusing on these issues will give you greater resolve when you are met with disinterest or resistance.",
              },
              {
                id: "cc-0:3-b",
                da: " If the issue is too big to challenge at once, break it down into smaller parts and stay focused on challenging one aspect at a time.",
              },
              {
                id: "cc-0:3-c",
                da: " Is someone else struggling to challenge the status quo? Lend them your support and find strength in numbers. Try to motivate others to join you in voicing your objections.",
              },
              {
                id: "cc-0:3-d",
                da: " You may be wasting energy if you do not understand the politics of an issue. Become more politically astute. Knowing the right person to engage for help to facilitate change will get you much further with less effort. If your stance is not well received, who else is there to listen to your opinion? Have you engaged the key decision makers? Think strategically about the people with whom you raise objections or concerns.",
              },
              {
                id: "cc-0:4-a",
                da: " Expect and prepare for resistance from people with more experience or authority. Write down responses to the objections you anticipate. Preparation will give you the confidence to manage opposition. Rehearse the debate with trusted peers - there may be positions you have not considered for which you should be prepared.",
              },
              {
                id: "cc-0:4-b",
                da: " Outline your reasons well. If the person becomes defensive about being challenged, keep on redirecting the conversation back to the goal you want to achieve.",
              },
              {
                id: "cc-0:4-c",
                da: " Get to know authority figures who make you feel anxious. Knowing people better helps to dispel anxieties. Attend company parties where you can interact with them or ask others who know them.",
              },
              {
                id: "cc-0:4-d",
                da: " After you have presented your case, you may need to approach the subject again. You have the right to follow up more than once if you feel you are not being heard or the issue remains unresolved.",
              },
              {
                id: "cc-0:4-e",
                da: " Time your challenge carefully. Typically, authority figures are extremely busy and the wrong timing may harm how your input is received. Try to find a time when the person is less busy and schedule a meeting, if possible, to ensure you receive undivided attention.",
              },
              {
                id: "cc-0:5-a",
                da: " Diplomacy is the key to not offending others when you stand firm on your opinion. Be honest but tactful. Acknowledge the current situation and make reference to what is working well.",
              },
              {
                id: "cc-0:5-b",
                da: " Speak in a calm, non-confrontational tone. It will encourage your audience to be more receptive and open to considering your position. Apologize if you have raised your voice.",
              },
              {
                id: "cc-0:5-c",
                da: " It is good to be passionate about your beliefs, but it is more important that you are able to articulate them well. Ensure you are thoroughly prepared for logical argument when challenging others. Prepare a business case if appropriate and outline the reasons why your position makes sense.",
              },
              {
                id: "cc-0:5-d",
                da: " Offer solutions when you challenge the status quo. Offering alternatives adds real value to the discussion and demonstrates your problem-solving skills.",
              },
              {
                id: "cc-0:5-e",
                da: " Just like you, most people are likely to defend their turf. Expect others to be argumentative and realize they are just as passionate as you are about the issue. Remain patient and agreeable and hear people out. They will find it harder to be aggressive with someone who is composed.",
              },
            ],
          },
          {
            id: "cc-1",
            icon: require("@/assets/Iconography/Attributes/03-02_Managing conflict.svg"),
            comp: "Managing conflict",
            wdd: "Recognizes, handles and resolves conflict promptly",
            progressMeasures: [
              {
                id: "cc-1-0",
                pm: "I can mediate successfully in a conflict situation",
                pmMap: "Successfully mediate in a conflict situation",
              },
              {
                id: "cc-1-1",
                pm: "I remain composed during conflict",
                pmMap: "Remain composed during conflict",
              },
              {
                id: "cc-1-2",
                pm: "I can diplomatically discuss things that people might not want to hear",
                pmMap:
                  "Diplomatically discuss things that people might not want to hear",
              },
              {
                id: "cc-1-3",
                pm: "I see conflict’s positive outcome after it has been resolved",
                pmMap:
                  "See conflict’s positive outcome after it has been resolved",
              },
              {
                id: "cc-1-4",
                pm: "I do not instigate conflict, even accidentally",
                pmMap: "Not instigate conflict, even accidentally",
              },
            ],
            developmentActions: [
              {
                id: "cc-1:1-a",
                da: " If you are asked to help others to resolve conflict among them, facilitate an honest discussion during which all parties have an opportunity to be heard. Focus the conversation on facts and do not allow insults or a lack of respect to enter the discussion.",
              },
              {
                id: "cc-1:1-b",
                da: " Reaching consensus may be too lofty a goal at first. You can measure success by your ability to facilitate a respectful understanding among the parties.",
              },
              {
                id: "cc-1:1-c",
                da: " Conflict is often avoided, or at least better managed, by proactively explaining to employees why decisions were made, especially when they were uninvolved in the decision-making process. Providing clarity prevents people from reaching their own conclusions or trusting rumors more than management.",
              },
              {
                id: "cc-1:1-d",
                da: " If the conflict is about resources, for example, disagreement about who does what or stress about working with inadequate resources, clarify their allocation.",
              },
              {
                id: "cc-1:1-e",
                da: " Remember what will be addressed by managing the conflict - leadership problems, poor team performance, a lack of sharing information etcetera.",
              },
              {
                id: "cc-1:1-f",
                da: " Ensure you do not concede too quickly just for the sake of peace. When dealing with overly competitive and aggressive people, you will have to bring strong conviction to your position.",
              },
              {
                id: "cc-1:1-g",
                da: " If you are going along with others, examine your reasons. It is acceptable when in everyone's best interest to do so, including yours, or as a strategy to promote your interests in the future, for example, in situations that will enhance your negotiating powers later.",
              },
              {
                id: "cc-1:2-a",
                da: " Handle conflict with a particular individual by engaging in a rational, unemotional conversation. It is the best way to clarify the issues.",
              },
              {
                id: "cc-1:2-b",
                da: " Be patient and assign value to the process, not just the outcome.",
              },
              {
                id: "cc-1:2-c",
                da: " Instead of using intimidation to make gains, make it your goal to put the other person at ease.",
              },
              {
                id: "cc-1:2-d",
                da: " Keep your voice calm and use a normal tone to discuss the matter.",
              },
              {
                id: "cc-1:2-e",
                da: " Be aware of your body language - it often says more than your words. Leaning into people's space and pointing repeatedly in their faces, for example, are signs of aggression. Your body language should remain open and welcoming.",
              },
              {
                id: "cc-1:2-f",
                da: " Be aware of the role personal chemistry plays in conflict. The actual issue may be less strong than the confrontational chemistry between people. For example, two people with strongly opposing views on an issue are likely to butt heads. We often dislike in others what we dislike in ourselves. Which characteristics of your personality do you find least attractive?",
              },
              {
                id: "cc-1:2-g",
                da: " Write down five traits in others that trigger your aggression. These come in every shape and size: people who talk constantly and never listen, who must always have the last word, who never commit, who criticize anything they did not create themselves, who stab you in the back or gossip all the time. Be aware that these traits may bring out the worst in you while you manage conflict.",
              },
              {
                id: "cc-1:2-h",
                da: " Ask a trusted peer to alert you when you walk over others. It may be difficult for you to spot your behavior, especially because you are unlikely to think you are doing anything wrong.",
              },
              {
                id: "cc-1:2-i",
                da: " Take an aggression management course if your temper is an issue or you fly off the handle easily.",
              },
              {
                id: "cc-1:3-a",
                da: " Deal with conflict immediately. Do not allow the situation to worsen or tensions to build unnecessarily. The longer matters remain unresolved, the more difficult it will be to defuse people's emotions, and the harder it will be to convince you to tackle them.",
              },
              {
                id: "cc-1:3-b",
                da: " Begin any discussion about the issue with a clear definition of its objectives and likely positive outcomes. Focusing on positive results validates the need for confrontation.",
              },
              {
                id: "cc-1:3-c",
                da: " There is strength in numbers. If appropriate, rally support from others to confront the other side.",
              },
              {
                id: "cc-1:3-d",
                da: " Remind yourself that you are working towards a positive goal, and that you or others feeling temporarily uncomfortable is worth the effort.",
              },
              {
                id: "cc-1:3-e",
                da: " Consider creative ways to resolve the conflict. Ask a trusted peer or mentor to provide suggestions. Practice with an issue about which you feel strongly.",
              },
              {
                id: "cc-1:3-f",
                da: " Keep practicing. Feeling confident to confront others may require doing it enough times to realize that your anxieties are unwarranted.",
              },
              {
                id: "cc-1:4-a",
                da: " Communicate and keep people informed. Often, a lack of communication is the root of conflict. People become upset when they continuously face surprises or are not informed about new decisions, programs etcetera.",
              },
              {
                id: "cc-1:4-b",
                da: " If tempers rise when confronting others, focus inward on your behavior, not theirs. Speaking to someone as if they are not upset is an effective strategy to remain composed.",
              },
              {
                id: "cc-1:4-c",
                da: " Be aware of using language that makes people defensive. For example, rather say 'It appears there is a misunderstanding' than 'You don't understand'. Also avoid sweeping generalizations when making your argument, such as 'You and your team always do what you want'.",
              },
              {
                id: "cc-1:4-d",
                da: " Be aware of your non-verbal communication, for example, maintain eye contact and nod while you listen.",
              },
              {
                id: "cc-1:4-e",
                da: " Focus on facts, not the person involved.",
              },
              {
                id: "cc-1:4-f",
                da: " Listen actively. You want to reach a mutually beneficial outcome, and that cannot be done without understanding the other side's position. If you supposedly know all the answers before discussions begin, you will not manage conflict well. Allow the other person time to vent and let them explain without interrupting or judging what is said. Verify that you truly hear each other. Repeat and rephrase what you have heard the other person say and confirm accuracy. Let them confirm that you have listened properly.",
              },
              {
                id: "cc-1:4-g",
                da: " If possible, always have conflict-related discussions in private. There is no need to include unnecessary ears or solicit unwanted input.",
              },
              {
                id: "cc-1:4-h",
                da: " Most often, it is best to be open and honest about your feelings. People will appreciate your sincerity and be more sympathetic to your position.",
              },
              {
                id: "cc-1:4-i",
                da: " End your discussion with action items for which all parties involved are responsible. Ensure there is agreement and support from both sides regarding these items. If you cannot come to an agreement there and then, consider taking time to reflect and cool down, and reconvene later.",
              },
              {
                id: "cc-1:4-j",
                da: " Agree to disagree, or seek a third party to mediate when issues simply cannot be resolved.",
              },
              {
                id: "cc-1:4-k",
                da: " Many books are available to learn more about conflict management. These include Interpersonal Conflict by William W Willmot and Conflict Resolution by Daniel Dana.",
              },
              {
                id: "cc-1:4-l",
                da: " Enquire about possible conflict-management courses you could take through the company. The human resources department could help.",
              },
              {
                id: "cc-1:4-m",
                da: " Ask your boss about opportunities to attend meetings that could give you first-hand exposure to conflict-management practices.",
              },
              {
                id: "cc-1:4-n",
                da: " Take advantage of assessment tools to help you identify and mitigate the risk of conflict in your team. The Team Dynamics app lets you assess different team styles and how individuals will likely perceive each other based on these styles.",
              },
              {
                id: "cc-1:5-a",
                da: " Acknowledge tension openly instead of denying it - it is the first step towards action.",
              },
              {
                id: "cc-1:5-b",
                da: " Redefine your perspective on confrontation. Encourage honesty and promote creative, constructive debate within your team and throughout the organization.",
              },
              {
                id: "cc-1:5-c",
                da: " If you lead within the organization, you will set an example for everyone else. Ensure you are open to being challenged.",
              },
              {
                id: "cc-1:5-d",
                da: " If a situation cannot be resolved through discussion and the other party's behavior clashes with policies and procedures, seek support from the human resources department.",
              },
              {
                id: "cc-1:5-e",
                da: " If you are in conflict with your boss, you will have to learn how to get along despite their arrogant or controlling behavior. Try to learn as much as you can about your boss's personality and expectations. Talk to others who work well with your boss and ask their advice.",
              },
            ],
          },
          {
            id: "cc-2",
            icon: require("@/assets/Iconography/Attributes/03-01_Managing under performance.svg"),
            comp: "Managing under performance",
            wdd: "Confronts under performance quickly when individuals fail to meet expectations and takes corrective action",
            progressMeasures: [
              {
                id: "cc-2-0",
                pm: "I feel comfortable to give corrective feedback when needed",
                pmMap:
                  "Feel comfortable to give corrective feedback when needed",
              },
              {
                id: "cc-2-1",
                pm: "I manage non-performance issues in a timely manner",
                pmMap: "Manage non-performance issues in a timely manner",
              },
              {
                id: "cc-2-2",
                pm: "I understand the underlying reasons related to under performance",
                pmMap:
                  "Understand the underlying reasons related to under performance",
              },
              {
                id: "cc-2-3",
                pm: "I can quickly detect non-performance issues",
                pmMap: "Quickly detect non-performance issues",
              },
              {
                id: "cc-2-4",
                pm: "I adapt my style of feedback to the needs of the person I am addressing",
                pmMap:
                  "Adapt my style of feedback to the needs of the person I am addressing",
              },
            ],
            developmentActions: [
              {
                id: "cc-2:1-a",
                da: " Start your discussion by pointing out some positive aspects of the employee's performance.",
              },
              {
                id: "cc-2:1-b",
                da: " Always treat the employee with professionalism, dignity and respect, even if their performance has had a negative impact on you and your team.",
              },
              {
                id: "cc-2:1-c",
                da: " Check the person's level of understanding of their job description to ensure that you both have the same expectations of their role.",
              },
              {
                id: "cc-2:1-d",
                da: " Prepare corrective suggestions before you meet with the employee, but allow them to express themselves. There may be factors of which you are unaware or have not considered that will affect the recommended action. People also must have the opportunity to feel that they have been heard.",
              },
              {
                id: "cc-2:1-e",
                da: " People tend to engage in inappropriate problem-solving techniques - blaming, accusing, defending etcetera. Ensure you recognize and manage such behavior, otherwise it could distract you from reaching a solution.",
              },
              {
                id: "cc-2:1-f",
                da: " Encourage the employee to suggest solutions to their non-performance. Employees are more likely to accept and support the need for change if they can solve their own problems.",
              },
              {
                id: "cc-2:1-g",
                da: " Do not get distracted by other work-related items that also need attention during a performance discussion; save them for another conversation. Mixing different issues lessens the impact of the conversation.",
              },
              {
                id: "cc-2:1-h",
                da: " Be as specific as you can about the issue. Avoid generalizations, opinions and comparisons, and provide evidence to support your point of view.",
              },
              {
                id: "cc-2:1-i",
                da: " Emphasize the consequences of the employee's non-performance. Highlight the impact their performance has on the rest of the team or organization and the consequences should the employee's performance not improve, for example, opportunities to grow in the company will be limited.",
              },
              {
                id: "cc-2:1-j",
                da: " Ensure the person truly has understood the impact of the problem. Signs that they have not could include that they continue to use excuses, accuse you of being unfair and so forth. If this happens, redirect the conversation by saying: 'I would like to talk about that later; right now, I would like to stay focused on what you can do.' At this point you may need to tell the employee what you think the best solution is.",
              },
              {
                id: "cc-2:1-k",
                da: " Remind the employee that strong performance is non-negotiable.",
              },
              {
                id: "cc-2:2-a",
                da: " Address non-performance immediately. Do not wait until the year-end review or other formal assessments if you see a change for the worse or feel worried about a person's performance. Even if the employee is a consistently good performer, a brief discussion about their challenges and how you can assist can prevent the performance from deteriorating.",
              },
              {
                id: "cc-2:2-b",
                da: " Understand how well an employee's talents match their job requirements. Determine the competencies required for the position and which gaps exist. If possible, use a talent management system to analyze the shortcomings between a person's talent, position and the context of that position. It will allow you to measure the existing shortcomings and prioritize development items that will maximize performance.",
              },
              {
                id: "cc-2:2-c",
                da: " Schedule a meeting with the employee to discuss how their role can be improved in a way that benefits them, their boss and the business. State which part of their performance must be improved - be specific and cite examples. Be clear about the level of expectations you have and the need to perform at this level consistently. Identify the support and resources you will provide to assist the person in being successful. Set the measurements you will use to evaluate progress. When you finish your meeting, summarize the solution and express confidence in the employee's ability to implement the solution. Finally, document the meeting.",
              },
              {
                id: "cc-2:2-d",
                da: " Involve the employee in setting their own goals so that these are fully supported.",
              },
              {
                id: "cc-2:2-e",
                da: " Set short-term improvement goals for a person. A 90-day period is ideal, because it allows ample opportunity to monitor progress and experience success on a regular basis.",
              },
              {
                id: "cc-2:2-f",
                da: " Decide at the outset how a person will communicate their progress - will it be weekly, once a month? The intervals should be frequent but not burdensome.",
              },
              {
                id: "cc-2:2-g",
                da: " Assess whether the person will be able to improve their performance without additional assistance from, for example, a mentor, another team member, coach or technical expert",
              },
              {
                id: "cc-2:2-h",
                da: " Ensure your employees' ability to improve their performance is not hindered by external factors beyond their control, such as political barriers, bureaucracy or an uncooperative internal client who withholds information. Be proactive in paving the way for their success.",
              },
              {
                id: "cc-2:2-i",
                da: " Investigate whether non-performance problems are due to motivational issues and not a lack of skill. Understanding these issues and creating some incentives may be all that is needed to manage non-performance.",
              },
              {
                id: "cc-2:3-a",
                da: " Regularly monitor employees' work performance and the challenges they face.",
              },
              {
                id: "cc-2:3-b",
                da: " Establish a culture of open discussion by making yourself available to your employees - set aside a specific time, if possible every week, for people to talk to you.",
              },
              {
                id: "cc-2:3-c",
                da: " Ask the human resources department for information about the cost of hiring new talent. The figure will give you perspective on whether it is worth your time to deal with non-performance issues.",
              },
              {
                id: "cc-2:3-d",
                da: " Try to be empathetic. Remember a time when you struggled in your career.",
              },
              {
                id: "cc-2:3-e",
                da: " Visualize yourself as a mentor rather than a boss. What would a good teacher do with a problem student? How well can you perform in getting the student back on track?",
              },
              {
                id: "cc-2:4-a",
                da: " Analyze whether the person has the necessary experience for their responsibilities or a project. If not, it may be the cause of their nonperformance. You can then reassign the person altogether to build their experience level first, keep them on the project but give them tasks with less responsibility, or keep them on the project but let them work closely with someone who has greater experience and can supervise them.",
              },
              {
                id: "cc-2:4-b",
                da: " What level of technical or functional expertise does the individual have? Identify the items that must be improved and create a development plan. Put together a plan for technical training to enhance the person's skills set. This can be formal training or through mentorship.",
              },
              {
                id: "cc-2:4-c",
                da: " Unskilled behavioral competencies are best addressed through feedback discussions and coaching. A 360Â° feedback process based on behavioral competencies is effective to define the performance issue.",
              },
              {
                id: "cc-2:4-d",
                da: " Motivation is often the culprit behind reduced performance. Explore whether the person is content with their work situation and address incentives that would help to engage the person again. An employee may not feel comfortable to honestly discuss their issues with you, so offer that they can talk to a human resources representative.",
              },
              {
                id: "cc-2:4-e",
                da: " Employees may have personal problems that interfere with their work, such as family illness, death or divorce. Try to provide solutions to help the person through these difficult times and encourage them to use professional support available through the company.",
              },
              {
                id: "cc-2:4-f",
                da: " Use a Talent Management system such as to accurately assess an employee's suitability for a position. Is the person in the wrong position given their interests and talent? Does the person have a problem with their manager or the different work styles among the team members? The answers to these questions will provide valuable insight to help you determine the root of non-performance.",
              },
              {
                id: "cc-2:5-a",
                da: " Focus on the problematic behavior, not the problematic employee. You are seeking a solution to weak performance, not a weak personality.",
              },
              {
                id: "cc-2:5-b",
                da: " Avoid catching a person off-guard with feedback - it is likely to make them defensive. Give the person notice that you want to have a discussion about certain points and conduct the discussion promptly to avoid raising their anxiety levels.",
              },
              {
                id: "cc-2:5-c",
                da: " Allow the employee to react and do not respond defensively - it will only add emotion to the situation. Behave the way you expect them to behave.",
              },
              {
                id: "cc-2:5-d",
                da: " Let the person know you understand why they are upset, but that you cannot work out a solution unless they are composed.",
              },
              {
                id: "cc-2:5-e",
                da: " Expect the individual to try to sidetrack the conversation by blaming, denying, acting angry and so forth. Remain objective at all times.",
              },
              {
                id: "cc-2:5-f",
                da: " If the person does not calm down despite your attempts, tell them you will give them time to collect themselves and hold the meeting when they are ready to listen. Schedule another appointment before parting ways.",
              },
              {
                id: "cc-2:5-g",
                da: " Ask a human resources mediator to facilitate the conversation if the person is too difficult to engage in conversation.",
              },
            ],
          },
        ],
      },
      mo: {
        characteristic: "Methodical Organization",
        wdd: "Being well organized and methodical, paying attention to detail; having a high level of productivity and using time well to get work done; setting definite milestones and actions for achieving goals.",
        icon: require("@/assets/Iconography/Characteristics/11_Methodical Organiser.svg"),
        competencies: [
          {
            id: "mo-0",
            icon: require("@/assets/Iconography/Attributes/11-03_Being Detail-Oriented.svg"),
            comp: "Being detail-oriented",
            wdd: "Is well organized and methodical, and pays attention to detail",
            progressMeasures: [
              {
                id: "mo-0-0",
                pm: "I have a system in place that keep me organized",
                pmMap: "Have a system in place that keep me organized",
              },
              {
                id: "mo-0-1",
                pm: "I consider things carefully before rushing in",
                pmMap: "Consider things carefully before rushing in",
              },
              {
                id: "mo-0-2",
                pm: "I take good notes and record things which I need to follow up",
                pmMap:
                  "Take good notes and record things which I need to follow up",
              },
              {
                id: "mo-0-3",
                pm: "I can quickly access information I have stored without spending unnecessary time looking for it",
                pmMap:
                  "Quickly access information I have stored without spending unnecessary time looking for it",
              },
              {
                id: "mo-0-4",
                pm: "I seldom make mistakes because I overlooked important details",
                pmMap:
                  "Not overlook important details that could lead to mistakes",
              },
            ],
            developmentActions: [
              {
                id: "mo-0:1-a",
                da: " Train yourself to focus on the here and now, if only for short periods at a time. Set aside a specific amount of time every day to go over the details of a plan, whether you want to or not. Consider this the 'construction time' any project requires.",
              },
              {
                id: "mo-0:1-b",
                da: " Try a baby-steps approach. Start with being methodical about smaller things, such as your Rolodex or filing system, that do not take up too much time, and then move on to bigger challenges. This will help you to see the benefits that a small investment of your time can create.",
              },
              {
                id: "mo-0:1-c",
                da: " Cultivate an active interest in what you do. When there is something you do not want to but simply must do, find a way to make it interesting or recognize it as a necessary step between where you are and where you want to be - and do it.",
              },
              {
                id: "mo-0:1-d",
                da: " Set up a system that reminds you to focus on details. Write a note on the back of your hand, put a colorful reminder on your computer screen, get a peer to remind you or add it to your electronic calendar so that it reminds you once a day.",
              },
              {
                id: "mo-0:1-e",
                da: " Partner with other people who have opposite strengths, for example, if you get the management position appoint a detail-oriented person as your assistant.",
              },
              {
                id: "mo-0:1-f",
                da: " Ask a trusted peer who is methodical to help you consider some of the details you are likely to overlook. Compare your list of details with the other person's. Which angles did you omit?",
              },
              {
                id: "mo-0:2-a",
                da: " Stop looking for the easiest way out. Most goals take hard work and dedication to accomplish. It is important to work smartly and quickly, but be careful not to make excuses about details because they require extra work. Identify the shortcuts you may be taking, including making assumptions about instructions, people etcetera.",
              },
              {
                id: "mo-0:2-b",
                da: " Break down your goal into smaller, detailed tasks - each small task that is completed brings a reward.",
              },
              {
                id: "mo-0:2-c",
                da: " Do a detailed project timeline that sets realistic points at which you can expect milestones to be reached. Do not try to rush the process unduly.",
              },
              {
                id: "mo-0:2-d",
                da: " Recognize whether a team approach would be better and assign ample resources to work on the details of a plan.",
              },
              {
                id: "mo-0:2-e",
                da: " Put quality-assurance practices in place to guard against any major flaws or oversights in your processes.",
              },
              {
                id: "mo-0:2-f",
                da: " Meditation is an effective way to bring calm and stillness to the mind. Incorporate it in your daily routine.",
              },
              {
                id: "mo-0:3-a",
                da: " Keep relevant people informed of your workload if it starts to affect the accuracy of your work. It is that person's responsibility to delegate appropriately.",
              },
              {
                id: "mo-0:3-b",
                da: " Store all information for different projects or tasks separately in an organized manner, either electronically or in paper files, and ensure you can access it easily.",
              },
              {
                id: "mo-0:3-c",
                da: " Switching gears constantly consumes time. To increase your efficiency, bundle similar activities together. For example, do all your calls to different clients at one time, and send all your e-mails at another.",
              },
              {
                id: "mo-0:3-d",
                da: " Do you have systems in place that help to keep you organized? If yes, ensure you actually put them into practice. Can you list and describe your systems to others? They do not have to be complex - jotting notes in a designated notepad is a system.",
              },
              {
                id: "mo-0:3-e",
                da: " Ask meticulous co-workers about the systems they use to keep themselves organized. Maybe one will work for you.",
              },
              {
                id: "mo-0:3-f",
                da: " Take advantage of all of the organizing technology on your desktop, such as calendars, scheduling tools and project management software. You will be surprised to find many tools at your disposal; now you just have to use them.",
              },
              {
                id: "mo-0:3-g",
                da: " Keep things neat. Organize your desk and your surroundings as much as you can.",
              },
              {
                id: "mo-0:3-h",
                da: " Resist the temptation to put off doing something that would help you to be organized just because you can do it 'later'. This is what contributes to piles of papers, missing notes, unanswered calls and e-mails, or files lost in your computer.",
              },
              {
                id: "mo-0:3-i",
                da: " Are you constantly creating lists, spending more time trying to organize yourself than actually being organized? Do not set up systems you cannot follow or incorporate in a daily routine.",
              },
              {
                id: "mo-0:3-j",
                da: " Habits and routines help you to keep track of the details, because they are dependable.",
              },
              {
                id: "mo-0:4-a",
                da: " To ensure accountability, announce to others your commitment to approach an issue methodically.",
              },
              {
                id: "mo-0:4-b",
                da: " Ensure you know your company's culture and the so-called lay of the land. You may have to adapt to higher expectations or a new culture. If necessary and expected, you will have to step it up a notch.",
              },
              {
                id: "mo-0:4-c",
                da: " Remember that some clients will expect more attention to detail than others. Assume they do.",
              },
              {
                id: "mo-0:4-d",
                da: " Partner with someone who will hold you accountable and demand careful consideration of details in your processes and decisions.",
              },
            ],
          },
          {
            id: "mo-1",
            icon: require("@/assets/Iconography/Attributes/11-02_Managing Time.svg"),
            comp: "Managing time",
            wdd: "Has a high level of productivity and uses time well to get work done",
            progressMeasures: [
              {
                id: "mo-1-0",
                pm: "I do things as soon as I can and do not procrastinate",
                pmMap: "Do things as soon as I can and do not procrastinate",
              },
              {
                id: "mo-1-1",
                pm: "I can juggle multiple projects or tasks",
                pmMap: "Juggle multiple projects or tasks",
              },
              {
                id: "mo-1-2",
                pm: "I am realistic about how much work I can get done",
                pmMap: "Be realistic about how much work I can get done",
              },
              {
                id: "mo-1-3",
                pm: "I use scheduling to make the best use of time",
                pmMap: "Use scheduling to make the best use of time",
              },
              {
                id: "mo-1-4",
                pm: "I try to do my best but I do not try to do everything perfectly",
                pmMap:
                  "Try to do my best but not try to do everything perfectly",
              },
            ],
            developmentActions: [
              {
                id: "mo-1:1-a",
                da: " Become familiar with the signs of procrastination and make a list of them. Add any symptom you have noticed in yourself or others. Refer to the list at the beginning and end of a day to serve as a reminder. Some common examples include filling your day with low-priority tasks, sitting down to start a highpriority task and almost immediately taking a break, making a cup of coffee or checking your e-mails while letting too much time pass by, leaving a priority on your to-do list for a long time without addressing it, and committing yourself to helping others instead of tackling your own work.",
              },
              {
                id: "mo-1:1-b",
                da: " If a task or project is overwhelming, set small milestones which you can achieve every day or week, and reward yourself.",
              },
              {
                id: "mo-1:1-c",
                da: " Develop your action list based on specific, well-defined activities rather than outcomes. Slowly but surely you will reach your goal.",
              },
              {
                id: "mo-1:1-d",
                da: " Ask someone to check on you and measure the work you do on a specific task. It helps to know that you will be held accountable.",
              },
              {
                id: "mo-1:1-e",
                da: " Calculate the cost of your time to your employer. How much are you getting paid per day or hour? If you procrastinate and do not focus on the right things, you do not deliver value for money.",
              },
              {
                id: "mo-1:1-f",
                da: " Concentrate on results, not busy work. Monitor how long you spend each day on unimportant things that do not really contribute to your success. Do you know how much time you spend on reading junk mail, talking to colleagues, making coffee or surfing the Internet? Are you aware of when in the day you check your e-mail, write important articles or do your long-term planning?",
              },
              {
                id: "mo-1:2-a",
                da: " Delegation is a tried-and-tested time management technique. Ensure you delegate effectively to your team. Which tasks are you doing that others could do instead? If you delegate poorly, you will always be pressed for time.",
              },
              {
                id: "mo-1:2-b",
                da: " How organized are you? Organized people create systems and routines that help them to manage information. They do not waste time to look for lost files on their computers or information that definitely was on their desks somewhere.",
              },
              {
                id: "mo-1:2-c",
                da: " Try to minimize the number of times a day you switch between different types of tasks. It wastes time. For example, read and reply to e-mails once in the morning and once in the afternoon. Do your other tasks in-between.",
              },
              {
                id: "mo-1:2-d",
                da: " Use a calendar to schedule work and personal activities one to two weeks in advance. It will force you to consider and prioritize what will fill the next two weeks, and you will always be aware of the time available for you and your personal activities. It will also give you control over your schedule, instead of putting it in others' hands.",
              },
              {
                id: "mo-1:2-e",
                da: " Take advantage of any technology available to automate processes which cut into your time unnecessarily. For example, online scheduling software allows you to manage meetings efficiently without sending e-mails back and forth, because you can gauge people's availability immediately.",
              },
              {
                id: "mo-1:2-f",
                da: " Every once in a while you will have to deal with personal matters during work hours. Be sure to limit these and do them during lunch or come in earlier to handle them.",
              },
              {
                id: "mo-1:2-g",
                da: " Keep e-mails unrelated to work to a minimum. They can go back and forth and before you know it an hour has passed without doing any work.",
              },
              {
                id: "mo-1:2-h",
                da: " The lower your energy level, the easier it is to waste time by working inefficiently. Most people's energy levels fluctuate during the day. It may be related to the amount of sugar in your blood, the length of time since you last took a break, stress, boredom and so forth. Keep a log for a week to analyze when you are most productive. Be conscious of the type of activities you schedule during times you tend to feel tired versus energetic. If possible, schedule your activities accordingly. For example, if you are most alert in the morning, schedule activities that require greater focus then. You will accomplish more. Leave calls for mid-afternoon when your energy levels are lower.",
              },
              {
                id: "mo-1:2-i",
                da: " The Internet is a great resource but it can also waste too much of people's time. Be cautious not to go off on time-wasting cyber tangents. Use the Internet for relevant workrelated purposes only.",
              },
              {
                id: "mo-1:2-j",
                da: " Ensure you do not abuse the amount of time spent on activities such as making coffee or using the copier or fax machine.",
              },
              {
                id: "mo-1:2-k",
                da: " There are many resources to help you to improve your time management skills. Read books such as The Seven Habits of Highly Effective People by Stephen Covey.",
              },
              {
                id: "mo-1:2-l",
                da: " Most organizations offer some course in time management. Ask your human resources department about the options.",
              },
              {
                id: "mo-1:2-m",
                da: " Ask colleagues who manage their time well for tips.",
              },
              {
                id: "mo-1:3-a",
                da: " Ask for help or delegate. Having assistance on a project can help you to stay focused. You can spend more time on reviewing work and making sure it is up to standard.",
              },
              {
                id: "mo-1:3-b",
                da: " Consider spending money on outsourcing key tasks.",
              },
              {
                id: "mo-1:3-c",
                da: " Keep your expectations in check. Replace all-or-nothing thoughts with realistic thinking, for example: 'It may not be perfect but it doesn't have to be and I'll finish on time.'",
              },
              {
                id: "mo-1:3-d",
                da: " Ask others, especially your manager, for feedback about the quality of your work so far. They can help you to gauge whether you put undue effort into a task.",
              },
              {
                id: "mo-1:3-e",
                da: " Try to adapt your expectations to the circumstances. Many factors over which you may have no control will determine the outcome of an assignment: the amount of resources assigned, due date, complexity of work, previous experience you have had on similar projects etcetera.",
              },
              {
                id: "mo-1:3-f",
                da: " Focus on other benefits you gain from working on a project and not just doing it perfectly, such as the learning involved, having fun and the satisfaction of completing something.",
              },
              {
                id: "mo-1:3-g",
                da: " Set strict time limits on each of your projects. Move on when the time is up and attend to something else.",
              },
              {
                id: "mo-1:3-h",
                da: " Learn how to deal with criticism. Perfectionists often view criticism as a personal attack and respond defensively. Concentrate on being more objective about the criticism and yourself.",
              },
              { id: "mo-1:3-i", da: " Seek the help of a professional coach." },
              {
                id: "mo-1:4-a",
                da: " Use more logic and less emotion to make a decision, then act.",
              },
              {
                id: "mo-1:4-b",
                da: " Before taking action, always question whether tasks are absolutely necessary and whether they could be delegated or trimmed to take up less time.",
              },
              {
                id: "mo-1:4-c",
                da: " Attend a project-management training program that will familiarize you with the principles of planning and relevant software.",
              },
              {
                id: "mo-1:4-d",
                da: " Plan a tentative schedule for the week ahead. It can always be adjusted if necessary and gives you a chance to consider your priorities ahead of time. Be sure to address highpriority, urgent items as well as maintenance tasks that cannot be delegated or avoided.",
              },
              {
                id: "mo-1:4-e",
                da: " Plan for contingencies. The more unpredictable your job, the more time you need for such eventualities. Constant interruption is a reality of managers' work. Studies show that, on average, some managers work uninterruptedly for as little as six minutes at a time.",
              },
              {
                id: "mo-1:4-f",
                da: " Make time for responsibilities for which you will be assessed, for example, if you manage people, schedule time for coaching, supervision and planning. Similarly, you must allow time to communicate with your boss and the key people around you.",
              },
              {
                id: "mo-1:5-a",
                da: " Never agree to take on more responsibility if you have critical items to deal with that have not been addressed.",
              },
              {
                id: "mo-1:5-b",
                da: " Ensure you know what you are getting involved in. The task may seem easy, but things always take longer than expected.",
              },
              {
                id: "mo-1:5-c",
                da: " Before agreeing to help someone, consult your supervisor about whether it is realistic and feasible to take on the work. If your supervisor disapproves, it gives you a legitimate reason to say no.",
              },
              {
                id: "mo-1:5-d",
                da: " You may find it difficult to manage your supervisor's requests. Clearly communicate to your boss when added work will have an impact on other priorities. For example, if your boss wants your help in a crisis, you may have to put plans on hold. However, negotiate the items that will be put on hold.",
              },
              {
                id: "mo-1:6-a",
                da: " Keep your office door closed if people routinely drop by just to chat. Open it when you can or want to interact. If people still do not get the message, it is perfectly acceptable to politely let them know it is not the best time for you. If they want to talk about work but it is not urgent, schedule a time later that works for both of you. If it is personal, offer to hold the conversation over coffee or during your break.",
              },
              {
                id: "mo-1:6-b",
                da: " Whether making or receiving a call, be upfront about keeping it short and to the point. Remind the person if necessary.",
              },
              {
                id: "mo-1:6-c",
                da: " Answer phone calls and e-mails at times that make sense to you instead of trying to respond immediately.",
              },
              {
                id: "mo-1:6-d",
                da: " Be selective about the gatherings you attend. Do not attend meetings just because you are invited - are they really necessary? Can someone go in your place, represent and brief you? It is a great way to extend staff's experience.",
              },
              {
                id: "mo-1:6-e",
                da: " Inform meeting hosts that you can stay for a certain period of time and will be leaving promptly thereafter. It helps you to manage your time and forces others to comply.",
              },
            ],
          },
          {
            id: "mo-2",
            icon: require("@/assets/Iconography/Attributes/11-01_Planning Work.svg"),
            comp: "Planning work",
            wdd: "Sets definite milestones and actions for achieving goals",
            progressMeasures: [
              {
                id: "mo-2-0",
                pm: "I assess the amount of time and resources I need for processes",
                pmMap:
                  "Assess the amount of time and resources I need for processes",
              },
              {
                id: "mo-2-1",
                pm: "I ensure the resources I need are available",
                pmMap: "Ensure the resources I need are available",
              },
              {
                id: "mo-2-2",
                pm: "I document process plans in terms of milestones, timelines, resource requirements and quality standards",
                pmMap:
                  "Document process plans in terms of milestones, timelines, resource requirements and quality standards",
              },
              {
                id: "mo-2-3",
                pm: "I anticipate process risks and pitfalls to create contingency plans",
                pmMap:
                  "Anticipate process risks and pitfalls to create contingency plans",
              },
              {
                id: "mo-2-4",
                pm: "I compare actual results against those predicted to evaluate process performance and record lessons learnt",
                pmMap:
                  "Compare actual results against those predicted to evaluate process performance and record lessons learnt",
              },
            ],
            developmentActions: [
              {
                id: "mo-2:1-a",
                da: " You may not have the time to lay out an entire plan in detail, but you do not have to do it that way. Delegate different portions and then use your time to piece the information together. The key is to address the details. In addition to saving you time, team member participation can create increased support for the plan.",
              },
              {
                id: "mo-2:1-b",
                da: " Do not recreate the wheel when planning. Become familiar with planning tools available to you that give you a template for addressing details. Also look at similar projects that have been launched in the company.",
              },
              {
                id: "mo-2:1-c",
                da: " Manage the plan's scope in increments. Prepare in detail for one or two critical parts of the process and focus your planning efforts on these activities first. Create the plan for the remaining portions later.",
              },
              {
                id: "mo-2:1-d",
                da: " Ensure there are a few detail-orientated people in your team who will ask the right questions and help you to remain focused.",
              },
              {
                id: "mo-2:1-e",
                da: " Ensure you have a short-term and long-term business plan. Having a plan will force you to consider the details carefully.",
              },
              {
                id: "mo-2:2-a",
                da: " At the beginning of each project, set aside time to document your plan, even if it is a draft and bound to change as the project evolves.",
              },
              {
                id: "mo-2:2-b",
                da: " Documentation can be as basic as ink on paper, however, a documented plan in an electronic format such as word processing, spreadsheets or project management software is easy to modify and access via e-mail, shared folders etcetera.",
              },
              {
                id: "mo-2:2-c",
                da: " During the initial brainstorming and development of your plan, ask someone to act as scribe and take down notes and details which can then be transcribed.",
              },
              {
                id: "mo-2:2-d",
                da: " Always send out follow-up correspondence after an initial meeting to summarize each team member's role and responsibilities and the first action items. Documentation in the initial stage of a process is critical to provide clarity.",
              },
              {
                id: "mo-2:2-e",
                da: " Be sure to send out written correspondence detailing any changes to the plan to all parties involved. Doing so ensures everyone has instructions in writing and no one is inadvertently left in the dark.",
              },
              {
                id: "mo-2:3-a",
                da: " Develop various planning methods by researching best practices.",
              },
              {
                id: "mo-2:3-b",
                da: " Ask for input in the plan early in the process, not after it has been formalized or resources have been committed.",
              },
              {
                id: "mo-2:3-c",
                da: " Identify key people in the process who have a vested interest in the plan's success and invite them to be in your planning team.",
              },
              {
                id: "mo-2:3-d",
                da: " Define the goal of the process, and then draft a list of all tasks that must be completed, followed by who should complete each task.",
              },
              {
                id: "mo-2:3-e",
                da: " Identify tasks that can be performed concurrently with others, and those that cannot be started until one or more tasks have been completed.",
              },
              {
                id: "mo-2:3-f",
                da: " Determine the required resources, for example, personnel time, funding, equipment, materials, software and space, as well as the person who can authorize the use of each resource in the process. Can you secure all your necessary resources, including each staff member's time? Are these people and other resources available at the intervals required by the plan?",
              },
              {
                id: "mo-2:3-g",
                da: " Identify any risks, for example, bottlenecks, competing projects, scheduling issues and scarce resources, and plan for contingencies.",
              },
              {
                id: "mo-2:3-h",
                da: " Determine milestones and define how you will measure the process success.",
              },
              {
                id: "mo-2:3-i",
                da: " Evaluate your actual results against your goals, for example, being on time and budget, quality checks, resource allocation and so forth.",
              },
              {
                id: "mo-2:3-j",
                da: " Discuss, document and share lessons learnt with your team and others who could benefit. You and your team's experiences can help to save planning time, improve resource estimations and make more accurate predictions of potential future risks for your organization.",
              },
              {
                id: "mo-2:3-k",
                da: " Celebrate accomplishments with your team and give praise, if appropriate.",
              },
              {
                id: "mo-2:3-l",
                da: " Find a person in the organization who you respect and who will share lessons from both successful and unsuccessful work or planning experiences. It is invaluable to listen to what others have been through.",
              },
              {
                id: "mo-2:4-a",
                da: " If you are in a leadership position, reward and encourage individuals who are good at planning.",
              },
              {
                id: "mo-2:4-b",
                da: " Personally investing time in planning will set an example and send a strong message to others that it is valued in the organization.",
              },
              {
                id: "mo-2:4-c",
                da: " Support project management training for your employees.",
              },
              {
                id: "mo-2:4-d",
                da: " Discuss with your boss and other team members the benefits that were realized by having planned properly.",
              },
              {
                id: "mo-2:4-e",
                da: " Talk to your boss about your need for a plan. Everyone has different work styles and some managers will assume you are comfortable to operate without one if you do not speak out.",
              },
              {
                id: "mo-2:4-f",
                da: " Be persistent in discussions and meetings about details that have to be considered. Present them in a way that makes a good business case. Even if they are overlooked, you have used your insight to provide valuable information.",
              },
              {
                id: "mo-2:4-g",
                da: " Keep notes of lesson learnt throughout the process, and ask your team to do the same. This practice can be communicated during an initial meeting or via an e-mail and supported by e-mail reminders to your team.",
              },
              {
                id: "mo-2:4-h",
                da: " Formalize debriefing sessions, if possible, and share lessons learnt with others in the company so that these are considered before others forge ahead on their projects. Compare your plan's goals against the actual results, for example, budget, timelines, milestones, resource allocation, quality etcetera.",
              },
            ],
          },
        ],
      },
      sd: {
        characteristic: "Decision Making",
        wdd: "Making decisions, even in the absence of complete data; exercising good judgment when making decisions while taking into account both facts and personal experience; prioritizing between critical and less important tasks; accurately identifying strengths, weaknesses and potential in people with relatively short exposure to them.",
        icon: require("@/assets/Iconography/Characteristics/17_Sound Decision Maker.svg"),
        competencies: [
          {
            id: "sd-0",
            icon: require("@/assets/Iconography/Attributes/17-04_Demonstrating Good Judgement.svg"),
            comp: "Demonstrating good judgement",
            wdd: "Exercises good judgment when making decisions and takes into account both facts and personal experience",
            progressMeasures: [
              {
                id: "sd-0-0",
                pm: "People tend to ask me for advice",
                pmMap: "Provide useful advice to people when asked",
              },
              {
                id: "sd-0-1",
                pm: "I trust my intuition",
                pmMap: "Trust my intuition",
              },
              {
                id: "sd-0-2",
                pm: "I am not unduly influenced by what others think",
                pmMap: "Not be unduly influenced by what others think",
              },
              {
                id: "sd-0-3",
                pm: "I consider consequences carefully when making a decision",
                pmMap: "Consider consequences carefully when making a decision",
              },
            ],
            developmentActions: [
              {
                id: "sd-0:1-a",
                da: " Do not go with your first impulse. It is wise to get out for a break, take a walk or sleep on it. Do whatever makes sense to give you time to make a good judgment call.",
              },
              {
                id: "sd-0:1-b",
                da: " Consider multiple potential scenarios and not just the obvious ones. Entertain several 'what if?' questions.",
              },
              {
                id: "sd-0:1-c",
                da: " Consider carefully what the consequences of your decision will be for all the stakeholders involved yourself, the client, team members and your organization.",
              },
              {
                id: "sd-0:1-d",
                da: " What are the consequences of your decision in the short term and long term?",
              },
              {
                id: "sd-0:1-e",
                da: " Assemble a team of people to provide alternative perspectives and help you approach the problem thoroughly and from different angles. Brainstorming can help you flesh out the complexities of the problem.",
              },
              {
                id: "sd-0:1-f",
                da: " Look for case samples of similar issues and grasp the parallels and differences with your issue.",
              },
              {
                id: "sd-0:1-g",
                da: " Display the options visually, using tools such as a flow chart or software such as MindJet's Mind Manager.",
              },
              {
                id: "sd-0:2-a",
                da: " Consider the immediate and potential gains or losses when making a choice.",
              },
              {
                id: "sd-0:2-b",
                da: " Understand the impact on your stakeholders.",
              },
              {
                id: "sd-0:2-c",
                da: " Pay attention to warnings or red flags raised by others. Log these if you cannot investigate immediately but be sure to go back to give them careful consideration.",
              },
              {
                id: "sd-0:2-d",
                da: " Ask a trusted colleague to help you regain focus if you feel you are concentrating on irrelevant information or issues.",
              },
              {
                id: "sd-0:2-e",
                da: " Learn from other people's experience. Ask peers or experts to share the regrets they may have over a similar situation and how they would have changed their decisions.",
              },
              {
                id: "sd-0:2-f",
                da: " Weigh the opinions of trusted peers. Ultimately, it is your decision, but multiple perspectives could shed light on issues you have not even considered.",
              },
              {
                id: "sd-0:2-g",
                da: " Do not focus on just one aspect of a situation, for example, technical matters. Gather your information from as many diverse sources as possible.",
              },
              {
                id: "sd-0:2-h",
                da: " Learn from your experiences by taking time to reflect on them before, during and after your assignments. Keep a journal. What did you learn that you had not realized before? What surprised you? Which good decisions were made and which were ineffective?",
              },
              {
                id: "sd-0:2-i",
                da: " Apply common sense in your judgment. Getting caught up in too many details or investing time going in one direction only can cloud your perspective and make you lose sight of an obvious, simple solution.",
              },
              {
                id: "sd-0:3-a",
                da: " Trust your intuition. If you have completed due diligence and a strong gut feeling is guiding you, your judgment is as valid as the other person's.",
              },
              {
                id: "sd-0:3-b",
                da: " Limit the number of people you ask for opinions to a trusted few.",
              },
              {
                id: "sd-0:3-c",
                da: " Try to anticipate people's resistance and prepare answers to defend your judgment. Having carefully examined possible objections enables you to defend your decision with confidence.",
              },
              {
                id: "sd-0:3-d",
                da: " When making a decision, take a step back and ask yourself whether it makes sense. It is easy to get swayed by classic textbook solutions, but they may be irrelevant in the context of your situation.",
              },
              {
                id: "sd-0:3-e",
                da: " Do not overlook the ethics of your judgment. If you feel your values are compromised, you must explore the issue further until you are comfortable.",
              },
              {
                id: "sd-0:3-f",
                da: " Be aware of other people's motives. You may be supporting their personal agendas without realizing it.",
              },
              {
                id: "sd-0:3-g",
                da: " Once you have considered all the information and made a decision, do not ask other people's opinions again. You did that before making your decision.",
              },
              {
                id: "sd-0:4-a",
                da: " Be honest with others and yourself about your personal motives. It gives them the opportunity to creatively find a mutual solution with you.",
              },
              {
                id: "sd-0:4-b",
                da: " Weigh carefully the value of getting your needs met versus the consequences of your decision.",
              },
              {
                id: "sd-0:4-c",
                da: " Base your judgment of a situation on logic instead of emotion. Regardless of how strong your personal motives are, is your decision a sound one?",
              },
              {
                id: "sd-0:4-d",
                da: " Ask a mentor or someone who knows you well whether they think your decision is unduly influenced by your personal motives.",
              },
              {
                id: "sd-0:4-e",
                da: " Ask yourself if your decision will make sense to everyone else too. If it does not, you need to look more closely at how you have arrived at your decision.",
              },
            ],
          },
          {
            id: "sd-1",
            icon: require("@/assets/Iconography/Attributes/17-03_Focusing on Priorities.svg"),
            comp: "Focusing on priorities",
            wdd: "Differentiates between critical and less important priorities",
            progressMeasures: [
              {
                id: "sd-1-0",
                pm: "I have a clear picture every day of what I need to accomplish",
                pmMap:
                  "Have a clear picture every day of what I need to accomplish",
              },
              {
                id: "sd-1-1",
                pm: "I prioritize mission-critical activities and organize my time accordingly",
                pmMap:
                  "Prioritize mission-critical activities and organize my time accordingly",
              },
              {
                id: "sd-1-2",
                pm: "I am not easily distracted from my priorities",
                pmMap: "Not be easily distracted from my priorities",
              },
              {
                id: "sd-1-3",
                pm: "I can sort through information quickly to get to the point",
                pmMap: "Sort through information quickly to get to the point",
              },
            ],
            developmentActions: [
              {
                id: "sd-1:1-a",
                da: " Do an end-of-day evaluation for a week. Write down the things on which you spent your time. How many of these were actually related to your goals? Which distractions prevented you from being more focused? Adopt a solution for your top distractions. For example, many people get sidetracked by checking e-mails. If this is your Achilles' heel, allow yourself to check e-mails twice a day only and respond to them only once you have dedicated proper time to your critical goals.",
              },
              {
                id: "sd-1:1-b",
                da: " Get creative about ensuring that you have some uninterrupted time every day to think through complex issues and reflect on what has been discussed. For example, make your schedule flexible and go to work early or leave late, keep your door shut to discourage interruptions and, if possible, work outside of the office for a few hours.",
              },
              {
                id: "sd-1:1-c",
                da: " Make sure you are not allotting most of your time to activities you find enjoyable or easy. Try to first do the things that you find hard to do.",
              },
              {
                id: "sd-1:1-d",
                da: " Discern what is really urgent. Is the task important to accomplishing your goal or must it be done to accomplish someone else's? Delegate the tasks that must be completed immediately but can be done by someone else.",
              },
              {
                id: "sd-1:1-e",
                da: " Politely excuse yourself from lengthy conversations that are going nowhere and are not directly related to your goal. Your time and priorities are just as important as the other person's.",
              },
              {
                id: "sd-1:2-a",
                da: " When examining an issue, always ask your own questions first and try to derive at your own conclusions independently of others. Once you have done this, you can contribute to and remain open-minded about the opinions of a larger group.",
              },
              {
                id: "sd-1:2-b",
                da: " If you feel strongly about a course of action but anticipate resistance, be sure to build appropriate support for your case. Get feedback from experts on the subject that will support your findings or suggestions and present a well-documented business case with as much detail as possible.",
              },
              {
                id: "sd-1:2-c",
                da: " Speak out if necessary, even if it makes you or others uncomfortable. Not offering input means you cannot fault the results if the group takes the wrong course of action.",
              },
              {
                id: "sd-1:2-d",
                da: " Assume the role of devil's advocate. This gives you the opportunity to consider and provide dissenting opinion and, in so doing, serves a key function in helping the group to consider alternatives.",
              },
              {
                id: "sd-1:2-e",
                da: " Agree to assist someone only if you can realistically add it to your workload.",
              },
              {
                id: "sd-1:2-f",
                da: " Practice saying no politely. The more you do so the more comfortable you will get with establishing boundaries.",
              },
              {
                id: "sd-1:3-a",
                da: " Revisit your strategy several times throughout a project to assess if there are any changes in assumptions, resources or circumstances that require you to adjust your focus. Be open to feedback.",
              },
              {
                id: "sd-1:3-b",
                da: " An important role of the person providing you with oversight is to help guide that on which you need to focus. Periodically, get feedback on whether you should adjust your priorities.",
              },
              {
                id: "sd-1:3-c",
                da: " Do not spend all your time on one project or assignment. Take a break from it and work on another assignment for a while. Getting away from the details helps to give you perspective on what is really important.",
              },
              {
                id: "sd-1:4-a",
                da: " Seek clarity and direction before getting into the details of any project. Do you and your team really know what you are supposed to do? Do you have ample instructions to proceed on your own? Define your goal.",
              },
              {
                id: "sd-1:4-b",
                da: " If you do not already have a yearly work plan, meet with your superior to develop one with specific goals and targets. Agree to revisit your work plan on occasion to adopt any necessary changes.",
              },
              {
                id: "sd-1:4-c",
                da: " If you are confused about your progress, ask for assistance in time. It is more productive to be honest about needing help than to spin your wheels and waste time and resources going in the wrong direction.",
              },
              {
                id: "sd-1:4-d",
                da: " Keep your boss and team members informed and up to date with your progress. Without feedback, you may not realize you are going in the wrong direction. You could do this with a weekly e-mail, for example.",
              },
              {
                id: "sd-1:4-e",
                da: " Resist the temptation to finish the assignment completely before discussing your progress with someone. You may waste much energy perfecting something that has to be redone.",
              },
              {
                id: "sd-1:5-a",
                da: " Practice your delegation skills. Be selective about what really needs your attention and delegate the rest to others. Assess how important a task is. You may not be able to delegate presenting to the board but you can certainly delegate researching data for the presentation.",
              },
              {
                id: "sd-1:5-b",
                da: " Stay well informed about your subordinates' workload. You should not be in a position in which you are overwhelmed and team members or subordinates are idle.",
              },
              {
                id: "sd-1:5-c",
                da: " Assess and be realistic about whether you can get the task done quicker with your current workload or should assign it to someone else.",
              },
              {
                id: "sd-1:5-d",
                da: " Work as a team player instead of an independent achiever. You can always get more work done by managing or being part of a collaborative team.",
              },
            ],
          },
          {
            id: "sd-2",
            icon: require("@/assets/Iconography/Attributes/17-02_Recognizing Talent and Potential.svg"),
            comp: "Recognizing talent and potential",
            wdd: "Accurately identifies strengths, weaknesses and potential in people with relatively short exposure to them",
            progressMeasures: [
              {
                id: "sd-2-0",
                pm: "I am a good judge of other peoples strengths and weaknesses",
                pmMap:
                  "Be a good judge of other peoples strengths and weaknesses",
              },
              {
                id: "sd-2-1",
                pm: "I can spot potential in others before they recognize it in themselves",
                pmMap:
                  "Spot potential in others before they recognize it in themselves",
              },
              {
                id: "sd-2-2",
                pm: "I can usually get an accurate reading of people in a short time",
                pmMap: "Get an accurate reading of people in a short time",
              },
              {
                id: "sd-2-3",
                pm: "I use all information available to make judgments about people",
                pmMap:
                  "Use all information available to make judgments about people",
              },
            ],
            developmentActions: [
              {
                id: "sd-2:1-a",
                da: " Consult with the human resources department to ensure the behavioral competencies, technical skills and experience needed for the job have been clearly and accurately defined.",
              },
              {
                id: "sd-2:1-b",
                da: " Broaden your perspective of how well a person will suit a position by considering how they will fare within its context.",
              },
              {
                id: "sd-2:1-c",
                da: " Examine results from assessments such as 360Â° feedback, which can provide fresh insight into people. It will give you an understanding of a person's strengths and weaknesses. Talk to HR about other feedback tools you can use.",
              },
              {
                id: "sd-2:1-d",
                da: " Research shows behavioral interviewing is the most effective. Learn about this method of interviewing and talk to HR if it is not yet used in your company. Read about effective interviewing skills.",
              },
              {
                id: "sd-2:1-e",
                da: " Ensure your team is balanced by recruiting people with diverse talents.",
              },
              {
                id: "sd-2:1-f",
                da: " Become involved in the actual hiring process. It will help you to gain valuable experience in sharpening your intuition about people and understanding how to ask effective questions that reveal strengths and weaknesses.",
              },
              {
                id: "sd-2:1-g",
                da: " Ensure that, during hiring, rigorous processes, techniques and standardized structures are applied.",
              },
              {
                id: "sd-2:2-a",
                da: " Give people who are new to assignments enough time to adapt within their new context before making judgments.",
              },
              {
                id: "sd-2:2-b",
                da: " Discover others' knowledge about an employee through 360Â° feedback or other multisource assessment tools. It is especially useful if someone is a new recruit or has just been assigned to you.",
              },
              {
                id: "sd-2:2-c",
                da: " Talk to your human resources department about the 9-Cell Matrix, which helps to predict performance. This process provides clues about how people are likely to perform in an organization.",
              },
              {
                id: "sd-2:2-d",
                da: " Encourage subordinates to be honest with you. People who are given the opportunity and a safe environment to do so will share information that can help you to understand their interests and strengths better. Ask about projects they have worked on previously and why these were successful or not. Enquire about experiences and skills they may have of which you have been unaware. Ask open-ended questions about what they find the most challenging or rewarding.",
              },
              {
                id: "sd-2:2-e",
                da: " An effective way to get to know someone's strengths and weaknesses is to give them assignments that challenge them in a variety of areas. Rotate people among assignments until you understand their talents and flaws. Avoid repeatedly using the same person to do a particular set of tasks.",
              },
              {
                id: "sd-2:2-f",
                da: " Collect feedback from other managers with whom an employee has worked in the past. What is their perspective of the individual's strengths and weaknesses? It can give you some idea of the person's performance in different contexts.",
              },
              {
                id: "sd-2:3-a",
                da: " Encourage an open culture in which people feel comfortable to be honest during assessments.",
              },
              {
                id: "sd-2:3-b",
                da: " Reward self-awareness and development efforts in those you manage so that they are more forthcoming about their flaws and willing to work on them.",
              },
              {
                id: "sd-2:3-c",
                da: " Keep accurate records of a person's performance and behavior so that you can back up an unpopular assessment with facts, rather than opinion.",
              },
              {
                id: "sd-2:3-d",
                da: " Consult your manager or human resources department for support and advice if you are worried about a particular assessment you have to conduct.",
              },
              {
                id: "sd-2:3-e",
                da: " Ensure you have set clear goals and objectives for subordinates. You will be able to use these as a reference to discuss whether they have been met.",
              },
              {
                id: "sd-2:4-a",
                da: " Do not stay at your desk or in your office all day long. Take time throughout your workday, even if only for a few minutes, to interact one on one with subordinates or peers.",
              },
              {
                id: "sd-2:4-b",
                da: " Take advantage of meetings and staff get-togethers to observe how people behave. Note differences in how individuals interact in a group versus alone.",
              },
              {
                id: "sd-2:4-c",
                da: " Question your understanding of your peers or those you supervise. Try to describe the role that each person plays in your work life, for example, coordinator, follower and leader. Write down exactly what you know about each person. Six months later, revisit the description to see if it differs now that you have observed it further. Did you notice something that confirmed your opinion or changed your mind?",
              },
              {
                id: "sd-2:4-d",
                da: " When possible, spend time with colleagues in informal and social settings. People are often guarded at work, which makes it difficult to get to know them.",
              },
              {
                id: "sd-2:4-e",
                da: " Volunteer to work on a team project that will allow you to interact with others regularly.",
              },
              {
                id: "sd-2:4-f",
                da: " Go to lunch with colleagues. Leave your desk.",
              },
              {
                id: "sd-2:4-g",
                da: " Become an active observer of people - do some 'people watching'. Humans have nuance that assessments cannot detect. Spend enough time with colleagues to be able to get a feel for the subtleties that make them unique. If possible, make time to get to know them outside of work. Have coffee or attend company functions together, for example.",
              },
              {
                id: "sd-2:5-a",
                da: " Give people a chance. Meet with them several times before you judge.",
              },
              {
                id: "sd-2:5-b",
                da: " Measure your impression of someone by asking others what they think. You may be surprised to hear quite different opinions.",
              },
              {
                id: "sd-2:5-c",
                da: " Get to know the people you find the hardest to read. What makes them a particularly difficult challenge? If they do not talk much, for example, invite them to a setting where they can feel more comfortable to express themselves, say, lunch or a round of golf.",
              },
              {
                id: "sd-2:5-d",
                da: " Undertake an exercise to compare people you know well now with your first impression of them. What is different? What do you know about them now that you did you not notice at first? Did you read them right the first time? If not, why not?",
              },
              {
                id: "sd-2:5-e",
                da: " Express in writing how someone might read you. Ask peers their first impression of you and if and how it has changed.",
              },
              {
                id: "sd-2:5-f",
                da: " If you find it difficult to discard a first impression of someone, make a list of all the positive attributes the person has, such as skills and experiences they add to your team.",
              },
            ],
          },
          {
            id: "sd-3",
            icon: require("@/assets/Iconography/Attributes/17-01_Acting Decisively.svg"),
            comp: "Acting decisively",
            wdd: "Makes decisions quickly, even in the absence of complete data",
            progressMeasures: [
              {
                id: "sd-3-0",
                pm: "I do not need an extensive amount of information to make a  decision",
                pmMap:
                  "Not need an extensive amount of information to make a  decision",
              },
              {
                id: "sd-3-1",
                pm: "I do not put off unpleasant decisions",
                pmMap: "Not put off unpleasant decisions",
              },
              {
                id: "sd-3-2",
                pm: "I do not need many people’s involvement to make a decision",
                pmMap: "Not need many people’s involvement to make a decision",
              },
              {
                id: "sd-3-3",
                pm: "I do not worry excessively about the consequences of my decision",
                pmMap:
                  "Not worry excessively about the consequences of my decision",
              },
            ],
            developmentActions: [
              {
                id: "sd-3:1-a",
                da: " Work smart. Prioritize the information that is absolutely necessary and would be good to have, and spend your valuable time collecting the former.",
              },
              {
                id: "sd-3:1-b",
                da: " Split a big decision into smaller ones. Instead of focusing on getting all the information before you start a project, concentrate on the information needed to make smaller decisions. Treat each small decision as another piece of information you have gathered.",
              },
              {
                id: "sd-3:1-c",
                da: " Give yourself a deadline for research and commit to making a decision by then, based on the facts you have available.",
              },
              {
                id: "sd-3:1-d",
                da: " Sharpen and trust your intuition. In his book Blink, Malcolm Gladwell makes a strong argument for the benefits and accuracy involved in making decisions that are based on intuition. Find a workshop that can help you to get in touch with your intuition.",
              },
              {
                id: "sd-3:1-e",
                da: " Ask a trusted peer about the last decision they made guided by their intuition. You will begin to see how often people in business successfully rely on their intuition when making decisions.",
              },
              {
                id: "sd-3:1-f",
                da: " Practice making quick decisions about small issues that have little consequence.",
              },
              {
                id: "sd-3:2-a",
                da: " Share your decision with a trusted peer to gain assurance. Use the person as a sounding board or to support your decision.",
              },
              {
                id: "sd-3:2-b",
                da: " Draw a decision tree with all the pros and cons. This will help to map your options and engage in a logical and not emotional approach.",
              },
              {
                id: "sd-3:2-c",
                da: " If you are procrastinating about a decision, you are suffering unnecessarily. Sooner or later the decision will have to be made, so why not do it sooner? Get it over and done with. Commit to a time frame for making the decision and tell other people so that you feel accountable.",
              },
              {
                id: "sd-3:2-d",
                da: " By not making a decision, you are making one already (to not do anything",
              },
              {
                id: "sd-3:2-e",
                da: " If you are deliberating unreasonably about a decision, ask yourself: 'Is this decision going to have a long-lasting effect on my life, the lives of others or the world in general?' If the answer is no, you can live with the consequences of the decision.",
              },
              {
                id: "sd-3:2-f",
                da: " If your decision has great consequences, do not tackle it alone. Get other stakeholders involved in the decision-making process.",
              },
              {
                id: "sd-3:2-g",
                da: " The long-term effects of chronic worry have been well researched and proven to have negative effects on your health. Ask yourself whether deliberating so much about the decision is damaging your health.",
              },
              {
                id: "sd-3:3-a",
                da: " If you can only focus on one specific area, take time beforehand to delegate work that others could be doing in the meantime. Delegation allows your project to move forward even if there are setbacks in one area.",
              },
              {
                id: "sd-3:3-b",
                da: " Become proficient at multitasking. Being well organized is the key. Do you have an orderly system that keeps all your responsibilities documented and accessible for daily viewing? Prioritize so that you know what needs your immediate attention and what can wait. Continue to reprioritize as new demands arise.",
              },
              {
                id: "sd-3:3-c",
                da: " Keep sight of the bigger picture. As long as the general direction is forward, it is to be expected that some items will have to be put on hold.",
              },
              {
                id: "sd-3:3-d",
                da: " Instead of rewarding yourself once you have completed a project, wait until you have tackled a series of assignments within a predefined time frame.",
              },
              { id: "sd-3:3-e", da: " Work as a team when possible." },
              {
                id: "sd-3:4-a",
                da: " Be honest with yourself. Ask whether you want to involve others for reassurance or because it will add value to the decision.",
              },
              {
                id: "sd-3:4-b",
                da: " If you are trying to reach a consensus, make sure only the appropriate stakeholders are involved in discussions to reduce distracting 'noise'. Write down a list that specifies the value each person will add.",
              },
              {
                id: "sd-3:4-c",
                da: " Solicit input from others. Give specific deadlines for feedback and announce a final deadline for when your decision will be made. And, of course, stick to that deadline.",
              },
            ],
          },
        ],
      },
      pm: {
        characteristic: "Leadership",
        wdd: "Providing clear objectives and instructions to others; assigning meaningful and important tasks and responsibilities to others and giving them authority to act; putting useful and meaningful measures in place to monitor work processes.",
        icon: require("@/assets/Iconography/Characteristics/12_People Manager.svg"),
        competencies: [
          {
            id: "pm-0",
            icon: require("@/assets/Iconography/Attributes/12-03_Empowering People.svg"),
            comp: "Empowering people",
            wdd: "Assigns meaningful and important tasks and responsibilities to others and gives them authority to act",
            progressMeasures: [
              {
                id: "pm-0-0",
                pm: "I give people the authority to make decisions without my approval",
                pmMap:
                  "Give people the authority to make decisions without my approval",
              },
              {
                id: "pm-0-1",
                pm: "I support other people’s decisions once they have made them",
                pmMap:
                  "Support other people’s decisions once they have made them",
              },
              {
                id: "pm-0-2",
                pm: "I remain composed and reassure people when they make mistakes",
                pmMap:
                  "Remain composed and reassure people when they make mistakes",
              },
              {
                id: "pm-0-3",
                pm: "I consider carefully the type of resources and support a person may need to complete an assignment successfully",
                pmMap:
                  "Carefully consider the type of resources and support a person may need to complete an assignment successfully",
              },
              {
                id: "pm-0-4",
                pm: "I delegate meaningful responsibilities to others, not tasks just to keep them busy",
                pmMap:
                  "Delegate meaningful responsibilities to others, not tasks just to keep them busy",
              },
            ],
            developmentActions: [
              {
                id: "pm-0:1-a",
                da: " Focus on the process and not only the people. Set your controls by planning work processes well. Invest time beforehand to lay out clear timeframes, goals and instructions. Once you have provided directives, allow people to follow them and test your controls.",
              },
              {
                id: "pm-0:1-b",
                da: " Give people tasks that are meaningful, not just stuff to keep them busy. Be sure to also give individuals the sort of responsibility that would make a difference in their careers.",
              },
              {
                id: "pm-0:1-c",
                da: " Use assessment tools to better understand the talent and strengths of individuals in your team, and delegate accordingly. For example, someone with strong persuasion skills can be assigned to lead the negotiation phase of an assignment.",
              },
              {
                id: "pm-0:1-d",
                da: " Ask people what they would like to do and give them opportunities to explore that interest.",
              },
              {
                id: "pm-0:1-e",
                da: " Delegate equitably. Examine to whom it is you usually delegate and why. Leaders have a tendency to delegate to those who have performed well previously, at the expense of others who may do just as well with a little more guidance.",
              },
              {
                id: "pm-0:1-f",
                da: " Consider experience level, timeframes and resources available when delegating an assignment. Ensure your expectations are realistic, based on all of the above, so that you do not set someone up for failure. Impossible tasks do not empower people.",
              },
              {
                id: "pm-0:2-a",
                da: " Verbalize clearly to subordinates that you give them authority to make decisions on their own. Having responsibilities is not empowering if one has to run every decision by one's manager. By nature, people are cautious about making wrong decisions, so if in doubt they will probably ask for approval.",
              },
              {
                id: "pm-0:2-b",
                da: " Establish a culture of trust. Make it clear that people are expected to manage their own work and that you are available when they need assistance.",
              },
              {
                id: "pm-0:2-c",
                da: " Agree to checkpoints in the process where you will review a person's work. In between these points, refrain from crowding the person.",
              },
              {
                id: "pm-0:2-d",
                da: " Regardless of how much you would want a task to be done in a particular way, remind yourself that there are many approaches. You may learn something new if you give someone freedom.",
              },
              {
                id: "pm-0:2-e",
                da: " If you are uncomfortable giving a person responsibility, team them with a stronger performer. Help them to evaluate the experience once the project is finished.",
              },
              {
                id: "pm-0:2-f",
                da: " Assume that extra time will be needed when someone is new to an assignment or testing new skills. It gives the person room to succeed in their assignment and learn at the same time.",
              },
              {
                id: "pm-0:2-g",
                da: " Delegate meaningful responsibilities that have a substantial impact. Constantly getting menial tasks is demoralizing and does little to empower people.",
              },
              {
                id: "pm-0:2-h",
                da: " During delegation you may well discover someone who does not perform in a certain area. Use this as an opportunity to discover their strengths or find the necessary interventions. If someone continually underperforms, despite your best attempts, you can choose development, reassignment, or let the person go.",
              },
              {
                id: "pm-0:3-a",
                da: " Take the lead in your team when it is sensible to do so. It is not always necessary to wait for your supervisor to delegate. Coordinate with your peers which tasks each will do and encourage others to cultivate new skills.",
              },
              {
                id: "pm-0:3-b",
                da: " If you are particularly skilled in an area, invite other team members to work with you on that aspect.",
              },
              {
                id: "pm-0:3-c",
                da: " Readily share interesting and new information or insights you have recently acquired.",
              },
              {
                id: "pm-0:3-d",
                da: " Observe other leaders who are good at empowering their team. Note what the person does well. Ask why people like working for that person.",
              },
              {
                id: "pm-0:3-e",
                da: " Tell your manager that you would like to gain experience in managing others and discuss the opportunities for you to do so. You may be assigned as team leader on a particular project, or perhaps serve in a special committee. Ask for increased authority in decision making and delegation.",
              },
              {
                id: "pm-0:3-f",
                da: " There are many opportunities to empower others outside of work. Practice your empowerment skills with your family members and through any groups or associations in which you are involved.",
              },
            ],
          },
          {
            id: "pm-1",
            icon: require("@/assets/Iconography/Attributes/12-02_Monitoring Work.svg"),
            comp: "Monitoring work",
            wdd: "Puts useful and meaningful measures in place to monitor work processes",
            progressMeasures: [
              {
                id: "pm-1-0",
                pm: "I set milestones for each significant target in a process",
                pmMap:
                  "Set milestones for each significant target in a process",
              },
              {
                id: "pm-1-1",
                pm: "I consult others for their input and perceptions about how work is progressing",
                pmMap:
                  "Consult others for their input and perceptions about how work is progressing",
              },
              {
                id: "pm-1-2",
                pm: "I provide regular feedback to others so that adjustments can be made throughout the process",
                pmMap:
                  "Provide regular feedback to others so that adjustments can be made throughout the process",
              },
              {
                id: "pm-1-3",
                pm: "When necessary, I recalculate schedules and reset milestones as outcomes dictate",
                pmMap:
                  "Recalculate schedules and reset milestones as outcomes dictate",
              },
              {
                id: "pm-1-4",
                pm: "I believe it is as important to monitor work progress as it is to have a plan",
                pmMap: "Monitor work progress against a plan",
              },
            ],
            developmentActions: [
              {
                id: "pm-1:1-a",
                da: " Develop a communication plan for regular dialogue with your team regarding the process's status and necessary modifications. This can take the form of weekly updating e-mails, formal meetings or informal conversations, shared folders for pertinent documents etcetera. Regular feedback ensures that people have direction along the way.",
              },
              {
                id: "pm-1:1-b",
                da: " Look for less obvious signs of problems in the process. For example, people may be meeting deadlines but feel undue stress, or lack essential resources, which can be demoralizing and cause burnout.",
              },
              {
                id: "pm-1:1-c",
                da: " Post and distribute a progress report, using a Gantt chart, project management evaluation and review technique (PERT",
              },
              {
                id: "pm-1:1-d",
                da: " Be sure to monitor processes more closely at the beginning of a project, until you are comfortable that everyone understands their roles and has clear direction.",
              },
              {
                id: "pm-1:1-e",
                da: " Verify that milestones are achieved and that tasks are on schedule and budget.",
              },
              {
                id: "pm-1:1-f",
                da: " Ensure that people are honest about the status of their tasks - ask them to show you the work they have completed so far. People may be reluctant to tell you their work status if they have fallen behind. Trust your instincts. You may discover that your team needs more resources or better clarification of tasks.",
              },
              {
                id: "pm-1:1-g",
                da: " Arrange a debriefing to document and discuss lessons learnt so that people know how to work more effectively in the future. Share these lessons with others in your organization as well.",
              },
              {
                id: "pm-1:2-a",
                da: " Nurture an environment in which you are regularly informed. Let people know it is important that they keep you up to date with their status without you having to solicit the information. For example, ask people to routinely send you brief status e-mails.",
              },
              {
                id: "pm-1:2-b",
                da: " Set up systems that facilitate quick monitoring, for example, utilize shared project management tools to quickly review online the status of milestones and budgets.",
              },
              {
                id: "pm-1:2-c",
                da: " If monitoring is difficult to manage on your own, delegate different aspects of the process to the team and hold debriefing meetings regularly.",
              },
              {
                id: "pm-1:2-d",
                da: " Invest more time in the beginning of the process, when more direction is needed, so that less of your time is required later.",
              },
              {
                id: "pm-1:2-e",
                da: " Limit the amount of time you spend with people who are giving you a status update. Do not let them ramble on or talk about irrelevant issues.",
              },
              {
                id: "pm-1:3-a",
                da: " Become involved in an assignment that involves planning and offer to work with your boss or other team members to establish milestones and progress measures.",
              },
              {
                id: "pm-1:3-b",
                da: " Do research and evaluate best practices for monitoring processes and their improvement.",
              },
              {
                id: "pm-1:3-c",
                da: " Become familiar with tools available to you, such as progress reports or charts (Gantt, PERT or CPM",
              },
              {
                id: "pm-1:3-d",
                da: " Utilize non-threatening methods of monitoring at first, such as debriefings, and then introduce more structured practices when people will accept them more easily.",
              },
              {
                id: "pm-1:3-e",
                da: " Find a respected person in the organization who will share their lessons in both successful and unsuccessful workflow monitoring with you. Although it is not a substitute for personal experience, it is useful to listen to what others have experienced.",
              },
              {
                id: "pm-1:3-f",
                da: " Document the lessons learnt from your experiences for use in monitoring future processes: what should have happened, could have been avoided or done differently?",
              },
            ],
          },
          {
            id: "pm-2",
            icon: require("@/assets/Iconography/Attributes/12-01_Directing People.svg"),
            comp: "Directing people",
            wdd: "Provides clear objectives and instructions to others",
            progressMeasures: [
              {
                id: "pm-2-0",
                pm: "People are able to follow my instructions",
                pmMap:
                  "Provide clear instructions that people are able to follow",
              },
              {
                id: "pm-2-1",
                pm: "People rarely misunderstand what I want or need from them",
                pmMap:
                  "Clearly make people  understand what I want or need from them",
              },
              {
                id: "pm-2-2",
                pm: "When I give instructions, I ask questions to ensure they have been understood",
                pmMap:
                  "Ask questions to ensure they have been understood when I give instructions to others",
              },
              {
                id: "pm-2-3",
                pm: "I am comfortable stepping in to provide direction",
                pmMap: "Feel comfortable stepping in and provide direction",
              },
              {
                id: "pm-2-4",
                pm: "I do not wait until people are struggling before I provide direction",
                pmMap:
                  "Not wait until people are struggling before I provide direction",
              },
            ],
            developmentActions: [
              {
                id: "pm-2:1-a",
                da: " Try to motivate people while instructing them. Give direction enthusiastically and point out the advantage of doing things a certain way.",
              },
              {
                id: "pm-2:1-b",
                da: " Be as inclusive as possible when providing direction, especially when resistant individuals are involved. Welcome their suggestions and let them know their feedback is valuable.",
              },
              {
                id: "pm-2:1-c",
                da: " Watch your tone of voice and mannerisms to ensure you do not seem bossy. This is particularly important if you are uncomfortable or tense. A person under stress often sends the wrong message inadvertently.",
              },
              {
                id: "pm-2:1-d",
                da: " By their very nature, some people are intimidating. If you have to provide them with direction, get to know them on an individual level. It will help you to make a connection with them and is likely to dispel some of your preconceived ideas.",
              },
              {
                id: "pm-2:1-e",
                da: " If people get defensive while getting instructions, remain composed and do not take things personally. The goal is to get them to move forward in a productive manner and with an appropriate mindset. Try to find out what makes them defensive by talking privately to each person. Ignoring their attitude will not make it go away, and it will become increasingly difficult for you to provide direction without meeting resistance. Show people that you care about the fact that something is bothering them.",
              },
              {
                id: "pm-2:2-a",
                da: " Schedule time to check in with each individual periodically, even if not for assistance.",
              },
              {
                id: "pm-2:2-b",
                da: " Never assume everyone works well independently. Some people simply require more direction than others, and when they get it they perform well.",
              },
              {
                id: "pm-2:2-c",
                da: " Get to know your team. People have different styles and needs, and the more you get to know them the better you will understand their position.",
              },
              {
                id: "pm-2:2-d",
                da: " Be realistic about those you supervise. Take into account not only personalities but people's experience, skills and level of maturity. For example, someone new to a position is likely to require more direction than a seasoned employee.",
              },
              {
                id: "pm-2:2-e",
                da: " Pair more experienced individuals with new employees to maximize the amount of direction they get.",
              },
              {
                id: "pm-2:2-f",
                da: " Take advantage of assessment instruments such as 360° feedback or the Birkman personality assessment for a better understanding of the people you work with or manage.",
              },
              {
                id: "pm-2:2-g",
                da: " Be accessible. When people ask for assistance, ensure you give them the appropriate time and are patient with their questions.",
              },
              {
                id: "pm-2:3-a",
                da: " First delegate those items that need the least instruction and support from you. Rate the tasks according to a scale from least to most direction required on your part and clear them first.",
              },
              {
                id: "pm-2:3-b",
                da: " Avoid spending time on repeating instructions. Confirm that your instructions have been understood & ask the person to summarize what they have to do.",
              },
              {
                id: "pm-2:3-c",
                da: " Create written instructions, where appropriate, which can be used as reference by colleagues in doubt before asking you. It will allow you to focus your time on addressing specific queries.",
              },
              {
                id: "pm-2:3-d",
                da: " Provide direction and preserve time simultaneously, for example, let a subordinate shadow you and give instructions to others as you perform the task.",
              },
              {
                id: "pm-2:3-e",
                da: " Be prepared for questions and feedback and do not become defensive or abrupt. People will refrain from asking questions that could clarify confusion.",
              },
              {
                id: "pm-2:3-f",
                da: " Include directing others as one of your performance measures. It will help you to prioritize time to do it.",
              },
              {
                id: "pm-2:4-a",
                da: " Never assume your directions are perfectly clear. Ask whether people have understood you. Get feedback about the quality of your instructions.",
              },
              {
                id: "pm-2:4-b",
                da: " Ensure you highlight and emphasize key points.",
              },
              {
                id: "pm-2:4-c",
                da: " Adapt your style of direction to the individual or audience. 'One size fits all' is not an appropriate approach. Consider people's work styles, level of experience and skills. People grasp concepts differently, so consider how you explain them. A discussion may be best for an eloquent person, but a spreadsheet may work better for someone methodical. An experienced engineer, for example, may only have to understand the overall objective, while a new hireling would need detailed instructions. Also, consider people's competencies. Some people are more comfortable with ambiguity or more resourceful than others and require less direction.",
              },
              {
                id: "pm-2:4-d",
                da: " Communicate the big plan - lay it out. Map a project plan with tasks and deadlines to provide direction for the team. It allows you to frame discussions about progress and you can direct colleagues in a structured way.",
              },
              {
                id: "pm-2:4-e",
                da: " Understand the problem or task and its objectives. Take time to organize your thoughts and instructions.",
              },
              {
                id: "pm-2:4-f",
                da: " Ensure you stick to the point and do not digress. Too much information and many tangents will confuse people and muddle the waters.",
              },
              {
                id: "pm-2:4-g",
                da: " Check where your attention goes. If you are preoccupied with multiple things at once, the direction you are providing may be compromised. Repeat what the person has asked you. Turn off your cellphone and use a private space, if possible, to minimize distractions. You must be focused to give relevant, meaningful instructions.",
              },
              {
                id: "pm-2:4-h",
                da: " Communicate instructions both verbally and in writing. Hard-copy instructions ensure people know what you want and limit neglected items. If possible, write your instructions to people in an e-mail or memo, or ask them to take notes.",
              },
            ],
          },
        ],
      },
      sn: {
        characteristic: "Networking Socially",
        wdd: "Cooperating well with others; delivering great service to customers, with a focus on their needs; actively building and managing social networks; sharing an appropriate amount of personal information so that others can get to know you; working effectively with people in authority.",
        icon: require("@/assets/Iconography/Characteristics/16_Social Networker.svg"),
        competencies: [
          {
            id: "sn-0",
            icon: require("@/assets/Iconography/Attributes/16-05_Collaborating With Others.svg"),
            comp: "Collaborating with others",
            wdd: "Is cooperative and handles collaboration well",
            progressMeasures: [
              {
                id: "sn-0-0",
                pm: "I look for common goals among myself and others",
                pmMap: "Look for common goals among myself and others",
              },
              {
                id: "sn-0-1",
                pm: "I like to share what I know",
                pmMap: "Share what I know",
              },
              {
                id: "sn-0-2",
                pm: "I do not withhold resources or information to gain advantage over my team members",
                pmMap:
                  "Not withhold resources or information to gain advantage over my team members",
              },
            ],
            developmentActions: [
              {
                id: "sn-0:1-a",
                da: " Make a point of crediting others. Acknowledge each time the group or person has done something well.",
              },
              {
                id: "sn-0:1-b",
                da: " Share information freely. Consider what you have withheld or felt possessive about previously, and why. How would you feel if important information necessary to get your job done was kept from you?",
              },
              {
                id: "sn-0:1-c",
                da: " Delegate or share work so that others can get credit for their efforts too.",
              },
              {
                id: "sn-0:1-d",
                da: " Gauge your competitive behavior by asking yourself whether your actions primarily serve you or the organization.",
              },
              {
                id: "sn-0:2-a",
                da: " Explore any hidden bias you may have. List what makes you uncomfortable to collaborate with a person or group. Is it an individual, something he or she has done, or something that you associate with the person? Do you base your negative feelings on fact or opinion?",
              },
              {
                id: "sn-0:2-b",
                da: " Start by getting a consensus about the common goal. It is a powerful way to build unity despite differences.",
              },
              {
                id: "sn-0:2-c",
                da: " Focus on similarities rather than differences among the parties involved.",
              },
              {
                id: "sn-0:2-d",
                da: " Make a list of the strengths and resources that will be brought forth by working with this particular group. It will help you to see the added value.",
              },
              {
                id: "sn-0:2-e",
                da: " Do not assume people are the same and give a new person or group the benefit of the doubt. You may have had a bad experience before with people from a specific group - perhaps someone dropped the ball or your work styles were incompatible - but start with an open mind.",
              },
              {
                id: "sn-0:2-f",
                da: " If the opportunity exists, get to know the people you work with on a personal level.",
              },
              {
                id: "sn-0:3-a",
                da: " Practice your collaboration skills by working with small groups at first. Tackle projects with one or two people and build up to bigger taskforces or committees.",
              },
              {
                id: "sn-0:3-b",
                da: " To work with others may take more time, but consider the quality of the outcome and what you may learn as a result of your collaboration.",
              },
              {
                id: "sn-0:3-c",
                da: " When a group effort is completed, take time to think about what you could not have accomplished on your own.",
              },
              {
                id: "sn-0:3-d",
                da: " Offer your help to others. Helping others benefits the whole and, invariably, at some point you will find yourself needing their assistance.",
              },
              {
                id: "sn-0:3-e",
                da: " Work on being accessible. A warm interpersonal style can do much to ease people's tension and defuse emotions. If you seem too independent and disinterested in other people, you will have to fight that perception when the time comes to collaborate with them.",
              },
              {
                id: "sn-0:3-f",
                da: " Practice asking others their opinions instead of telling them how things should be done. Be the first one to listen and the last one to comment.",
              },
              {
                id: "sn-0:3-g",
                da: " Take the opportunity to mentor or work with someone who struggles or is less experienced than you.",
              },
            ],
          },
          {
            id: "sn-1",
            icon: require("@/assets/Iconography/Attributes/16-04_Focusing On Customers.svg"),
            comp: "Focusing on customers",
            wdd: "Builds relationships with and delivers services to both internal and external customers, with a focus on their needs",
            progressMeasures: [
              {
                id: "sn-1-0",
                pm: "I keep my customers in mind when making my decisions",
                pmMap: "Keep my customers in mind when making my decisions",
              },
              {
                id: "sn-1-1",
                pm: "Satisfying my customers is a priority",
                pmMap:
                  "Act in a way that demonstrates that satisfying my customers is a priority",
              },
              {
                id: "sn-1-2",
                pm: "I solicit information from my customers to help me to improve my service",
                pmMap:
                  "Solicit information from my customers to help me to improve my service",
              },
            ],
            developmentActions: [
              {
                id: "sn-1:1-a",
                da: " You may have to sift through emotions and irrelevant information before you can provide a desirable solution for your customer. Listen carefully and restate the customer's request to ensure you have understood the problem correctly. This could take a while because the customer might not even know what they need.",
              },
              {
                id: "sn-1:1-b",
                da: " Remain patient and composed, even beyond what you may deem reasonable. Your first response will set the tone for the rest of the conversation. Patience allows you to hear the customer properly and avoid incorrect conclusions.",
              },
              {
                id: "sn-1:1-c",
                da: " Put yourself in their shoes and try to empathize with the reasons why they are upset. Restate their request to let them know you have understood. You may be defensive at first, but if you can understand why the client is feeling a certain way it will help to manage your emotions more effectively.",
              },
              {
                id: "sn-1:1-d",
                da: " Be creative with your solutions. There may be strict policies and procedures for assisting the customer, but creative alternatives can often accommodate their needs. People appreciate and remember that you have gone the extra mile to accommodate them.",
              },
              {
                id: "sn-1:1-e",
                da: " Perhaps your processes or products need improvement and not your client's attitude. Track repeated requests from customers and use the information to improve where needed.",
              },
              {
                id: "sn-1:1-f",
                da: " If the relationship with your customer is costing more than the benefit it creates, consider the pros and cons of continuing the relationship. Sometimes it is not worth the resources to continue.",
              },
              {
                id: "sn-1:2-a",
                da: " Be highly attentive to information that can help you to anticipate future needs. Routinely generate conversations with clients about changes they experience in their market that will have an impact on them. These conversations can lead to ideas for new products or services which you would not have thought of without listening to their needs.",
              },
              {
                id: "sn-1:2-b",
                da: " Schedule customer calls on your calendar as part of your responsibilities. Habitually engage with your customers.",
              },
              {
                id: "sn-1:2-c",
                da: " If appropriate, use formal feedback techniques such as questionnaires to collect information about your clients' needs.",
              },
              {
                id: "sn-1:2-d",
                da: " Utilize client focus groups and feedback to test ideas before investing too much time and resources.",
              },
              {
                id: "sn-1:2-e",
                da: " Ask your clients about their likes and dislikes regarding both your product or services and your processes.",
              },
              {
                id: "sn-1:3-a",
                da: " Become familiar with the company's client base and the changes in trends that will affect clients' profiles, as well as new clients the company may be pursuing in the future.",
              },
              {
                id: "sn-1:3-b",
                da: " Try to identify and improve any process that has an impact on the client.",
              },
              {
                id: "sn-1:3-c",
                da: " You have both external and internal clients. Examine the quality of your relationship with people in other departments that count on you for information or to get their work done.",
              },
              {
                id: "sn-1:4-a",
                da: " Investigate how your work can be reorganized to make time to attend to your customers.",
              },
              {
                id: "sn-1:4-b",
                da: " Ensure that customers can reach you. Provide enough avenues for them to get in touch with you at all times, and alternatives if you are out of the office often.",
              },
              {
                id: "sn-1:4-c",
                da: " Set a policy for acceptable response times and monitor how compliant you and your team are.",
              },
              {
                id: "sn-1:4-d",
                da: " If there is absolutely no time available for managing your client relationships, talk to the relevant person about helping you reset priorities and getting assistance with your workload.",
              },
              {
                id: "sn-1:5-a",
                da: " Apply the same set of standards to new and existing clients.",
              },
              {
                id: "sn-1:5-b",
                da: " What are the company's values? Is your behavior compatible with them?",
              },
              {
                id: "sn-1:5-c",
                da: " Team up with other people who can help you to manage the client's ongoing needs if, for example, you must focus on enlarging the client base. Even if you are removed from follow-up responsibilities, occasionally check the client's status. If you closed the deal, your name and reputation will always be linked to that client.",
              },
              {
                id: "sn-1:5-d",
                da: " Weigh the consequences of enlarging versus simply providing the promised services to your existing and new client base. What kind of additional resources and investments will be necessary to support growth? Is customer satisfaction as much of a priority as profit? The two are interdependent.",
              },
              {
                id: "sn-1:5-e",
                da: " Try to take equal or greater interest and pride in not only landing the customer, but keeping them satisfied in the long term. The latter is arguably a bigger challenge.",
              },
            ],
          },
          {
            id: "sn-2",
            icon: require("@/assets/Iconography/Attributes/16-03_Building A Personal Network.svg"),
            comp: "Building a personal network",
            wdd: "Actively builds and manages social networks both inside and outside the organization",
            progressMeasures: [
              {
                id: "sn-2-0",
                pm: "I keep in touch regularly with key people",
                pmMap: "Keep in touch regularly with key people",
              },
              {
                id: "sn-2-1",
                pm: "I actively look for opportunities to create new contacts",
                pmMap: "Actively look for opportunities to create new contacts",
              },
              {
                id: "sn-2-2",
                pm: "I take advantage of social networking tools available through the Internet community",
                pmMap:
                  "Take advantage of social networking tools available through the Internet community",
              },
            ],
            developmentActions: [
              {
                id: "sn-2:1-a",
                da: " List a few people you would like to meet and think about what you would be able to offer them. Get in touch to offer assistance.",
              },
              {
                id: "sn-2:1-b",
                da: " Network with close friends and family first. You may feel more comfortable first doing this with people you know.",
              },
              {
                id: "sn-2:1-c",
                da: " Focus on your goal. You would not be asking for assistance if it was not important to you. Share your purpose with the person and make them excited about your cause.",
              },
              {
                id: "sn-2:2-a",
                da: " Utilize your lunch hour for networking. People lose great opportunities to talk to others because they are married to their desks. Everyone has to eat, and you may as well do it where you have an opportunity to meet others.",
              },
              {
                id: "sn-2:2-b",
                da: " Ensure you try to talk to as many people as possible during social gatherings or events. We tend to stick to those with whom we are familiar. You have enough time to talk to your peers and friends, so instead target people you have never met.",
              },
              {
                id: "sn-2:2-c",
                da: " Commit yourself to meeting one new person a month in your organization. Become familiar with their function or role in the company.",
              },
              {
                id: "sn-2:2-d",
                da: " Attend professional associations which allow you to meet other people in your industry.",
              },
              {
                id: "sn-2:2-e",
                da: " Take advantage of Internet-based networking tools such as LinkedIn or even Facebook",
              },
              {
                id: "sn-2:3-a",
                da: " Talk to trusted colleagues or the relevant people about your company's structure and try to get first-hand insight into the perceptions people have of those you identify as important.",
              },
              {
                id: "sn-2:3-b",
                da: " Create a list of people both inside and outside of your organization who you think are important to meet. Think about people in the company with influence over how and why decisions are made. Who, in turn, influence them? Identify ways to get in contact with them or, if appropriate, people close to them. Make it your goal to go through your entire list within a given period.",
              },
              {
                id: "sn-2:3-c",
                da: " Select a few key professional associations to join that will give you access to experts and influential people in your field.",
              },
              {
                id: "sn-2:3-d",
                da: " Spend time to get to know people's skills and abilities - who knows what? Learn who the experts in various fields in your company are. You will know who to call regarding different matters and could ask for assistance, if necessary. An expert can save you much time by identifying the core of the problem and offering solutions that have worked well previously.",
              },
              {
                id: "sn-2:3-e",
                da: " Identify people in your company with resources they can share when you need assistance with manpower or time constraints. Having made the effort to establish good relationships with individuals, you will be in a better position to ask for a favor when needed.",
              },
              {
                id: "sn-2:3-f",
                da: " Strategic partnerships are an effective way to gain advantage through resources. Networking allows you to get to know who else out there you could consider to gain advantage through your resources, now or in the future. Remain mindful of where those partnerships might exist.",
              },
              {
                id: "sn-2:3-g",
                da: " Do not overlook your inner circle of peers, family and friends.",
              },
            ],
          },
          {
            id: "sn-3",
            icon: require("@/assets/Iconography/Attributes/16-02_Being Open.svg"),
            comp: "Being open",
            wdd: "Shares an appropriate amount of personal information so that others can get to know them",
            progressMeasures: [
              {
                id: "sn-3-0",
                pm: "I feel comfortable sharing relevant personal information with others",
                pmMap:
                  "Feel comfortable sharing relevant personal information with others",
              },
              {
                id: "sn-3-1",
                pm: "I spend time interacting socially with people from work",
                pmMap: "Spend time interacting socially with people from work",
              },
              {
                id: "sn-3-2",
                pm: "I encourage people to be open with me",
                pmMap: "Encourage people to be open with me",
              },
            ],
            developmentActions: [
              {
                id: "sn-3:1-a",
                da: " Using humor is a safe way of being open, yet talk about weaknesses. People will usually join in with their own stories.",
              },
              {
                id: "sn-3:1-b",
                da: " Focus on sharing the positive things in your life, rather than the negative.",
              },
              {
                id: "sn-3:1-c",
                da: " Use your openness to help others to learn. Share your personal insight about the good and less positive decisions you have made in your career.",
              },
              {
                id: "sn-3:1-d",
                da: " Think about people who are open with you. Do you respect them less because of it?",
              },
              {
                id: "sn-3:2-a",
                da: " Take a break or two each day to simply chat with people and tell them something unrelated to work. Make it your goal to make others feel comfortable. Ask personal questions or share a personal story or a smile.",
              },
              {
                id: "sn-3:2-b",
                da: " Schedule time in your calendar to attend events, functions, lunches etcetera, for the sake of spending some personal time with people.",
              },
              {
                id: "sn-3:2-c",
                da: " Use your openness to help others learn in the workplace. Share your insight about the good and less positive decisions you have made in your career.",
              },
              {
                id: "sn-3:3-a",
                da: " If you are uncomfortable with openness, start by sharing information about neutral subjects such as your hobbies.",
              },
              {
                id: "sn-3:3-b",
                da: " What would you like to know about other people? If you initiate the conversation and allow the other person to share first, you may feel less guarded.",
              },
              {
                id: "sn-3:3-c",
                da: " Try to share something about yourself with someone at work once a week.",
              },
              {
                id: "sn-3:3-d",
                da: " How open are you in your private life? Ask your significant other's opinion. It is often easier to practice being more open with your family first, then with your colleagues.",
              },
              {
                id: "sn-3:4-a",
                da: " Start by trying to engage the other person with casual questions, for example, 'How did you like that restaurant where we all went to lunch?' or 'Do you often go out to eat?' If the person is receptive, continue the conversation.",
              },
              {
                id: "sn-3:4-b",
                da: " Ensure you are not sharing information which may make the person uncomfortable. Observe the reaction to what you said. Is there a change in their tone of voice? Do they immediately get quiet, or change their demeanor or the topic?",
              },
              {
                id: "sn-3:4-c",
                da: " Observe a respected peer who is well liked and to whom people open up readily. What kind of information does that person share?",
              },
              {
                id: "sn-3:4-d",
                da: " Ask a trusted peer whether your comments are appropriate.",
              },
              {
                id: "sn-3:4-e",
                da: " Be mindful of people's time and busy schedules. It may be that they want to listen, but perhaps not for that long.",
              },
              {
                id: "sn-3:4-f",
                da: " Never share information about yourself that you feel you may regret later. Openness is not confession.",
              },
              {
                id: "sn-3:4-g",
                da: " Unless it is a trusted peer, do not share information about yourself which you would want people to keep confidential. It gives them an unfair responsibility to guard what you have told them. It is also likely to make them uncomfortable.",
              },
              {
                id: "sn-3:4-h",
                da: " Non-verbal communication is the key when sharing information. Make sure you are sincere about sharing a story and that you come across like that. Make direct eye contact, do not answer your phone during the conversation etcetera.",
              },
            ],
          },
          {
            id: "sn-4",
            icon: require("@/assets/Iconography/Attributes/16-01_Working Well With Authority.svg"),
            comp: "Working well with authority",
            wdd: "Respectful towards authority, and open to corrective feedback",
            progressMeasures: [
              {
                id: "sn-4-0",
                pm: "I feel I can be honest and open with people in authority about issues or problems",
                pmMap:
                  "Be honest and open with people in authority about issues or problems",
              },
              {
                id: "sn-4-1",
                pm: "I do not get defensive when someone who has more authority than me gives me negative feedback",
                pmMap:
                  "Not get defensive when someone who has more authority than me gives me negative feedback",
              },
              {
                id: "sn-4-2",
                pm: "I respect people who have more authority than I do",
                pmMap: "Respect people who have more authority than I do",
              },
            ],
            developmentActions: [
              {
                id: "sn-4:1-a",
                da: " Judge your boss by overall performance, not depth of technical knowledge.",
              },
              {
                id: "sn-4:1-b",
                da: " Be realistic about comparing your boss with others. You may have worked hard at specializing in an area and developed expertise in it, or previously had a boss who was a technical expert, but it may not be necessary now for your boss to do the job well.",
              },
              {
                id: "sn-4:1-c",
                da: " Instead of criticizing or judging, find ways to use your technical knowledge to make your boss and team more successful.",
              },
              {
                id: "sn-4:1-d",
                da: " Share literature or experiences that you have found useful in building your technical knowledge with your boss.",
              },
              {
                id: "sn-4:1-e",
                da: " Ask your boss to identify technical experts in the company from whom you and your team can get guidance if he or she is unable to answer your questions.",
              },
              {
                id: "sn-4:1-f",
                da: " Improve your own technical expertise so that you do not to have to rely on your boss.",
              },
              {
                id: "sn-4:1-g",
                da: " Learn as much as you can from the boss's strengths instead of focusing on the weaknesses.",
              },
              {
                id: "sn-4:2-a",
                da: " Have an honest discussion with your boss about your preferred work style and the guidance you need to perform your best. This type of feedback will help your boss to understand the approach with which you are most comfortable. Be as specific as possible and cite examples of when your boss's style made things challenging for you. The goal is to understand the best way to work together.",
              },
              {
                id: "sn-4:2-b",
                da: " Reinforce behavior by letting your boss know what he or she is doing right. Thank your boss for giving you room to carry out a project or, conversely, for taking the time to help you structure a task properly.",
              },
              {
                id: "sn-4:2-c",
                da: " Ask your boss what is required of you. What can you change about your work style to improve your relationship? For example, if your boss is constantly micro-managing, perhaps it is because he or she has a need to be informed and you are not providing enough information.",
              },
              {
                id: "sn-4:2-d",
                da: " Suggest to your boss that your group or team participates in assessments which probe deeper into the different work styles represented in the group. Assessments such as the Birkman Method and the Team Styles tool explore the differences between individuals and groups.",
              },
              {
                id: "sn-4:2-e",
                da: " Get to know the person behind the work style. If possible, try to spend time in a social setting - go to lunch together or attend a social event where you get a chance to converse with your boss.",
              },
              {
                id: "sn-4:3-a",
                da: " Focus on things about your boss that you respect - tenacity, level of business acumen, ability to make decisions. Do not just consider your boss's behavior, but his or her accomplishments as well.",
              },
              {
                id: "sn-4:3-b",
                da: " Observe the context or situations that make it more difficult to work with your boss. Does it always happen, or just under particular circumstances? If it is the latter, what can you do to assist your boss during those times?",
              },
              {
                id: "sn-4:3-c",
                da: " Prepare yourself emotionally for the ups and downs that go hand in hand with a difficult personality. A person whose moods are inconsistent is difficult to work with, so be sure not to take a bad mood personally.",
              },
              {
                id: "sn-4:3-d",
                da: " Be as open as possible with your boss. He or she may be unaware of the impact of their behavior and, without feedback, are unlikely to change.",
              },
              {
                id: "sn-4:3-e",
                da: " Become familiar with behavioral competency language. It will help you to define and communicate which elements of a person's behavior make them difficult, for example, someone is not open, does not listen, is not approachable, patient or fair.",
              },
              {
                id: "sn-4:3-f",
                da: " Get to know your boss in social settings. Attend events where you can interact or plan a lunch with your boss, if possible. You may get to know a very different person.",
              },
              {
                id: "sn-4:3-g",
                da: " Keep your boss informed. Often, we withhold information from people we do not respect. Keeping you boss well informed ensures lines of communication stay open and encourages dialogue between the two of you.",
              },
              {
                id: "sn-4:3-h",
                da: " Relationships are a two-way street have you thought about what you might you be contributing to the situation? Be honest with yourself. You may have little control over your boss's behavior, but you do have control over yours. Write down things you may be doing that make the relationship difficult. Are you too competitive? Do you expect your boss to behave in a certain way all the time?",
              },
              {
                id: "sn-4:3-i",
                da: " Although a strong relationship with your boss is ideal, a person is sometimes just not willing to change. Concentrate on building a good relationship through your performance and not your relationship. The best you can do is to focus on developing your skills to prepare you for a reassignment.",
              },
              {
                id: "sn-4:3-j",
                da: " If the relationship with your boss is verbally or mentally abusive, talk confidentially with your human resources representative about your options.",
              },
              {
                id: "sn-4:3-k",
                da: " Do you get defensive when your boss gives you negative feedback? Do you hold a grudge about something that happened in the past? Do you talk behind your boss's back?",
              },
              {
                id: "sn-4:3-l",
                da: " Manage your expectations. You do not have to like everything about your boss. Are you comparing your boss to someone else?",
              },
            ],
          },
        ],
      },
      imr: {
        characteristic: "Motivational Influence",
        wdd: "Inspiring others to accept and trust a vision of the future; knowing what motivates different types of people and get the best out of them; developing others and providing an opportunity for them to practice new skills or improve existing ones; ability to pull people together as a team for a common purpose.",
        icon: require("@/assets/Iconography/Characteristics/10_Inspirational Motivator.svg"),
        competencies: [
          {
            id: "imr-0",
            icon: require("@/assets/Iconography/Attributes/10-04_Developing people.svg"),
            comp: "Developing people",
            wdd: "Develops others and provides an opportunity for them to practice new skills or improve existing ones",
            progressMeasures: [
              {
                id: "imr-0-0",
                pm: "I include people who work with me in relevant meetings and projects to expose them to development opportunities",
                pmMap:
                  "Include people who work with me in relevant meetings and projects to expose them to development opportunities",
              },
              {
                id: "imr-0-1",
                pm: "I regularly ask people what they would be interested to work on",
                pmMap:
                  "Regularly ask people what they would be interested to work on",
              },
              {
                id: "imr-0-2",
                pm: "I actively help people who want to develop themselves",
                pmMap: "Actively help people who want to develop themselves",
              },
              {
                id: "imr-0-3",
                pm: "I understand that people have different ways they like to learn and I accommodate those differences",
                pmMap:
                  "Help people that have different ways to learn and accommodate those differences",
              },
            ],
            developmentActions: [
              {
                id: "imr-0:1-a",
                da: " Do you encourage a culture of self-development? Discuss it openly and offer people opportunities to develop. Let them know it is one of your priorities and that you encourage them to be proactive about suggesting opportunities.",
              },
              {
                id: "imr-0:1-b",
                da: " Consider all requests for development. Ensure you do not demoralize people by turning down suggestions for events they would like to attend or projects for which they show enthusiasm. Give people the benefit of the doubt and reward them for having shown initiative. They will learn to gauge the types of activities that pay off.",
              },
              {
                id: "imr-0:1-c",
                da: " Praise people openly when they complete a development item. Praise is infectious and will help to motivate other team members. It will also send the message that selfdevelopment is valued.",
              },
              {
                id: "imr-0:1-d",
                da: " Do not keep your knowledge to yourself. It takes little effort to motivate others to develop themselves by reading articles, business journals or books that you have found particularly enlightening and recommend. Formalize the process by regularly sending a compilation of suggestions to which people can look forward.",
              },
              {
                id: "imr-0:2-a",
                da: " Expose people to development by including them in meetings with groups they do not typically encounter: clients, higher management and other departments etcetera. They do not have to play an active role but could learn from the experience, and it does not impose on your time.",
              },
              {
                id: "imr-0:2-b",
                da: " Identify tasks you can delegate to subordinates to help them to improve weak skills.",
              },
              {
                id: "imr-0:2-c",
                da: " Set appropriate performance expectations which consider the person's experience, skills set and the position's context.",
              },
              {
                id: "imr-0:2-d",
                da: " Give staff adequate space and time to work through problems and prove themselves.",
              },
              {
                id: "imr-0:2-e",
                da: " Encourage people to take initiative. Do not overreact when a mistake is made; instead, use it as an opportunity for reflection and development.",
              },
              {
                id: "imr-0:3-a",
                da: " Ask a consultant or the human resources department to train you in coaching. It will build your coaching skills and allow you to provide feedback to staff more easily.",
              },
              {
                id: "imr-0:3-b",
                da: " Use tools such as 360° assessments to learn about a person's strengths and developmental needs. Collective evidence from various sources about the skills a person should improve is more weighty because it is harder to object to than if it came from one source only.",
              },
              {
                id: "imr-0:3-c",
                da: " Some subordinates will be better prepared to follow your guidance than others. Do not be defensive or take it personally. Most people dread feedback, and awareness is often preceded by denial. You may have to discuss the subject several times before a person can assimilate the feedback and is prepared to act.",
              },
              {
                id: "imr-0:3-d",
                da: " Ensure the employee understands the feedback's relevance to achieving success in a position. The person must fully grasp how a deficiency that has been identified affects their ability to perform well.",
              },
              {
                id: "imr-0:4-a",
                da: " Take advantage of assessment tools such as 360° feedback, which informs you about a person's strengths and development opportunities.",
              },
              {
                id: "imr-0:4-b",
                da: " Prioritize the improvement of 'knockout factors' and 'derailers' that have been identified in a person's profile. Knockout factors are certain behavioral attributes that will cause a problem in every context regardless of a person's job, such as having poor relationships with bosses. Derailers result from a special combination of strengths and weaknesses. It may begin as a strength, but can create problems over the evolution of a career, such as when someone becomes a too independent loner. These factors need attention early on.",
              },
              {
                id: "imr-0:4-c",
                da: " Identify the development items that will have the greatest impact on an employee's current position.",
              },
              {
                id: "imr-0:4-d",
                da: " Consider the context of someone's current position or the future job the person is aiming for. For example, if someone is being groomed for a turnaround position, ensure their behavioral competencies are a good match for that type of position.",
              },
              {
                id: "imr-0:4-e",
                da: " Contact your human resources department, about the 9-Cell Matrix. It is used to identify people with high potential in the company and examine the best developmental strategies for people based on performance and learning agility predictors.",
              },
              {
                id: "imr-0:4-f",
                da: " Expose people to a variety of assignments. It is a practical way to uncover their strengths and weaknesses.",
              },
              {
                id: "imr-0:4-g",
                da: " Interest should play a key role in someone's development path. Ask people which assignments they find fulfilling and which challenges they would like to tackle.",
              },
              {
                id: "imr-0:4-h",
                da: " Peers can learn a lot from each other. Encourage discussion groups or informal lunch meetings during which they can share information or insights about their projects.",
              },
              {
                id: "imr-0:4-i",
                da: " Take into account that people learn differently. Some learn better on their own, others enjoy group learning; some learn from books and other require practical experience.",
              },
              {
                id: "imr-0:5-a",
                da: " Identify successors for critical positions in your business and ensure a succession plan is in place.",
              },
              {
                id: "imr-0:5-b",
                da: " Adopt a long-term development philosophy that allows you to build the necessary talent in others step by step.",
              },
              {
                id: "imr-0:5-c",
                da: " Take people along to key meetings and engagements where they can learn by observing you with little risk to you or the organization.",
              },
              {
                id: "imr-0:5-d",
                da: " Identify which of your responsibilities you can delegate to others as part of their development. Discuss and okay it with your supervisor - their support will make it easier for you to take the risk.",
              },
              {
                id: "imr-0:5-e",
                da: " Assign mentors to people so they can gain valuable knowledge and perspectives from someone other than you.",
              },
              {
                id: "imr-0:5-f",
                da: " Write down the consequences should someone you are developing take a misstep. Are these consequences as grave as you imagine them to be?",
              },
              {
                id: "imr-0:6-a",
                da: " Ensure you understand what motivates employees and offer incentives that acknowledge their talent and secure their loyalty.",
              },
              {
                id: "imr-0:6-b",
                da: " Ask individuals about the opportunities they would find interesting and ensure they have assignments that tap into those interests.",
              },
              {
                id: "imr-0:6-c",
                da: " Assign an individual you are developing to be a mentor to others. It will reinforce your confidence in the person and reward their skill.",
              },
              {
                id: "imr-0:6-d",
                da: " Raise individuals visibility among higher management by communicating and promoting their successes and hard work.",
              },
            ],
          },
          {
            id: "imr-1",
            icon: require("@/assets/Iconography/Attributes/10-03_Inspiring A Future.svg"),
            comp: "Inspiring a future",
            wdd: "Gets others to accept and trust a vision of the future and inspires them",
            progressMeasures: [
              {
                id: "imr-1-0",
                pm: "I like to remind people of the part their work plays in the bigger picture",
                pmMap:
                  "Remind people of the part their work plays in the bigger picture",
              },
              {
                id: "imr-1-1",
                pm: "I routinely talk to people about a common cause and build consensus for a shared future",
                pmMap:
                  "Routinely talk to people about a common cause and build consensus for a shared future",
              },
              {
                id: "imr-1-2",
                pm: "If people’s energy levels are low I try to inspire them by talking about the future",
                pmMap:
                  "Inspire if their energy is low and talk to them about the future",
              },
              {
                id: "imr-1-3",
                pm: "I am an effective motivational speaker",
                pmMap: "Be an effective motivational speaker",
              },
            ],
            developmentActions: [
              {
                id: "imr-1:1-a",
                da: " Review the company's mission and vision.",
              },
              {
                id: "imr-1:1-b",
                da: " If they are vague, discuss them with other leaders in the organization and clarify them. Ensure you understand why decisions were made to move in this direction. Understanding the reasons behind change helps you to make a convincing case to those you supervise.",
              },
              {
                id: "imr-1:1-c",
                da: " Expect people to be apprehensive and doubtful about change.",
              },
              {
                id: "imr-1:1-d",
                da: " Anticipate that there will be many questions and concerns, so prepare to respond. You can get a list of common questions by asking representatives of various divisions to supply their key concerns.",
              },
              {
                id: "imr-1:1-e",
                da: " Present the vision as a work in progress rather than something that is set in stone. It communicates to everyone that the road ahead will involve trial and error, as well as adjustments.",
              },
              {
                id: "imr-1:1-f",
                da: " Ensure you highlight what will remain the same, such as company values, commitment to excellence, core products etcetera. It will comfort employees.",
              },
              {
                id: "imr-1:1-g",
                da: " Talk to leaders who have successfully implemented turnaround strategies. Which challenges did they face in trying to inspire others?",
              },
              {
                id: "imr-1:1-h",
                da: " Remember humor when discussing the difficulties that might be encountered in steering the company on a different course. Humor is a bonding tool and humanizes you, which may help employees to see your side and approach change with less apprehension.",
              },
              {
                id: "imr-1:1-i",
                da: " Encourage a culture in which people tolerate and even thrive during times of ambiguity. Support experimentation and reward innovative approaches to nurture such a culture.",
              },
              { id: "imr-1:2-a", da: " Do not voice your disagreement." },
              {
                id: "imr-1:2-b",
                da: " If you feel tempted to share your personal opinions, ask yourself whether your comments will change things or whether you will just be venting.",
              },
              {
                id: "imr-1:2-c",
                da: " Be aware of the impact your words may have on morale, especially should you openly express concerns about the decision-making process or leadership.",
              },
              {
                id: "imr-1:2-d",
                da: " Watch your body language, for example, do not roll your eyes or shake your head during discussions about the company's goals, or cross your arms tightly and speak disinterestedly in a monotone when talking about its future.",
              },
              {
                id: "imr-1:2-e",
                da: " No matter how you fake it, create some motivation to accept the company's vision or direction. It will make it easier for you to convey enthusiasm and motivate others. If you do not believe in it somehow, you will not be perceived as authentic. Write down the reasons for your skepticism to identify exactly what makes you uncomfortable.",
              },
              {
                id: "imr-1:2-f",
                da: " Challenge your logic - get a fresh perspective on the situation from a mentor or respected peers.",
              },
              {
                id: "imr-1:2-g",
                da: " If you are not sold on the company course that has been set, ensure you find ways to change that in the future by becoming more involved in the decision-making process. If appropriate, talk to those who made the decision to learn their rationale. Become involved in a committee or task force, or volunteer to be part of the project that generates the decisions being made. If you are really passionate about change, try to influence others by lobbying behind the scenes.",
              },
              {
                id: "imr-1:3-a",
                da: " Schedule regular meetings with staff to engage them in the company's direction and create excitement among them.",
              },
              {
                id: "imr-1:3-b",
                da: " Ensure you are accessible to your subordinates. They should be able to openly discuss their ambitions for their future within the company.",
              },
              {
                id: "imr-1:3-c",
                da: " Up your energy level so that your enthusiasm shows. Leaders often make the mistake of delivering their message as if it were an unpleasant task. Be optimistic and impart excitement when talking about the company's future. Be animated. Raise people's interest by encouraging constructive questions.",
              },
              {
                id: "imr-1:3-d",
                da: " Ensure you can clearly articulate the benefits of the direction the company is taking.",
              },
              {
                id: "imr-1:3-e",
                da: " Do not be discouraged by detractors. Some people may be disinterested, others skeptical or even outright resistant. If you can isolate these individuals, talk to them privately about their negativity and try to address their concerns. Pretending that they do not matter risks having them influence the attitude of the entire group. Also, be prepared to answer the key questions from detractors. Do not respond defensively - find patience in the knowledge that your position is stronger when change is accepted, not forced.",
              },
              {
                id: "imr-1:3-f",
                da: " Your message will often have to be delivered through formal presentations. If resources permit, engage a professional speechwriter who can translate your ideas into motivational words. It takes a highly specialized writer, so get help if necessary. If you want to inspire an audience, the investment will pay off handsomely.",
              },
              {
                id: "imr-1:3-g",
                da: " Practice your speech in front of the mirror, your family or a peer. Would you be inspired? Were they? Ensure you trust your message, or your delivery will not be believable.",
              },
              {
                id: "imr-1:3-h",
                da: " The reasons behind people's inspiration is as diverse as people themselves. One size will not fit all while you try to instill a vision for the future. Be aware of the different audiences to whom you will have to present. Your message to the board will differ from your message to your line workers or members of the press.",
              },
              {
                id: "imr-1:3-i",
                da: " Add a down-to-earth touch to your message by using humor and metaphors or analogies to which your particular audience can relate.",
              },
              {
                id: "imr-1:3-j",
                da: " Learn to become an accomplished futurist. To inspire others, you have to know how to get them to use their imagination and believe in possibilities - things they are unable to see just then.",
              },
              {
                id: "imr-1:4-a",
                da: " Selling an idea to others does not have to be a large production. Each individual you talk to is a customer, so use the opportunity to do your pitch informally and show your enthusiasm for the direction the company is taking.",
              },
              {
                id: "imr-1:4-b",
                da: " Use others to help you to spread the word. Ask other managers to make it a priority and encourage or reward them for inspiring a vision of the future in others.",
              },
              {
                id: "imr-1:4-c",
                da: " Spearhead a formal communication campaign, which is supported by the executive team. It could take many forms, for example, e-mails, webcasts or company-wide presentations, depending on resources. Consult your change management or communications team to devise an effective marketing plan.",
              },
              {
                id: "imr-1:4-d",
                da: " Ensure the company's vision and mission are clearly communicated in the annual report.",
              },
              {
                id: "imr-1:4-e",
                da: " Remember, action often has a greater impact than words as far as inspiring others is concerned. Ensure you act according to the mission and vision you are selling.",
              },
              {
                id: "imr-1:5-a",
                da: " Focus less on how you will get there and more on what your destination actually looks like.",
              },
              {
                id: "imr-1:5-b",
                da: " Do not shy away from setting ambitious goals and objectives for yourself and the team. If you are successful, you will have raised the bar beyond average. If the outcome falls short, you will likely have achieved what was expected anyway.",
              },
              {
                id: "imr-1:5-c",
                da: " Become inspired about greatness by learning about inspirational leaders. Read biographies or listen to famous inspirational speeches.",
              },
              {
                id: "imr-1:5-d",
                da: " If it makes you feel more comfortable, let people know you are aiming for the stars and that how you get there is a work in progress with all the trial and error it involves.",
              },
            ],
          },
          {
            id: "imr-2",
            icon: require("@/assets/Iconography/Attributes/10-02_Motivating People.svg"),
            comp: "Motivating people",
            wdd: "Creates an environment that brings out the best in others and knows what motivates different types of people",
            progressMeasures: [
              {
                id: "imr-2-0",
                pm: "I realize everyone needs motivation once in a while",
                pmMap: "Recognize everyone needs motivation once in a while",
              },
              {
                id: "imr-2-1",
                pm: "I like to talk to people about what motivates them",
                pmMap: "Talk to people about what motivates them",
              },
              {
                id: "imr-2-2",
                pm: "I remain energetic and motivate others even when I am going through a difficult time",
                pmMap:
                  "Remain energetic and motivate others even when I am going through a difficult time",
              },
              {
                id: "imr-2-3",
                pm: "I consider the impact of my statements on other people's motivation before I make them",
                pmMap:
                  "Consider the impact of my statements on other people's motivation before I make them",
              },
            ],
            developmentActions: [
              {
                id: "imr-2:1-a",
                da: " Participate in a 360Â° feedback process that will provide honest feedback from your peers, clients and even manager about your behavior. Remember that feedback is not useful unless you are willing to accept it and make the necessary changes.",
              },
              {
                id: "imr-2:1-b",
                da: " Engage a coach to help you pinpoint the aspects of your personality that affect your ability to motivate others. For example, being empathetic, listening well, patience, empowering others, delegation skills, informing others and being open.",
              },
              {
                id: "imr-2:1-c",
                da: " Observe people in the organization who are good at motivating others. Which personality traits enable them to do it?",
              },
              {
                id: "imr-2:1-d",
                da: " Realize that your motivation stems from a different place than others'. It is based on personality types. You may like to work on your own and need a structured work environment. Another person may enjoy working in teams, sharing ideas, and gets motivated by a flexible environment.",
              },
              {
                id: "imr-2:2-a",
                da: " Spend the time necessary to get people motivated about a project. People remain inspired when they form a connection with a bigger vision, rather than a task.",
              },
              {
                id: "imr-2:2-b",
                da: " Balance your need for action with praise for what has been accomplished so far.",
              },
              {
                id: "imr-2:2-c",
                da: " When pointing out mistakes or an area that needs to be improved, always mention the things that have been done correctly as well.",
              },
              {
                id: "imr-2:2-d",
                da: " Check in with people periodically to monitor both their progress and their feelings and concerns.",
              },
              {
                id: "imr-2:2-e",
                da: " Consider carefully which results really need to be perfect, how aggressive deadlines must be and how realistic your standards are. You can place undue pressure on people with tasks that actually require less accuracy or could be finished within a more forgiving time period.",
              },
              {
                id: "imr-2:2-f",
                da: " Do not use a 'one size fits all' approach with people. Ensure you understand the different incentives individuals need and use that to get your results.",
              },
              {
                id: "imr-2:3-a",
                da: " Look for clues that point to decreased motivation - negative statements, withdrawal from the group, a drastic change in work style, lagging behind in work, consistently missing deadlines, an unusually short attention span, irritability or disruptive behavior.",
              },
              {
                id: "imr-2:3-b",
                da: " Observe what makes a person become animated. People tend to be more engaged and excited when they talk about or work on things that motivate them. Do not let the opportunity pass to ask people what about the experience, topic etcetera appeals to them. Use the feedback when considering ways to motivate them in future.",
              },
              {
                id: "imr-2:3-c",
                da: " If you suspect something is wrong, ask! Trust your intuition. Just knowing you care enough to notice can be a big motivator.",
              },
              {
                id: "imr-2:3-d",
                da: " Listen carefully to what people say and do not say. Sometimes, people who are trying to sort things out have not yet discovered exactly what they are unhappy about.",
              },
              {
                id: "imr-2:3-e",
                da: " Reading people is not necessarily easy, so get a head start. Numerous assessment tools can give you great insight into people, for example, the Birkman Method focuses on people's hidden needs. Such assessment tools can provide invaluable information about people's motivation. Ask your human resources advisers about available tools you can use.",
              },
              {
                id: "imr-2:4-a",
                da: " Be appreciative - it is the simplest way to motivate people. Let people know the value of their work, be generous with your thanks, point out openly how well someone is doing. When was the last time you expressed gratitude to the people you oversee?",
              },
              {
                id: "imr-2:4-b",
                da: " Do not let someone struggle too long with an assignment if they obviously need help. Routinely check on their progress, ask whether they need assistance and ensure resources are mobilized to help if needed. To ask for help and not get it can be highly damaging to morale.",
              },
              {
                id: "imr-2:4-c",
                da: " Get to know the people who work for you. Create opportunities to share information about each other in an informal setting. Go to lunch with them or attend after-hours events where you can see people interact outside of work.",
              },
              {
                id: "imr-2:4-d",
                da: " Actions speak louder than words. Herb Keller, chairman of Southwest Airlines in the US, has occasionally participated in loading luggage or taking tickets at the gate. To show colleagues that you are a real part of the team and know what their work entails is a powerful message.",
              },
              {
                id: "imr-2:5-a",
                da: " Consult human resources and your supervisor to learn about practices and policies regarding incentives to employees.",
              },
              {
                id: "imr-2:5-b",
                da: " When morale is low or the work environment has been particularly difficult, provide incentives that encourage people to meet specific goals, targets or deadlines. Everyone needs a push sometimes.",
              },
              {
                id: "imr-2:5-c",
                da: " Interesting assignments help to keep people motivated. Ensure the people you oversee have realistic but challenging goals and assignments about which they can get excited. Understand the nature of the work on which people spend most of their time. Rotate tasks to avoid burnout. Ask whether a person would like to work on a specific task or project. Surprisingly, employees are rarely asked that question.",
              },
              {
                id: "imr-2:5-d",
                da: " Help people to remain enthusiastic about their work by informing them about the bigger picture and the opportunities they have - not just today, but in the future.",
              },
              {
                id: "imr-2:5-e",
                da: " When possible, raise people's profile among higher management by communicating their successes.",
              },
              {
                id: "imr-2:5-f",
                da: " Do not assume people are content because they have not complained. Let your subordinates participate in a motivation survey. The results could be enlightening.",
              },
              {
                id: "imr-2:5-g",
                da: " Wherever you can, ensure that changes in policy are made and put into practice to reflect the feedback from such surveys. If people's opinions have been sought and action does not follow, they will become demoralized.",
              },
              {
                id: "imr-2:5-h",
                da: " Ensure you have plans to retain your best performers and those with high potential.",
              },
              {
                id: "imr-2:6-a",
                da: " Always begin with a positive response to a person's request and act in an encouraging manner, even if you have your doubts.",
              },
              {
                id: "imr-2:6-b",
                da: " When discussing a person's goals, outline both the obstacles to success and the reasons why the goal could be achieved.",
              },
              {
                id: "imr-2:6-c",
                da: " Approach every situation as if it were new. Previously, others may not have succeeded, but it does not mean that the person in front of you will not.",
              },
              {
                id: "imr-2:6-d",
                da: " Do not assume things have to stay the way thery are. Talk to the appropriate people about options and make a case for the individual you are championing.",
              },
              {
                id: "imr-2:6-e",
                da: " Ask the person to give you a plan of how they expect to achieve the goal before you judge whether it can succeed or not.",
              },
              {
                id: "imr-2:6-f",
                da: " If your team worked diligently on a project and the outcome was not as good as expected, do not dwell unnecessarily on the results. Encourage the team to apply what they have learned to the next project.",
              },
              {
                id: "imr-2:7-a",
                da: " Consider carefully what might be affecting your positive outlook, not just at work but also in your personal life.",
              },
              {
                id: "imr-2:7-b",
                da: " Make a list and identify the aspects of your work or life which you can change immediately, in the short term and the long term.",
              },
              {
                id: "imr-2:7-c",
                da: " Create an action plan to address these changes. For example, if you are unhappy with your work schedule, mark it as a short-term item that could be addressed by working from home two days a week. Unhappiness with your position is a longer-term item that you can address by developing skills for another position in the organization.",
              },
              {
                id: "imr-2:7-d",
                da: " Read inspiring literature. Ask peers to recommend books for motivational reading.",
              },
              {
                id: "imr-2:7-e",
                da: " Do not vent your frustrations in front of your subordinates and be mindful of negative talk. They will not be able to change the situation and you risk demoralizing them. Instead, talk about your grievances to the appropriate person - your boss, a human resources representative, your coach.",
              },
              {
                id: "imr-2:7-f",
                da: " Even when you are not motivated about your situation, you can still be positive and affirming about others.",
              },
              {
                id: "imr-2:7-g",
                da: " Consider seeing a counselor if your negativity is chronic or becomes disruptive at work.",
              },
              {
                id: "imr-2:7-h",
                da: " Sometimes, you may have to fake being motivated for a little while until you really feel that way.",
              },
            ],
          },
          {
            id: "imr-3",
            icon: require("@/assets/Iconography/Attributes/10-01_Unifying People.svg"),
            comp: "Unifying people",
            wdd: "Recognizes the value of teamwork and can pull people together for a common purpose",
            progressMeasures: [
              {
                id: "imr-3-0",
                pm: "I like to define team goals and inspire a sense of common purpose when working with others",
                pmMap:
                  "Define team goals and inspire a sense of common purpose when working with others",
              },
              {
                id: "imr-3-1",
                pm: "I recognize team members have different work styles and I accommodate them",
                pmMap:
                  "Recognize team members have different work styles and I accommodate them",
              },
              {
                id: "imr-3-2",
                pm: "I regularly gather the team together to discuss progress build team spirit",
                pmMap:
                  "Regularly gather the team together to discuss progress build team spirit",
              },
              {
                id: "imr-3-3",
                pm: "I reward the team effort, not just individuals",
                pmMap: "Reward the team effort, not just individuals",
              },
            ],
            developmentActions: [
              {
                id: "imr-3:1-a",
                da: " Establish a culture that values team participation. Share team accomplishments with both your subordinates and higher management to gain recognition for their efforts. It is an effective way to reward people for their collective work.",
              },
              {
                id: "imr-3:1-b",
                da: " Reward and celebrate team goals that are met, not just individual goals.",
              },
              {
                id: "imr-3:1-c",
                da: " Consider carefully the scope of the project and whether its quality would benefit from teamwork or one person's involvement.",
              },
              {
                id: "imr-3:1-d",
                da: " Find ways to optimize people's input by putting together teams with diverse skills sets to tackle projects.",
              },
              {
                id: "imr-3:1-e",
                da: " Clearly define the role of each player in the team. This means highlighting and promoting what each member brings to the team.",
              },
              {
                id: "imr-3:1-f",
                da: " At your initial team meetings, establish the necessary procedure individuals must follow: how they will communicate, the decision-making process, details of how work will be done and ways in which conflict will be resolved.",
              },
              {
                id: "imr-3:2-a",
                da: " Be sure to create and maintain a well-defined, relevant mission statement.",
              },
              {
                id: "imr-3:2-b",
                da: " Allow the team members to participate as much as possible in creating their vision and goals. It will increase their sense of ownership of the project.",
              },
              {
                id: "imr-3:2-c",
                da: " Create milestones and concrete measures of success to help team members to stay motivated along the way. Tie measurements to the goals achieved, for example, the number of new clients reached.",
              },
              {
                id: "imr-3:2-d",
                da: " Build a sense of camaraderie by celebrating the team's milestones.",
              },
              {
                id: "imr-3:2-e",
                da: " Periodically, take the time to articulate to individuals exactly what their parts play in the team's success as well as that of the ultimate goal, and what that goal means to the company.",
              },
              {
                id: "imr-3:3-a",
                da: " Gather all the team members together for an initial face-to-face meeting. It is important to establish the team's identity, build trust among its members and create a sense of unity.",
              },
              {
                id: "imr-3:3-b",
                da: " Let your team be assessed for different team styles and facilitate a guided workshop to help the members understand each other better. The Birkman Method is an effective tool to look at how individual needs affect a team's dynamics. The Team Styles and Individual Talent Analysis reports, available through a consultant at www.GetBoarded.com, can give managers key insights into individuals in their team.",
              },
              {
                id: "imr-3:3-c",
                da: " Ask your human resources department about team-building exercises your team can attend.",
              },
              {
                id: "imr-3:3-d",
                da: " Help people to make the vital connection between career advancement and working well with others. Effective interpersonal skills are critical for advancement in any organization. Learn, and teach your team, to develop them.",
              },
              {
                id: "imr-3:3-e",
                da: " Be sure to intervene quickly when a team member is being disruptive. Talk to the person privately to assess the challenges they experience. An outside mediator may be necessary if intense conflict arises between individuals in the team. Misunderstandings must be addressed before they assume greater meaning than they should.",
              },
              {
                id: "imr-3:3-f",
                da: " Do not assume that team issues can be resolved at once - you may have to address matters again. Remain constantly aware of the group's needs.",
              },
              {
                id: "imr-3:4-a",
                da: " If your position does not include managing a team, try taking on the role of motivator in your workgroup. Help your colleagues to stay focused on progress and the positive side of things when morale is low.",
              },
              {
                id: "imr-3:4-b",
                da: " If not already in place, try to institute periodic team meetings to review the work status. Offer to facilitate the meeting and, possibly, the discussion.",
              },
              {
                id: "imr-3:4-c",
                da: " Talk you your boss about opportunities to take a lead role in a team project.",
              },
              {
                id: "imr-3:4-d",
                da: " Join special committees, at work or privately, that expose you to group dynamics.",
              },
              {
                id: "imr-3:4-e",
                da: " Become familiar with the competencies required to manage others. Talk to an HR consultant  about the 360° assessment process and the company's Individual Talent Analysis, which provide an in-depth view of areas for development.",
              },
              {
                id: "imr-3:4-f",
                da: " Read The Leadership Pipeline by authors Charan, Drotter and Noel.",
              },
            ],
          },
        ],
      },
      en: {
        characteristic: "Negotiating Effectively",
        wdd: "Interacting with others confidently; communicating in a tactful, non-confrontational and polite manner; reaching win-win outcomes even when there are conflicting interests and limited resources; knowing how to manage the politics of relationships.",
        icon: require("@/assets/Iconography/Characteristics/06_Effective Negotiator.svg"),
        competencies: [
          {
            id: "en-0",
            icon: require("@/assets/Iconography/Attributes/06-04_Acting Confidently.svg"),
            comp: "Acting confidently",
            wdd: "Is confident when interacting with others, even those with greater authority",
            progressMeasures: [
              {
                id: "en-0-0",
                pm: "I am comfortable expressing myself in front of others",
                pmMap: "Comfortably express myself in front of others",
              },
              {
                id: "en-0-1",
                pm: "I believe I am competent in what I do",
                pmMap: "Competent in work",
              },
              {
                id: "en-0-2",
                pm: "Mostly, I have a “can do” attitude",
                pmMap: "Have a “can do” attitude",
              },
              {
                id: "en-0-3",
                pm: "I am not embarrassed easily",
                pmMap: "Not become embarrassed easily",
              },
            ],
            developmentActions: [
              {
                id: "en-0:1-a",
                da: " Others may know more than you in some areas, but every person brings both strengths and weaknesses to their jobs. Promote your strengths by identifying the parts of a project to which you can add most value. If you are a good problem solver, for example, but are not familiar with the subject, you can still help the team to organize their ideas logically and add value by asking questions from an outsider's perspective. Which strengths do you add, regardless of your assignment?",
              },
              {
                id: "en-0:1-b",
                da: " Roll up your sleeves and jump in. Nothing will give you more confidence than mastering what you did not know. Become involved in projects and assignments that will help you to gain knowledge in the areas in which you are least confident. Many companies have rotation opportunities for employees to work in different areas of the organization. Ask for assignments that are different from what you have mastered.",
              },
              {
                id: "en-0:1-c",
                da: " Engage with people who know more than you or are experts in a particular field. Instead of comparing yourself to them, choose to learn from them.",
              },
              {
                id: "en-0:1-d",
                da: " Do not pretend to know what you do not. It is perfectly acceptable that you are not an expert in everything. Defer questions you cannot answer to someone who can, or do your research and get back to the person. People appreciate honesty and will have more respect for you if you do not mislead them.",
              },
              {
                id: "en-0:1-e",
                da: " Be a student. Accept the role of asking many questions.",
              },
              {
                id: "en-0:1-f",
                da: " Do not give up at the moment things get particularly difficult or confusing. It is part of the learning process and the stage in which most people lose confidence.",
              },
              {
                id: "en-0:1-g",
                da: " Ask to be included in meetings and conference calls even when you are not going to participate. The exposure is invaluable in getting comfortable with different settings and building confidence.",
              },
              {
                id: "en-0:2-a",
                da: " Positive affirmation can help you to rewire your thinking. Be vigilant about negative thoughts and practice to replace them with positive thinking.",
              },
              {
                id: "en-0:2-b",
                da: " Identify someone you admire for their self-confidence and discuss how they view the world. Note the differences in their views and yours.",
              },
              {
                id: "en-0:2-c",
                da: " Do not place more importance on mistakes than they deserve. Write down the worstcase scenario. Unless someone's life is threatened, the consequences are really not as bad as you think.",
              },
              {
                id: "en-0:2-d",
                da: " Read about the many famous people in history who were undeterred by their mistakes and went on to change the world. For example, Thomas Edison experienced 10 000 failures before perfecting the light bulb. It is a good thing that he had the confidence to continue after the first few hundred mistakes!",
              },
              {
                id: "en-0:2-e",
                da: " You cannot predict anything100% correctly or control things fully. Make a list of the things over which you do have control versus the things you do not. Make peace with a balance between the two and focus only on the things you can control. For example, do your home work on the topic, rehearse your speech, become familiar with the setting in which you will be presenting it, get to know individuals in the meeting before the big day, and so forth. You have then done your part and the rest is beyond your control.",
              },
              {
                id: "en-0:2-f",
                da: " Stop thinking too much about how things will be done and focus on getting started instead. Trust that the process will resolve itself. Choose something you have been putting off and tackle it today.",
              },
              {
                id: "en-0:2-g",
                da: " Team up with someone who is action-oriented to help you get started and give you support.",
              },
              {
                id: "en-0:2-h",
                da: " Remember that most projects have strict deadlines and always take longer to complete than you expected, so consider that when framing timelines.",
              },
              {
                id: "en-0:2-i",
                da: " Prioritize your time. Some things require a great deal of attention and detail and others do not. For example, spending time to perfect an e-mail to a peer is unnecessary, but doing it to examine a contract carefully is time well spent.",
              },
              {
                id: "en-0:3-a",
                da: " Exposing yourself to the situations or people that make you fearful is the best way to address your anxiety and gain confidence. The more exposure you have to these situations, the more you will raise your comfort level. Find ways to participate, if only minimally at first, in these kind of settings.",
              },
              {
                id: "en-0:3-b",
                da: " Share your anxiety. Find someone who can give you support in times when you are most anxious. For example, if you do not like being in large groups but need to attend a networking function, find a co-worker who enjoys socializing to accompany you.",
              },
              {
                id: "en-0:3-c",
                da: " If you are uncomfortable around those with greater authority, make a conscious effort to try to get to know them on a more personal level. It will help to challenge your assumptions about them and see them as individuals instead of authority figures. Talk to individuals while you are waiting for meetings to start; attend social gatherings that allow you to interact in a relaxed manner; gain insight into people by asking others what they think of them.",
              },
              {
                id: "en-0:3-d",
                da: " Ask a professional counselor for techniques to relax and reduce anxiety. Breathing exercises, bio-feedback, visualization and hypnosis are just a few of the tools available to you.",
              },
              {
                id: "en-0:4-a",
                da: " Positive affirmation can help you to rewire your thinking. Be vigilant about negative thoughts and practice to replace them with positive thinking.",
              },
              {
                id: "en-0:4-b",
                da: " Consider how you would react if someone else slipped up in front of you. You would not crucify them. We tend to be hardest on ourselves. When you look around the room, remind yourself that people leave room for mistakes and are more empathetic than you think.",
              },
              {
                id: "en-0:4-c",
                da: " Get feedback about how your presentation went or how well your work turned out. Because you are your own worst critic, others can provide a more realistic perspective.",
              },
              {
                id: "en-0:4-d",
                da: " Use your sense of humor and practice poking fun at yourself, even in public. It is an easy way to connect with others and take pressure off you. How many times have you looked at situations and found their funny sides in hindsight? Try using that perspective in the present.",
              },
              {
                id: "en-0:4-e",
                da: " Focus on the issues or problem instead of yourself.",
              },
            ],
          },
          {
            id: "en-1",
            icon: require("@/assets/Iconography/Attributes/06-03_Acting Diplomatically.svg"),
            comp: "Acting diplomatically",
            wdd: "Is tactful and can communicate in a non-confrontational and polite manner",
            progressMeasures: [
              {
                id: "en-1-0",
                pm: "I am able to defuse tense situations",
                pmMap: "Defuse tense situations",
              },
              {
                id: "en-1-1",
                pm: "I relate well to people even if they are different from me",
                pmMap:
                  "Relate well to people even if they are different from me",
              },
              {
                id: "en-1-2",
                pm: "I communicate delicate information in a tactful manner",
                pmMap: "Communicate delicate information in a tactful manner",
              },
              {
                id: "en-1-3",
                pm: "I am able to be honest without being disrespectful",
                pmMap: "Be honest without being disrespectful",
              },
            ],
            developmentActions: [
              {
                id: "en-1:1-a",
                da: " Depersonalize the interaction. Think of yourself as acting in a role, for example, as a manager dealing with staff, a customer service representative dealing with a customer etcetera. You are not being attacked by the other person or people; they are interacting with your role.",
              },
              {
                id: "en-1:1-b",
                da: " Think before you speak. Once you have said something, you cannot take it back. People will remember utterances that provoked a strong emotional response. Saying something that offends, humiliates or criticizes will damage a relationship.",
              },
              {
                id: "en-1:1-c",
                da: " Manage your emotions. Being aware of your own emotional triggers will help to prevent emotional outbursts that can damage a relationship. Think of it as identifying your 'red buttons', for example, someone making a racist comment or implying you lack intelligence may provoke a stronger than usual reaction from you.",
              },
              {
                id: "en-1:1-d",
                da: " Listen more than you talk. Diplomacy requires an understanding of people, their agendas, belief systems and values. These things can be identified if you listen to what is not being said, too. Most of the time you get important information not just from the message, but from its delivery. Be aware of timing and tone.",
              },
              {
                id: "en-1:2-a",
                da: " Consider the reasons why you want to communicate certain information to someone. Is the message critical to the parties involved, or are you satisfying a personal and emotional need by sharing it?",
              },
              {
                id: "en-1:2-b",
                da: " Good timing is essential. You may be more successful in sharing your thoughts later, so be patient and hold off if you believe people will be more receptive at a later stage.",
              },
              {
                id: "en-1:2-c",
                da: " Put yourself in the other person's shoes. There are probably some things about which you are sensitive that would offend you if someone shared them with you. Make the effort to understand the impact of what you have to say on the person. Weigh whether it is important enough to say at all. If it is, how would you have liked to hear it?",
              },
              {
                id: "en-1:2-d",
                da: " Remain composed throughout. It puts you in a better position to handle conflict or tense situations. Do not take things personally. In tense circumstances, you can expect emotions to run high and people will be more prone to launching unfair attacks. If you are feeling too emotional, refrain from responding and take time to collect your thoughts. You can ask for time to think things through, if necessary. Keep your tone of voice consistent and calm, because raising it will only encourage others to do the same.",
              },
              {
                id: "en-1:2-e",
                da: " Get a good reading on your audience and adjust your strategy accordingly. Invariably, some people will need more delicate handling than others.",
              },
              {
                id: "en-1:3-a",
                da: " It is difficult to establish a mutually respectful relationship if you do not genuinely listen to what people have to say. Whether you agree or not, acknowledge the other person's point of view. Focus on being attentive instead of telling people 'the way it is'.",
              },
              {
                id: "en-1:3-b",
                da: " Ask people's opinions and do not make quick judgments or speak dismissively, indicating you already have all the answers.",
              },
              {
                id: "en-1:3-c",
                da: " Guard against aggressive body language or behaviors that others could perceive as overly authoritarian or arrogant, for example, raising your voice, interrupting people or cutting them off, crossing your arms in front of your body, or tapping your foot impatiently.",
              },
              {
                id: "en-1:4-a",
                da: " Guard against hidden biases. You may be quite diplomatic with most people, except those from a particular group. Consider taking the implicit association test which is available at www.understandingprejudice.org/iat/. It will help to identify subconscious biases.",
              },
              {
                id: "en-1:4-b",
                da: " If you struggle to understand another person's perspective, focus on your commonalities. They tend to be universal, for example, an appreciation of good service, desire to advance a career, recognition of the importance of quality family time anything that binds you and the person together.",
              },
              {
                id: "en-1:4-c",
                da: " Read biographies or watch documentaries about great politicians. Note how they interact with different interest groups, get their message across or state their opinion without offending or alienating people who hold different views.",
              },
            ],
          },
          {
            id: "en-2",
            icon: require("@/assets/Iconography/Attributes/06-02_Managing Negotiations.svg"),
            comp: "Managing negotiations",
            wdd: "Achieves a win-win outcome even when there are conflicting interests and limited resources",
            progressMeasures: [
              {
                id: "en-2-0",
                pm: "I can reach a compromise when negotiating",
                pmMap: "Reach a compromise when negotiating",
              },
              {
                id: "en-2-1",
                pm: "I usually arrive at outcomes that benefit both parties",
                pmMap: "Arrive at outcomes that benefit both parties",
              },
              {
                id: "en-2-2",
                pm: "When the negotiation is over, both parties usually feel positive",
                pmMap:
                  "Ensure both parties usually feel positive when the negotiation is over",
              },
              {
                id: "en-2-3",
                pm: "It does not bother me to ask for what I want",
                pmMap: "Ask for what I want",
              },
            ],
            developmentActions: [
              {
                id: "en-2:1-a",
                da: " Work on your style and approach: stay composed, do not raise your voice, restate what the other person has said and acknowledge their point of view. Such an approach is critical to maintain a productive discussion - loud displays or outbursts will always work to your disadvantage.",
              },
              {
                id: "en-2:1-b",
                da: " If talking about people's emotions is important to clear the air, do so but manage the conversation carefully. The goal is to address feelings but get to the business of discussing facts as quickly as possible.",
              },
              {
                id: "en-2:1-c",
                da: " Allow the other party to vent their frustrations so that they feel they have been heard. It will probably reduce volatility during the discussions.",
              },
              {
                id: "en-2:1-d",
                da: " If discussions between you and another person heat up, speak to them as if they are not upset, regardless of their reaction. Focus on your response, not their reaction.",
              },
              {
                id: "en-2:1-e",
                da: " Try to be empathetic when a situation is emotionally charged. Why does the other party feel so strongly about a position?",
              },
              {
                id: "en-2:1-f",
                da: " Be quiet at the right moments. When people become anxious, it is a natural human reaction to try to fill the silence with meaningless noise, especially during conflict. During negotiations, anxious people tend to say things that erode their positions. Bide your time by asking questions.",
              },
              {
                id: "en-2:1-g",
                da: " Are you giving away your emotions inadvertently - do you roll your eyes, look away impatiently, fidget? Be conscious of the signals you send.",
              },
              {
                id: "en-2:1-h",
                da: " Do not get pulled in by others' threats, blame or games. Remember, these tactics can rattle you, so do not let them.",
              },
              {
                id: "en-2:2-a",
                da: " Only consider a win-lose negotiation if you do not need an ongoing relationship with the other party. A party that gains no benefits from a negotiation will be reluctant to maintain a relationship with you.",
              },
              {
                id: "en-2:2-b",
                da: " Consider honesty and openness before manipulation and let common principles of ethics and fairness guide you when negotiating.",
              },
              {
                id: "en-2:2-c",
                da: " Avoid coming to the table with inflexible black-or-white positions. There is always room to consider other options if you really listen to what the other side has to say.",
              },
              {
                id: "en-2:2-d",
                da: " Refrain from using threats to get your way. Threats are unproductive and only serve to put the other party on the defensive.",
              },
              {
                id: "en-2:2-e",
                da: " Before negotiating, think carefully about the points you could concede and keep those for leverage. Even if you have the advantage, conceding to some points establishes goodwill and allows the other party to walk away with some sense of gain.",
              },
              {
                id: "en-2:3-a",
                da: " Start negotiations by establishing an environment of cooperation. Allow people to have a short period to mingle informally and engage in small talk, arrange the seating to not differentiate sides, have breaks and encourage people to talk among themselves.",
              },
              {
                id: "en-2:3-b",
                da: " Allow parties to verbalize their goals for the meeting.",
              },
              {
                id: "en-2:3-c",
                da: " Always listen to the issues and underlying interests of the parties involved and try to understand them. It is surprising how many negotiations fail due to the issues being misunderstood. Ask as many questions as possible to clarify people's motives and key concerns.",
              },
              {
                id: "en-2:3-d",
                da: " Take steps to ensure that all parties actually hear each other. Rephrase what a person says during a discussion if there is any doubt. Summarize the major points made as the conversation progresses.",
              },
              {
                id: "en-2:3-e",
                da: " Use language that clearly indicates your willingness to solve a problem in a mutually beneficial way and work together. Use sentences such as 'What if we try this?' or 'What do you think about the two of us taking this approach?'",
              },
              {
                id: "en-2:3-f",
                da: " Use non-verbal communication to let the other party know you are listening and open to discussion - maintain eye contact and nod when you understand. Avoid a posture that says you feel defensive or threatened, such as crossing your arms, scowling, shaking your head or leaning back in your chair as if you have disengaged.",
              },
              {
                id: "en-2:3-g",
                da: " Think about the other party's personal style. Do they tend to be diplomatic, or are they more frank and lay everything on the table upfront? Adapt accordingly as you negotiate.",
              },
              {
                id: "en-2:3-h",
                da: " Consider the negotiation points that are of little value to you and highly valued by the other party. If you have to give in, it is important to know what these points are in advance.",
              },
              {
                id: "en-2:3-i",
                da: " Make any progress and agreement as visible as possible. Document success throughout the discussions by writing the agreed-upon points on a flipchart or board. When frustration is high, refer to the progress that has been made.",
              },
              {
                id: "en-2:3-j",
                da: " Utilize comparable or precedent-setting transactions as a benchmark for negotiations. The information can help you to gauge the type of outcome you might expect and understand the points to which the other party will likely be willing to agree.",
              },
              {
                id: "en-2:4-a",
                da: " Consider all your interests before negotiations begin. You may have to concede some points, but be clear about the ones you absolutely cannot concede. If you cannot negotiate a win-win solution, what is the least acceptable scenario? Knowing that will help you to stick to your guns.",
              },
              {
                id: "en-2:4-b",
                da: " If the other party has adopted the role of tough negotiator, find ways during the process to commend them on their toughness and recognize that they drive a hard bargain.",
              },
              {
                id: "en-2:4-c",
                da: " If you cannot agree on everything, work on the points that are critical and focus on them for now. Agree to address the other points later, but try to set a precedent for a successful negotiation experience.",
              },
              {
                id: "en-2:4-d",
                da: " If you have reached a stalemate, consider engaging an arbitrator acceptable to both parties instead of conceding.",
              },
              {
                id: "en-2:4-e",
                da: " Be prepared to walk away rather than give in. This may not be the best time to negotiate and there may be another way to get what you need. Walking away when you do not stand to gain anything is perfectly acceptable.",
              },
              {
                id: "en-2:5-a",
                da: " Consider the negotiation's goals. What do you want from it? What do you think the other person wants?",
              },
              {
                id: "en-2:5-b",
                da: " Consider possible solutions and alternatives. If you do not reach an agreement with the other party, what are your alternatives? Are they good or bad? How much does it matter if you cannot agree? Does failure to reach an agreement eliminate future opportunities? Which alternatives could the other person have?",
              },
              {
                id: "en-2:5-c",
                da: " Consider relationships. What is a relationship's history; could or should it have an impact on the negotiation? Are there any hidden issues that could influence the negotiation and how will you handle these?",
              },
              {
                id: "en-2:5-d",
                da: " Consider the consequences of you winning or losing this negotiation. and what they mean to the other person.",
              },
              {
                id: "en-2:5-e",
                da: " Who holds what kind of power in the relationship? Who controls resources? Who stands to lose the most if agreement is not forthcoming? What power does the other person have to satisfy your needs?",
              },
              {
                id: "en-2:5-f",
                da: " Never make a false statement or assertion, and collect as much accurate information as possible before any negotiations.",
              },
            ],
          },
          {
            id: "en-3",
            icon: require("@/assets/Iconography/Attributes/06-01_Being Politically Astute.svg"),
            comp: "Being politically astute",
            wdd: "Is aware of and can manage the dynamics of power within an organization",
            progressMeasures: [
              {
                id: "en-3-0",
                pm: "I adapt my approach based on a particular situation or person",
                pmMap:
                  "Adapt my approach based on a particular situation or person",
              },
              {
                id: "en-3-1",
                pm: "I understand how personal power dynamics influence people and the decisions they make",
                pmMap:
                  "Understand how personal power dynamics influence people and the decisions they make",
              },
              {
                id: "en-3-2",
                pm: "I seldom, or never, get others in trouble because of what I say",
                pmMap:
                  "Seldom, or never, get others in trouble because of what I say",
              },
              {
                id: "en-3-3",
                pm: "I know which information to share with whom",
                pmMap: "Know which information to share with whom",
              },
            ],
            developmentActions: [
              {
                id: "en-3:1-a",
                da: " Observe what enables a respected leader in your organization to use politics to push an agenda. It can help to dispel a stereotype you may hold about the nature of politicking.",
              },
              {
                id: "en-3:1-b",
                da: " Read about politically astute leaders, such as Mahatma Gandhi and Nelson Mandela, who are widely respected and overcame tremendous obstacles by somehow managing the politics of their time. It will provide a different perspective of politics.",
              },
              {
                id: "en-3:1-c",
                da: " Remain genuine and sincere. If your actions are guided by what is best for the organization, rather than what is best for you, you will feel more comfortable.",
              },
              {
                id: "en-3:1-d",
                da: " Make clear to yourself why it is necessary to use politics in the goal you are trying to achieve. Compile a list of ways the 'right' people can help you to accomplish your goal more effectively. Does it make sense to do it on your own? Do you believe in your position enough to defend it? On which ethics or values do you really have to infringe to achieve your goal?",
              },
              {
                id: "en-3:1-e",
                da: " Sometimes, as skeptics, we dehumanize people with political power. Attend organizational events that give you an opportunity to talk to key decision makers on a more personal level. Find your common interests, passions and humanity. You will find many respectable, honest people just like you.",
              },
              {
                id: "en-3:2-a",
                da: " Find a trusted peer or mentor in your organization with whom you can discuss the internal politics. Learn to understand who holds the power to make decisions in different areas, both in theory and reality.",
              },
              {
                id: "en-3:2-b",
                da: " Become familiar with the company's organizational chart and its critical positions. Make it a goal to introduce yourself at least once to everyone in key positions.",
              },
              {
                id: "en-3:2-c",
                da: " Maximize your networking opportunities. Attend receptions, company events and conferences to establish relationships with as many people as possible, not just in your company but also in your field.",
              },
              {
                id: "en-3:2-d",
                da: " Be prepared to succinctly communicate the way your work, project or idea can make a difference. You do not often have the opportunity to discuss your ideas at length, so a well-communicated and convincing speech is important.",
              },
              {
                id: "en-3:2-e",
                da: " Make allies of the relevant people. Keep them informed of the obstacles you encounter, including resistance from people or departments. Together you can develop a strategy to overcome these hurdles and share the task of influencing others.",
              },
              {
                id: "en-3:2-f",
                da: " Try to develop coalitions for maximum influence. Power often lies in numbers and some issues need a coalition to push an agenda.",
              },
              {
                id: "en-3:2-g",
                da: " Are there specific groups with which you have trouble politically, all or most of the time? Look for particular biases you may harbor. You may think they are invisible, but people quickly pick up subtleties in behavior or language that makes them defensive and resistant to your influence.",
              },
              {
                id: "en-3:2-h",
                da: " Timing can make all the difference in garnering support. Sometimes it simply is not the right time to keep pushing. Be sensitive about times you may need to back off in order to keep the door open for later. List the conditions that make this an inappropriate time to introduce your agenda.",
              },
              {
                id: "en-3:2-i",
                da: " Often, it is not that you have reached the wrong people, but your delivery has not been well received. Poor communication or interpersonal skills are a surefire way to lose influence. A 360Â° assessment is effective for feedback on your strengths and weaknesses, as well as issues on which you can work with a coach.",
              },
              {
                id: "en-3:2-j",
                da: " Read about ordinary people such as Erin Brockovich who, with little political experience, was able to navigate through complex politics and exert great influence.",
              },
              {
                id: "en-3:3-a",
                da: " Forward e-mails of praise from clients or other team members to relevant people.",
              },
              {
                id: "en-3:3-b",
                da: " Keep a list of major accomplishments for your reference during performance reviews. The person doing your evaluation may not remember all your achievements throughout the year.",
              },
              {
                id: "en-3:3-c",
                da: " Ask experts and respected colleagues their professional opinions and advice on a project. It gives you an opportunity to meet influential people and make your work visible.",
              },
              {
                id: "en-3:3-d",
                da: " Become involved in projects beyond your immediate scope that expose you to decision makers. For example, volunteer for a taskforce or committee.",
              },
              {
                id: "en-3:3-e",
                da: " If, at first, you are uncomfortable to promote your talents, talk about your team's accomplishments. It will highlight your achievements indirectly.",
              },
              {
                id: "en-3:3-f",
                da: " Invite key decision makers from other divisions or groups to add value to your meetings and become familiar with your projects.",
              },
              {
                id: "en-3:3-g",
                da: " Your accomplishments may speak for themselves at present, but a former leader in your organization may not have had the same experience with you. Do not overlook previous relationships that may require extra attention or even repair.",
              },
            ],
          },
        ],
      },
      sc: {
        characteristic: "Communication Skills",
        wdd: "Clearly explaining a point of view and its reasoning in both one-on-one and large audience situations; writing accurately and professionally in multiple formats, with the correct amount of detail; keeping people informed with relevant and well-timed information.",
        icon: require("@/assets/Iconography/Characteristics/15_Skilled Communicator.svg"),
        competencies: [
          {
            id: "sc-0",
            icon: require("@/assets/Iconography/Attributes/15-03_Communicating Well (Verbally).svg"),
            comp: "Communicating well (verbally)",
            wdd: "Clearly explains a point of view and its reasoning in both one-on-one and large audience situations",
            progressMeasures: [
              {
                id: "sc-0-0",
                pm: "I am confident when speaking to others",
                pmMap: "Be confident when speaking to others",
              },
              {
                id: "sc-0-1",
                pm: "My thoughts are well organized when I speak",
                pmMap: "Organize my thoughts well organized when I speak",
              },
              {
                id: "sc-0-2",
                pm: "I adapt how I communicate depending on the situation",
                pmMap: "Adapt how I communicate depending on the situation",
              },
              {
                id: "sc-0-3",
                pm: "I am usually able to add to a conversation",
                pmMap: "Add meaningful input to a conversation",
              },
              {
                id: "sc-0-4",
                pm: "I provide enough context (make sure others are on the same page) when I start a discussion",
                pmMap:
                  "Provide enough context (make sure others are on the same page) when I start a discussion",
              },
            ],
            developmentActions: [
              {
                id: "sc-0:1-a",
                da: " There are many strategies you can practice daily to help you relax and give you better control of your body's physical reaction to stress. Explore, for example, relaxation techniques such as deep breathing and meditation. Practicing daily makes control of your responses more automatic and it will become like anything else in which you invest time and diligent practice - you will improve.",
              },
              {
                id: "sc-0:1-b",
                da: " Your alarm response in presentation situations is based on irrational and disproportionate fear of the situation at hand. Your body does not know this, so your mind must provide perspective. Use positive self-reinforcement to address irrational negative thoughts. For example, replace 'What if I don't know how to answer a question?' with 'I can't possibly know everything'. Then find a balanced solution, such as 'I will get back to the person with the answer later'. Pay attention to and become aware of negative reinforcement.",
              },
              {
                id: "sc-0:1-c",
                da: " Use the visualization technique to get you more comfortable with the pending presentation, in other words, imagine yourself having a successful presentation. Try to go through the details in your mind. Make the experience as real as possible. Do this repeatedly until you start to believe what you visualize.",
              },
              {
                id: "sc-0:1-d",
                da: " Remain objective about your purpose: to communicate and engage people in conversation. If, in the process, people agree with you and like you and you are able to answer every question, that is simply a bonus, not your objective. Until you are more comfortable with presentations, remove unnecessary pressures and simply aim to effectively deliver the information.",
              },
              {
                id: "sc-0:1-e",
                da: " Join organizations such as Toast Masters, which helps you to practice gaining confidence to speak and present effectively in public because it provides experience in a non-threatening setting.",
              },
              {
                id: "sc-0:1-f",
                da: " Read some of the hundreds of books on effective public speaking, such as Public Speaking for Success by Dale Carnegie.",
              },
              {
                id: "sc-0:1-g",
                da: " Become intimate and comfortable with the subject matter. The more you know the more self-confident you will feel. You may need to do supplementary reading or talk to experts to help you.",
              },
              {
                id: "sc-0:1-h",
                da: " Use prompts such as note cards and PowerPoint presentations, but only as guides. Reading notes verbatim during a presentation makes it dry and you will not be perceived as adding value. It also discourages you from relaxing and letting your personality shine through.",
              },
              {
                id: "sc-0:1-i",
                da: " Act the part until you believe it. Speak confidently, even if you are not. No one knows you are uncomfortable unless you let it show. Look at your audience directly and speak up so that everyone can hear you. Avoid justifying or apologizing for everything you say, or fidgeting unnecessarily, because it will signal that you are nervous and lack confidence.",
              },
              {
                id: "sc-0:1-j",
                da: " Consult a professional counselor for relaxation techniques and anxiety reduction. Breathing exercises, bio-feedback and visualization are just a few of the tools you can use.",
              },
              {
                id: "sc-0:2-a",
                da: " You do not need to be scripted to present well or hold a discussion eloquently, but if you tend to lose track easily, spend some time to organize your thoughts beforehand. Create a logical flow for communicating your ideas. Map what you want to communicate and ensure there is order to your ideas. Share the outline with a peer to see if it makes sense. Try using software such as MindJet Manager to map ideas beforehand or as they are discussed.",
              },
              {
                id: "sc-0:2-b",
                da: " Use prompts to help you stay on track. Draw up an agenda and make sure you do not veer from it. Ensure the agenda states the goals of the meeting or presentation. Even less formal discussions can benefit from an agenda. Prepare visual aids such as a PowerPoint presentation or simple note cards with the key points you must address by the end of the discussion. Your tendency might be to 'wing it', but the necessary preparation will be to your advantage.",
              },
              {
                id: "sc-0:2-c",
                da: " Manage the amount of detail you provide when talking or presenting. Too much detail makes it difficult for people to remain focused on your point. Always ask yourself while talking whether the detail you are providing is critical to the conversation, or simply added information.",
              },
              {
                id: "sc-0:2-d",
                da: " Limit the amount of tangential conversation and personal anecdotes you introduce to a conversation. These departures from the topic can waste much time and distract your audience. Ask a trusted peer to point out when you are digressing. Being aware of the frequency with which you do this can help you to adjust your conversation style.",
              },
              {
                id: "sc-0:2-e",
                da: " Know your stuff! Although you cannot be an expert on everything, the more you know about a topic the more likely you are to provide relevant information.",
              },
              {
                id: "sc-0:2-f",
                da: " Do not assume that everyone is like you. Some people need you to get directly to the point and others want all the details. Are you getting cut short quite often? Do people tend to avoid asking you questions? Try to read the person's reactions or ask them whether you are providing too much information.",
              },
              {
                id: "sc-0:2-g",
                da: " Are you easily distracted? Always anticipate that you will be interrupted or asked questions when trying to make a point. If the question is not relevant, table it and, as tempting as it may be, avoid pursuing unnecessary digressions.",
              },
              {
                id: "sc-0:2-h",
                da: " To the extent that you can, make a conscious effort to minimize distractions in your environment beforehand. Schedule meetings in quiet places far from activity, ask people to turn off their phones and be conscious of minimizing distractions, and involve the appropriate number of people in meetings - the number should maximize input but limit distractions that will interrupt your focus.",
              },
              {
                id: "sc-0:2-i",
                da: " Try not to jump from thought to thought or topic to topic without closure or sufficient introduction to a new topic. Some people may be able to follow your communication, but others think linearly and need the conversation to be more organized.",
              },
              {
                id: "sc-0:2-j",
                da: " Do not forget to provide sufficient context for people when you start a conversation. Recap briefly where things stand and make sure people know what you are talking about before jumping to details.",
              },
              {
                id: "sc-0:3-a",
                da: " When doing a presentation, it is easy to get caught up in the message and forget the listener. Stay in touch with your audience. For example, routinely ask whether they are following the point, hearing you well, or whether you need to talk slower. Keep gauging where they stand and whether you have to adjust your communication style. Be sure to get feedback at the end of the presentation to identify where there is room for improvement.",
              },
              {
                id: "sc-0:3-b",
                da: " What does your audience need to hear or see to remain engaged? Details, visuals, business cases? Perhaps you should cover more bases if you have a diverse audience.",
              },
              {
                id: "sc-0:3-c",
                da: " If you are presenting to people of a specific cultural group, become knowledgeable about their sensitivities and norms. Talk to a consultant, read about the culture and ask others who have had experience with that group.",
              },
              {
                id: "sc-0:3-d",
                da: " When speaking one on one, consider the individual's personality. Is the person more people oriented, analytical or reserved? Craft your message with the individual's personality in mind.",
              },
              {
                id: "sc-0:3-e",
                da: " Consider the complexity of your message. The audience's level of understanding of the subject will determine the information you provide, in other words, how complex or simple the message must be. If the people you are talking to are not experts on the subject, try to avoid technical jargon or unnecessary information that will leave them confused or frustrated.",
              },
              {
                id: "sc-0:4-a",
                da: " Recognize your 'hot buttons' and when they are being pressed. Take a deep breath and give yourself time to calm down before responding. Remind yourself of your purpose - to have your point both heard and understood. It may require a great deal of patience.",
              },
              {
                id: "sc-0:4-b",
                da: " Ask for some time to collect yourself. You may need to leave the room, which is preferable to losing your focus entirely.",
              },
              {
                id: "sc-0:4-c",
                da: " Try to stay objective and patient. You do not have control over people's moods or their lack of respect. How is getting emotional going to improve the situation?",
              },
              {
                id: "sc-0:5-a",
                da: " Do supplementary reading on the relevant topic before going to a meeting or gathering of people.",
              },
              {
                id: "sc-0:5-b",
                da: " Read the newspaper as often as possible to stay knowledgeable about current events.",
              },
              {
                id: "sc-0:5-c",
                da: " Expose yourself to different methods of expression. Try to read diverse types of literature, for example, fiction, business journals, poetry and white papers. Take note of the vocabulary use, metaphors and analogies that you can incorporate into your communication.",
              },
              {
                id: "sc-0:5-d",
                da: " Attend a storytelling workshop to help you understand how to express yourself and optimally engage your audience.",
              },
              {
                id: "sc-0:5-e",
                da: " Spend time with peers who are effective communicators. Which topics do they cover? How do they manage small talk?",
              },
              {
                id: "sc-0:6-a",
                da: " Instead of ignoring your condition, address it upfront so that others know it is not a taboo subject and can move on to the relevant issues.",
              },
              {
                id: "sc-0:6-b",
                da: " If you are comfortable doing so, use humor to break the ice about your particular circumstances.",
              },
              {
                id: "sc-0:6-c",
                da: " Focus on the things over which you have control - how well you know the topic and how prepared, personable and approachable you are.",
              },
              {
                id: "sc-0:6-d",
                da: " Seek a voice coach, therapist or voice clinic where you can find support and learn techniques to deal with speech issues.",
              },
              {
                id: "sc-0:6-e",
                da: " Engage a native-language teacher to help with your accent.",
              },
            ],
          },
          {
            id: "sc-1",
            icon: require("@/assets/Iconography/Attributes/15-02_Communicating Well (Written).svg"),
            comp: "Communicating well (written)",
            wdd: "Writes accurately and professionally in multiple formats, with the correct amount of detail",
            progressMeasures: [
              {
                id: "sc-1-0",
                pm: "I rarely need to clarify what I have written",
                pmMap: "Clarify what I have written",
              },
              {
                id: "sc-1-1",
                pm: "I adapt my writing style to suit the recipient",
                pmMap: "Adapt my writing style to suit the recipient",
              },
              {
                id: "sc-1-2",
                pm: "I have a good understanding of basic grammar",
                pmMap: "Have a good understanding of basic grammar",
              },
              {
                id: "sc-1-3",
                pm: "I always correct or edit my writing before sending it",
                pmMap: "Always correct or edit my writing before sending it",
              },
              {
                id: "sc-1-4",
                pm: "I can get my point across in few words",
                pmMap: "Get my point across in few words",
              },
            ],
            developmentActions: [
              {
                id: "sc-1:1-a",
                da: " Always reread and edit what you have written. Mistakes are easy to make when you write something quickly and a simple review will catch them.",
              },
              {
                id: "sc-1:1-b",
                da: " Let a second pair of eyes look at your writing - a peer or an assistant can review important information you are sending out. It is remarkable how many mistakes another person catches. Try to improve the amount of mistakes you make.",
              },
              {
                id: "sc-1:1-c",
                da: " Do not assume people know what you are talking about, particularly if your writing style is quite concise. Ensure people have the appropriate context in which to understand your message.",
              },
              {
                id: "sc-1:1-d",
                da: " If you have the tendency to write as you speak, you may be using jargon or associate too freely in your writing. Conversations and written communication are very different methods of articulation and should not be confused in a professional setting.",
              },
              {
                id: "sc-1:2-a",
                da: " Organize your thoughts thoroughly before you start writing. Outline the points you want to make and ensure they are presented in a logical sequence. Review them with a peer to see if they make sense. If you are not naturally good at writing, use your other strengths to organize your thoughts beforehand. For example, if you are visually inclined, try software such as MindJet Manager to map and organize your ideas, or create your own drawing or illustration. If you are a verbal person, voice your thoughts out loud or make a recording of your proposals, then put them in writing.",
              },
              {
                id: "sc-1:2-b",
                da: " Do not provide unnecessary detail which will confuse or distract people from your written message. Which supporting information does the reader have to know? If the recipient is unfamiliar with the topic or subject, provide enough context to clarify your communication. Preferably, add attachments or provide supporting reference material to which the person can refer. Your basic message should provide the highlights or a brief historical summary only.",
              },
              {
                id: "sc-1:2-c",
                da: " Pay attention to formatting, especially when you need to communicate numerous points. Good formatting makes it much easier for the reader to follow your thoughts. For example, separate different points with paragraphs or appropriate titles or spacing, instead of all the information running together. Highlight in bold important points to which you want to draw attention. Although it may look somewhat dry and overly formal, use numbering or bullet points to order your writing.",
              },
              {
                id: "sc-1:2-d",
                da: " Poor grammar can make the simplest e-mail message hard to grasp. Ensure you understand the basic principles of punctuation. Use the spellcheck feature your software provides, but do not rely on that alone. Reread your work. Eats, Shoots and Leaves by Lynn Truss is an entertaining and insightful book about the perils of poor grammar.",
              },
              {
                id: "sc-1:2-e",
                da: " Curb repetitious statements or points that confuse your readers and sap their attention. You should not be repeating your point numerous times, except once in your summary. Reread what you have written and delete unnecessary statements - clear the 'noise' from your writing. This sounds simple, but it is not done often enough.",
              },
              {
                id: "sc-1:2-f",
                da: " Ask others if they have difficulty reading your work and understanding your message, and exactly what confuses them. Use their feedback to enhance your writing skills.",
              },
              {
                id: "sc-1:3-a",
                da: " Consider the reader's personality. Write for the reader, not for you. Is the reader sociable or reserved, analytical or full of humor? Craft your message with the person's personality in mind.",
              },
              {
                id: "sc-1:3-b",
                da: " How well do you know the reader? Unless you know the person relatively well, use more formal communication. Ensure your writing style is appropriate for both the message and the reader.",
              },
              {
                id: "sc-1:3-c",
                da: " Take a cue from others' writing style. For example, if they respond with brief oneliners, you should know to write succinctly as well.",
              },
              {
                id: "sc-1:3-d",
                da: " Keep cultural differences in mind when writing. People from Latin countries, for example, tend to expect less formality in their communication than those from the Orient. If you correspond regularly with a particular cultural group, it is worth it to do some research and become knowledgeable about their sensitivities and norms. Ask a consultant, read literature about the culture, ask people who have had experience with that group.",
              },
              {
                id: "sc-1:3-e",
                da: " Consider the reader's level of understanding of the subject. If the person is not an expert, avoid technical jargon and use analogies or explanations to which they can relate.",
              },
              {
                id: "sc-1:3-f",
                da: " Ensure your vocabulary is appropriate to your readers. Ceremonious language use with the wrong audience can irritate and distract them, and you could be perceived as arrogant.",
              },
              {
                id: "sc-1:3-g",
                da: " Be conscious of the reader's position and status relative to you. Those in upper management have to read great volumes of information, so respect their time by writing succinctly and clearly. Focus on distilling your information down to the critical points.",
              },
              {
                id: "sc-1:4-a",
                da: " You may be inspired to write when you are emotional. Do put your thoughts into words, but do not distribute the message or document until you are feeling less affected. Give yourself time to read it again in a less emotional state and use the opportunity to edit the content and tone of the message. If possible, allow a day or two to pass, then revisit your thoughts and writing.",
              },
              {
                id: "sc-1:4-b",
                da: " Show what you have written to a trusted peer or two and get their perspective on whether it is appropriate.",
              },
              {
                id: "sc-1:4-c",
                da: " Try to identify your so-called red buttons. Self-awareness can help you to recognize when you react too sensitively and give you a chance to modify your message. Keep a log of the types of comments, situations or people that put you on edge and learn from it.",
              },
              {
                id: "sc-1:4-d",
                da: " If you must respond immediately, take a deep breath and try to calm down. While you write, remind yourself that the purpose of communication is to get your point across. Do so in an objective manner and try to understand the recipient's point of view. It may require a great deal of patience, be warned!",
              },
              {
                id: "sc-1:4-e",
                da: " If you are sensitive about a subject and wish to communicate your feelings, preferably arrange a personal meeting. Writing is often not an easy medium through which to express your emotions calmly and clearly.",
              },
              {
                id: "sc-1:5-a",
                da: " Read as much as possible. Increase the amount of time you spend on reading - it is the only way to expose yourself to different styles of expression and enhance your vocabulary. Try to read diverse types of literature, for example, fiction, business journals, poetry, white papers. Take note of the vocabulary, metaphors and analogies which you can incorporate into your communication.",
              },
              {
                id: "sc-1:5-b",
                da: " Practice writing. Like any skill, it needs repeated application to improve. Keep a journal at home to get you in the habit of expressing your thoughts in writing, or take a creative writing course to stretch your imagination and abilities.",
              },
              {
                id: "sc-1:5-c",
                da: " Immediately consult the dictionary when you come across unfamiliar words. Memorize them and incorporate them in your written communication from now on. A good dictionary is an essential tool in every office, regardless of your position.",
              },
              {
                id: "sc-1:5-d",
                da: " Keep a Thesaurus close by to help you identify alternative words to use. There are many online Thesauruses and dictionaries available, but as a rule they are not as comprehensive as their printed counterparts.",
              },
              {
                id: "sc-1:5-e",
                da: " If you are not writing in your first language, ask a native speaker to help with phrases and word choices and how to translate what you mean.",
              },
            ],
          },
          {
            id: "sc-2",
            icon: require("@/assets/Iconography/Attributes/15-01_Informing Others.svg"),
            comp: "Informing others",
            wdd: "Keeps people informed with relevant and well-timed information",
            progressMeasures: [
              {
                id: "sc-2-0",
                pm: "I give feedback to others promptly enough for them to take action, if necessary",
                pmMap:
                  "Give feedback to others promptly enough for them to take action, if necessary",
              },
              {
                id: "sc-2-1",
                pm: "I consider my audience before deciding how to inform them",
                pmMap:
                  "Consider my audience before deciding how to inform them",
              },
              {
                id: "sc-2-2",
                pm: "I am willing to supply information that will not be well received",
                pmMap:
                  "Be willing to supply information that will not be well received",
              },
              {
                id: "sc-2-3",
                pm: "Even when I am upset with someone or disagree with them, I will share information freely",
                pmMap:
                  "Share information freely , even when I am upset with someone or disagree with them",
              },
              {
                id: "sc-2-4",
                pm: "I regularly inform people about the goings-on in the organization to keep them in the loop and motivated",
                pmMap:
                  "Regularly inform people about the goings-on in the organization to keep them in the loop and motivated",
              },
            ],
            developmentActions: [
              {
                id: "sc-2:1-a",
                da: " Get perspective. Ask a trusted peer who can treat the situation more objectively to give you their take on its gravity. The circumstances may not be as grave as they appear.",
              },
              {
                id: "sc-2:1-b",
                da: " Acknowledge the mistakes, but focus on the solution. If people are upset by the information, give them a chance to express themselves without trying to defend yourself. You have acknowledged the mistakes and it is unproductive to get caught up in defending them at this point.",
              },
              {
                id: "sc-2:1-c",
                da: " Do not make it worse by sugarcoating reality. Be truthful with the information you provide. Trying to make the outlook brighter to diminish a negative response means appropriate action cannot be taken, which can create further problems.",
              },
              {
                id: "sc-2:1-d",
                da: " Learn to confront people. Start by working on your conflict-management skills. Research the topic or engage a coach.",
              },
              {
                id: "sc-2:1-e",
                da: " Choose the most appropriate form of communication to ensure the information is received in the best way possible. Is it appropriate to inform people via e-mail, for example? It could be too impersonal for certain information.",
              },
              {
                id: "sc-2:1-f",
                da: " Speak up immediately. Every day you allow to pass will generate more stress for you, because it will become increasingly difficult to explain why you did not share the information sooner.",
              },
              {
                id: "sc-2:2-a",
                da: " Agree when and how you will keep relevant people informed. It can be in staff meetings, via e-mail correspondence or with a status report. The key is to establish a system that forces you to treat informing others as the priority it deserves to be.",
              },
              {
                id: "sc-2:2-b",
                da: " Schedule a realistic amount of time to share information and transfer knowledge. Because of tight schedules, the temptation is to be sparing with time for informational meetings. But people need to know sharing information is a priority for you, not an inconvenience.",
              },
              {
                id: "sc-2:2-c",
                da: " In the interest of time you may summarize too much. Ensure you provide enough context and history to make your information easy to digest.",
              },
              {
                id: "sc-2:3-a",
                da: " During meetings, listen to the type of information people may need to do their jobs and, if you have such material, share it with them.",
              },
              {
                id: "sc-2:3-b",
                da: " Establish informal, regular 'learning reviews' during which people get together to share what they have learned.",
              },
              {
                id: "sc-2:3-c",
                da: " Create mentorship programs and reward people who transfer their knowledge to others.",
              },
              {
                id: "sc-2:3-d",
                da: " Developing others is highly valued in an organization. Add the skill to your development plan and engage a coach to help you.",
              },
              {
                id: "sc-2:3-e",
                da: " If you withhold information because of strong negative feelings towards a person or an unresolved issue with them, try to resolve it through conversation. A person you both respect can assist in mediating the conflict in a professional manner.",
              },
              {
                id: "sc-2:3-f",
                da: " Be aware when favoritism determines with whom you share information, and the kind of information you reveal. Make a list of the people from whom you typically withhold information and discuss your reasons with a coach.",
              },
              {
                id: "sc-2:3-g",
                da: " You may be the only one who does not trust a person. Talk to a peer or mentor about your beliefs. It is important to get perspective and, sometimes, simply a reality check.",
              },
              {
                id: "sc-2:3-h",
                da: " Ask yourself whether your primary motive for withholding information is personal gain. If so, let it go.",
              },
              {
                id: "sc-2:4-a",
                da: " As a rule, assume people want to know everything. It is better to curb what you say than to be seen as unresponsive or lacking in customer service.",
              },
              {
                id: "sc-2:4-b",
                da: " If you think you may inconvenience people, ask them to clarify how much information they need.",
              },
              {
                id: "sc-2:4-c",
                da: " Copying relevant people on e-mails is a quick and easy way to keep them informed without extra work on your part. They can choose to ignore or read the correspondence. Do it habitually.",
              },
              {
                id: "sc-2:4-d",
                da: " Be conscious of the information people simply have to know and brief them. Take particular care to inform others about controversial issues and matters that negatively affect a client.",
              },
              {
                id: "sc-2:4-e",
                da: " How well informed are your internal and external customers? Establish a system to ensure you communicate important information about new products or changes in procedures and delivery dates in a timely manner. It mitigates any risks involved and sends a message to clients that you care and are in control.",
              },
              {
                id: "sc-2:4-f",
                da: " Do not assume your responsibility stops once you have informed people. As much as you can, create and follow up on further reminders.",
              },
              {
                id: "sc-2:4-g",
                da: " Ensure you have someone else on the team who is informed enough to understand the status of your projects and can step in when you are unavailable.",
              },
              {
                id: "sc-2:4-h",
                da: " Do not be tempted to finish a project completely before discussing it with your superior. Send constant updates or divide the project into smaller milestones on which you can report. Agree beforehand what those milestones will be.",
              },
              {
                id: "sc-2:5-a",
                da: " Think about the knowledge you have that may be valuable to other groups and share it with them.",
              },
              {
                id: "sc-2:5-b",
                da: " Communicate the usefulness of sharing information across teams and find ways of rewarding and encouraging it.",
              },
              {
                id: "sc-2:5-c",
                da: " Create opportunities for cross-functional interaction to break down structural silos.",
              },
              {
                id: "sc-2:5-d",
                da: " Get to know people from different divisions. It will facilitate swapping information.",
              },
              {
                id: "sc-2:5-e",
                da: " Understand the company's politics: who supposedly owns which information, who you should include in correspondence, and so forth. It will allow you to access information without crossing political boundaries.",
              },
            ],
          },
        ],
      },
      pf: {
        characteristic: "Practical Solutions",
        wdd: "Always looking for ways to improve processes; taking new ideas from concept to reality by managing the innovation process; solving challenging problems by using a combination of intuition and analytical thinking; quickly realizing the impact new technology and finding opportunities to integrate it.",
        icon: require("@/assets/Iconography/Characteristics/13_Practical Fixer.svg"),
        competencies: [
          {
            id: "pf-0",
            icon: require("@/assets/Iconography/Attributes/13-04_Improving Processes.svg"),
            comp: "Improving processes",
            wdd: "Continuously looks for ways to improve or re-engineer processes",
            progressMeasures: [
              {
                id: "pf-0-0",
                pm: "I am good at identifying, analyzing and improving processes",
                pmMap: "Identify, analyze and improve processes",
              },
              {
                id: "pf-0-1",
                pm: "I continuously look for ways to increase the output, efficiency and effectiveness of processes",
                pmMap:
                  "Continuously look for ways to increase the output, efficiency and effectiveness of processes",
              },
              {
                id: "pf-0-2",
                pm: "I identify weaknesses that can hamper processes in fulfilling their purpose",
                pmMap:
                  "Identify weaknesses that can hamper processes in fulfilling their purpose",
              },
              {
                id: "pf-0-3",
                pm: "I document and reflect on lessons learnt",
                pmMap: "Document and reflect on lessons learnt",
              },
            ],
            developmentActions: [
              {
                id: "pf-0:1-a",
                da: " Do your research. Investigate quality management practices and processes on the Internet and become familiar with the various models and methodologies. Look for patterns and common practices, and find case studies that explain the whole process from initial identification of the problem through to implementation, the results achieved and the challenges faced.",
              },
              {
                id: "pf-0:1-b",
                da: " Pick an appropriate methodology. The Six Sigma strategy, for example, is a complex, time-intensive, detail-oriented process that requires proper training to implement effectively. It also gives a better return in a high-transaction environment in which small changes can have big consequences. There are many other approaches that are less intensive or easier to use, which may be better suited to a service- or experience-oriented environment.",
              },
              {
                id: "pf-0:1-c",
                da: " Find an expert in the company. You will benefit from their experience without having to make mistakes.",
              },
              {
                id: "pf-0:1-d",
                da: " Consider engaging an external quality-management consultant. Talk to them about the projects they have implemented to ensure their experience matches your needs. If cost is an issue, consider hiring a consultant to help you implement a small project and apply its principles independently to a larger-scale project.",
              },
              {
                id: "pf-0:1-e",
                da: " Ensure you get input from employees and customers when improving processes. The people in the trenches and those using the product are closest to the problem and in the best position to give you valuable feedback.",
              },
              {
                id: "pf-0:1-f",
                da: " Look at your competitors and other industries or businesses that operate under similar conditions. There is much to learn from studying what others have done to improve their processes. For example, if your business distributes products through a channel instead of directly to the consumer, look for related businesses in non-competing industries that are recognized as leaders and speak to them. Most companies are happy to share their successes and experiences, especially if you are not a competitor.",
              },
              {
                id: "pf-0:1-g",
                da: " Attend workshops or seminars that expose you to different ways of thinking in the area of process management.",
              },
              {
                id: "pf-0:1-h",
                da: " When improving processes, keep the customer in mind. Internally, the process might be highly efficient, but does it meet the customer's needs?",
              },
              {
                id: "pf-0:2-a",
                da: " Focus your attention on the significant difference between a good product or service and a great one. Think about the instances when you received excellent service or were fully satisfied with a product you bought. Then consider the instances when you received poor service or purchased an inferior product. Use these reflections to identify a process in your organization that works sufficiently but could benefit from improving parts of it. Write down your thoughts about how these changes could have a positive impact on customers both internal and external.",
              },
              {
                id: "pf-0:2-b",
                da: " Identify potential areas for improvement within your organization. Then organize a brainstorm meeting and invite people from all the relevant areas or functions to participate. Document the potentially beneficial elements identified. Determine the actions that should be taken next and who will be responsible for them.",
              },
              {
                id: "pf-0:2-c",
                da: " Stay on top of market trends regarding process improvement, for example, best practices, Six Sigma, lean thinking etcetera.",
              },
              {
                id: "pf-0:2-d",
                da: " Expose yourself as much as possible to what goes on in your industry. Attend trade shows, conferences and webinars that cover cutting-edge topics and highlight innovative products or services.",
              },
              {
                id: "pf-0:2-e",
                da: " Keep abreast of emerging trends globally and in your region. Read trade journals, leading magazines and newspapers, and any other progressive literature. Download podcasts or sign up for e-zines and e-alerts regarding the marketplace, industry trends, technological and scientific advancements, and breaking news.",
              },
              {
                id: "pf-0:2-f",
                da: " Develop a healthy skepticism about your processes. Ask yourself why you do things the way they are done. Question information presented to you.",
              },
              {
                id: "pf-0:3-a",
                da: " Understand the process of change. It has been studied extensively and is much more predictable than you think. Learn to understand some models of change, the phases of change and how people respond to them, how to deal with resistance, and how to get commitment and support for the new and different.",
              },
              {
                id: "pf-0:3-b",
                da: " Consider the alternative to change. Project the consequences of changing versus not changing.",
              },
              {
                id: "pf-0:3-c",
                da: " People avoid change because of the initial pain, so focus on and promote the end result.",
              },
              {
                id: "pf-0:3-d",
                da: " Identify individuals who are energized by change. Openness to the new is a fundamental personality trait and you will always find people willing to champion the cause. They are likely to be passionate and enthusiastic about change, which can be infectious. Ensure they get the resources and support they need to be change agents and use them to lead project teams.",
              },
              {
                id: "pf-0:3-e",
                da: " Avoid complacency, that is, not asking tough questions. Establish a formal process whereby you specifically consider what you have done that has improved the business in some way, and do this at least twice a year. How significant was that improvement, which benefits did it have, what would have happened if you had not made the change? Such a process will create an opportunity for you to celebrate your success and reflect on missed opportunities, which will motivate and encourage more process improvement efforts in the future.",
              },
              {
                id: "pf-0:3-f",
                da: " Encourage employees to participate in the improvement of work design and processes to ensure you get input from many sources. Organize regular feedback and brainstorm sessions with your team as well as cross-functional peers to strengthen your improvement initiatives.",
              },
              {
                id: "pf-0:3-g",
                da: " Empower others to design their own work processes. Encourage your team to research best practices of industry leaders and within other areas of the organization. This practice increases employee support for the process and improves morale.",
              },
              {
                id: "pf-0:3-h",
                da: " Be careful not to establish a yes-man culture. Ask a trusted peer whether people feel this way about giving input. Ensure people know that all ideas are valuable, even if their ideas are contrary to yours.",
              },
              {
                id: "pf-0:4-a",
                da: " Keep abreast of what your internal and external customers expect now, and anticipate their future needs before they know what those are. You will have to perform a market analysis that includes changes in customer demographics, competition and technology. Establish various processes to get customer feedback regarding features, value, price, quality, convenience etcetera on a regular basis.",
              },
              {
                id: "pf-0:4-b",
                da: " Always design your processes with your customers in mind, including product design, materials used, manufacturing, distribution channels as well as customer service and support.",
              },
              {
                id: "pf-0:4-c",
                da: " Brainstorm ways to improve customer satisfaction with your team. Put yourself in your customers' shoes. What would please them? What would dissatisfy them? Use the answers to look for ways to improve your processes to build further customer support.",
              },
              {
                id: "pf-0:4-d",
                da: " Experience your own services and products. There is no better way to identify opportunities for improvement than to get first-hand experience of the products or services you sell. For example, a multinational manufacturer of adult diapers made their company's executives wear them for a day. It fundamentally shifted the way they thought about their customers and their products.",
              },
              {
                id: "pf-0:4-e",
                da: " Treat your suppliers as customers. They are a key aspect of your business, and improving processes to benefit both parties will improve your bottom line.",
              },
            ],
          },
          {
            id: "pf-1",
            icon: require("@/assets/Iconography/Attributes/13-03_Managing  Ideas.svg"),
            comp: "Managing ideas",
            wdd: "Takes new ideas from conception to fruition by managing the innovation process",
            progressMeasures: [
              {
                id: "pf-1-0",
                pm: "I encourage people to share new ideas",
                pmMap: "Encourage people to share new ideas",
              },
              {
                id: "pf-1-1",
                pm: "I value and support creativity",
                pmMap: "Value and support creativity",
              },
              {
                id: "pf-1-2",
                pm: "I listen to everybody’s ideas, even if they are different from mine",
                pmMap:
                  "Listen to everybody’s ideas, even if they are different from mine",
              },
              {
                id: "pf-1-3",
                pm: "I believe innovative ideas require a plan if they are to be executed",
                pmMap: "Ensure there is a plan to execute innovative ideas",
              },
            ],
            developmentActions: [
              {
                id: "pf-1:1-a",
                da: " Stimulate creativity by always encouraging employees to offer any thoughts on a new approach, product or service that can be implemented both now and in the future.",
              },
              {
                id: "pf-1:1-b",
                da: " Ensure your team includes a few highly creative people - they tend to force others to think about new ideas too.",
              },
              {
                id: "pf-1:1-c",
                da: " Start an ideas campaign to get everyone involved in generating ideas. Present a business problem to employees and encourage them all to participate in finding solutions. Set a period during which they can contribute their suggestions, then select the best ideas and send these to experts for evaluation. The winning ideas will be used and their creators will receive credit.",
              },
              {
                id: "pf-1:1-d",
                da: " Do not focus on getting one perfect idea. Encourage people to generate more than one solution and assess the input in its variety. A range of ideas are usually combined to find the best approach and achieve the highest level of innovation.",
              },
              {
                id: "pf-1:1-e",
                da: " Be there to listen to people who want to share innovative ideas with you. If you are always unavailable, they may think you are uninterested and will stop trying to get your attention. If it is not a convenient time, schedule another appointment when the person can do the pitch to you.",
              },
              {
                id: "pf-1:1-f",
                da: " When innovative solutions for a particular issue are needed, create an innovation taskforce with creative thinkers from different disciplines.",
              },
              {
                id: "pf-1:1-g",
                da: " Let a consultant facilitate a creativity workshop at which employees can learn to explore different ways of thinking. Ask a human resources representative to research some options for you.",
              },
              {
                id: "pf-1:1-h",
                da: " Keep the workplace playful and flexible. Ask your employees whether their environment fosters creativity. If not, what do they suggest? Rearranging the office space, adding colors on the wall, more flexibility in schedules, dress codes? Discover the things that your employees really believe matter and make a difference.",
              },
              {
                id: "pf-1:1-i",
                da: " Clients are a great source of innovative ideas. Use surveys, special focus groups or even informal calls or e-mails to solicit new ideas.",
              },
              {
                id: "pf-1:2-a",
                da: " Do not let an idea remain on the shelf for too long. You will lose momentum, energy and even the interest of those involved. Create a team or taskforce to look at an idea's feasibility and report on it within a reasonable timeframe.",
              },
              {
                id: "pf-1:2-b",
                da: " If you decide to go forward with it, be thorough in your process planning. The plan should be no different from that of other projects you have, with goals and milestones identified.",
              },
              {
                id: "pf-1:2-c",
                da: " Ensure you can assign sufficient resources to carry the plan through. It may be a great idea, but a new direction often means withdrawing resources from elsewhere. Your time is a resource that will have to be redirected as well.",
              },
              {
                id: "pf-1:2-d",
                da: " Ensure you have addressed internal politics and have the approval you need from the relevant authorities. Many great ideas fail to be implemented because they did not have the support of the right stakeholders.",
              },
              {
                id: "pf-1:2-e",
                da: " If you approve the implementation of a new idea, ensure you monitor the process more closely than you would any other. By their nature, new ideas encounter obstacles as they are rolled out.",
              },
              {
                id: "pf-1:2-f",
                da: " Have a change management plan ready. New ideas can have an impact on people's roles and the way they have been conducting business. Communicating the need for change and allaying people's fears will increase the likelihood of a successful roll-out.",
              },
              {
                id: "pf-1:2-g",
                da: " If an idea has been scrapped, inform people of the reason. They will understand a lack of resources or competing demands, but will be less inclined to understand why a good idea gets no support.",
              },
              {
                id: "pf-1:3-a",
                da: " If you have a new idea, ask for feedback to improve what you have originated, not to get approval or consent.",
              },
              {
                id: "pf-1:3-b",
                da: " Take on a greater mentor or teacher role and encourage others to bring you their ideas, then use your expertise to lend a hand to their contributions.",
              },
              {
                id: "pf-1:3-c",
                da: " Assume that every idea presented to you could potentially have a positive impact on the business.",
              },
              {
                id: "pf-1:3-d",
                da: " Be positive, interested and really listen when a new idea is pitched to you. Respond with questions that explore the idea properly, for example, 'That sounds interesting. Can you tell me more?', 'How do you imagine your idea will benefit others?', 'How does your idea fit with our strategic vision?', 'What would the next step be?'",
              },
              {
                id: "pf-1:3-e",
                da: " Allow the idea's originator the chance to think out loud and enough time to explain their idea. The longer you listen, the more likely you will see threads of possibility and visualize ways to integrate it with existing ways or processes.",
              },
              {
                id: "pf-1:3-f",
                da: " Do not assume a junior person has less to contribute - their particular experience or insight can shed new light on a problem. Welcome and actively seek fresh perspectives. Even people who are unfamiliar with your business may have valuable perspectives to offer.",
              },
              {
                id: "pf-1:4-a",
                da: " Innovation can take the form of small changes, and often does. Start with ideas that are less demanding on resources.",
              },
              {
                id: "pf-1:4-b",
                da: " Consider business processes that can be improved through a fresh approach.",
              },
              {
                id: "pf-1:4-c",
                da: " Identify the ways in which collaboration and partnerships, both internal and external, will let you pool resources to move an innovative initiative forward.",
              },
              {
                id: "pf-1:4-d",
                da: " You do not have to recreate the wheel to be innovative. Take a look at the ideas your competitors have rolled out and focus to simply improve those or provide more creative options.",
              },
              {
                id: "pf-1:4-e",
                da: " Spend enough time on the brainstorming and planning phases to address details and select appropriate solutions upfront. This is critical to maximize the possibility of success and ensure that resources are not wasted.",
              },
              {
                id: "pf-1:5-a",
                da: " Treat failures and mistakes as experiences that teach you invaluable lessons. Do not feel discouraged if your time and resource investment does not generate success the first time. If you consider experiments as learning opportunities, your time and effort are well spent.",
              },
              {
                id: "pf-1:5-b",
                da: " Focus on the big picture instead of the short-term cost. Understand the benefits a successful new idea will generate. It is hard to argue with well-researched numbers.",
              },
              {
                id: "pf-1:5-c",
                da: " Get support from someone else in the company who is more adept at risk taking. They can give you a fresh perspective.",
              },
              {
                id: "pf-1:5-d",
                da: " List the drawbacks of doing business as usual. What are the problems with the process, product or service as it is now? Nothing is perfect and sometimes we are just more comfortable with established patterns than new approaches.",
              },
            ],
          },
          {
            id: "pf-2",
            icon: require("@/assets/Iconography/Attributes/13-02_Analytical Problem Solving.svg"),
            comp: "Analytical problem solving",
            wdd: "Solves challenging problems by using a combination of intuition and analytical thinking",
            progressMeasures: [
              {
                id: "pf-2-0",
                pm: "I consider multiple solutions for a problem before taking action",
                pmMap:
                  "Consider multiple solutions for a problem before taking action",
              },
              {
                id: "pf-2-1",
                pm: "I can identify problems or challenges that others do not see",
                pmMap: "Identify problems or challenges that others do not see",
              },
              {
                id: "pf-2-2",
                pm: "I understand the nature of a problem quickly, even with little information",
                pmMap:
                  "Understand the nature of a problem quickly, even with limited information",
              },
              {
                id: "pf-2-3",
                pm: "I use logic and trust my intuition when solving problems",
                pmMap: "Use logic and intuition when solving problems",
              },
            ],
            developmentActions: [
              {
                id: "pf-2:1-a",
                da: " There are numerous approaches to keep in your problem-solving toolbox, for example, SWOT analysis (strengths, weaknesses, opportunities, threats",
              },
              {
                id: "pf-2:1-b",
                da: " Ask peers about their unique problem-solving techniques, as well as people not from your discipline. The marketing department, for example, may have instructive ways to approach a brainstorming session, of which you can take advantage in your field too.",
              },
              {
                id: "pf-2:1-c",
                da: " Let others in the team take the lead. Observe their ways of approaching a problem. Which methods could you adopt? What is not working for them?",
              },
              {
                id: "pf-2:1-d",
                da: " Contact your human resources department about courses your company has to broaden your problem-solving techniques.",
              },
              {
                id: "pf-2:1-e",
                da: " Define the factors that make this situation or problem different from a similar one you have had. Just because they seem alike does not mean the solution is the same.",
              },
              {
                id: "pf-2:1-f",
                da: " Consider the resources available to address the problem. You may have a perfect solution or one that was previously successful, but your time or resources at present may be insufficient to facilitate it again. An alternative solution would then be a better approach.",
              },
              {
                id: "pf-2:1-g",
                da: " Ensure you include highly creative people in your team. They are effective at introducing out-of-the-box possibilities.",
              },
              {
                id: "pf-2:1-h",
                da: " Do not assume you know the answer because you have had a similar experience in the past. It is as important to be aware of what you do not know as it is to draw on what you do know. Be aware of making generalizations based on previous experiences.",
              },
              {
                id: "pf-2:1-i",
                da: " When stating information as fact, ensure it is indeed fact and not opinion. Find experts with whom you can discuss the problem to verify your assumptions.",
              },
              {
                id: "pf-2:2-a",
                da: " Ensure you have ample time to consider and analyze the existing assumptions about an issue. An incorrect premise will set your problem solving efforts off in the wrong direction from the start.",
              },
              {
                id: "pf-2:2-b",
                da: " Be sure to properly define the problem. Differentiate between the problem and its symptoms.",
              },
              {
                id: "pf-2:2-c",
                da: " Consider the process part of the problem as well as the constraints on it, and work to remove them.",
              },
              {
                id: "pf-2:2-d",
                da: " Recognize when a team approach is better than doing it alone. It may take longer this way, but it could be a smart approach that yields better results.",
              },
              {
                id: "pf-2:2-e",
                da: " Do not cut corners on problems with important consequences or that could have a great impact on your business. Schedule sufficient time to consider these problems, and do so when and where you have the least distractions.",
              },
              {
                id: "pf-2:2-f",
                da: " Divide the problem into components and delegate tasks accordingly. This way, you can focus your attention on the parts where your input is most valuable",
              },
              {
                id: "pf-2:2-g",
                da: " People think and work at different speeds. Some will want or need more time than others to consider possibilities and find solutions. Respect and support the time individuals need to contribute to the process.",
              },
              {
                id: "pf-2:3-a",
                da: " Set a specific deadline to make a decision. Giving yourself a deadline will help you to avoid prolonged delays in making a decision. Hold yourself accountable to that deadline by setting a date to discuss your decision with your superiors. If you are working with a team, set a date on which everyone will review the information they have gathered and start tackling the problem.",
              },
              {
                id: "pf-2:3-b",
                da: " Schedule occasional meetings with your supervisor to discuss the information you have collected and whether it focuses on your priorities.",
              },
              {
                id: "pf-2:3-c",
                da: " Do you tend to think too much and complicate things? Use your peers as sounding boards to give you perspective. Look for opportunities to combine or abbreviate processes.",
              },
              {
                id: "pf-2:3-d",
                da: " After a project is complete, spend time to consider the information that was important as well as irrelevant. Could you have focused your time and energy in a better direction? Reflection like this is important to process the effectiveness of your problem-solving techniques.",
              },
              {
                id: "pf-2:3-e",
                da: " Get in touch with your intuition and learn to trust it. Forget your intellect and logic at some point and ask yourself what your gut feeling says. Practice by working on issues with limited information and little consequence and build up to more important decisions.",
              },
              {
                id: "pf-2:4-a",
                da: " On a scale of one to 10, rate the level of dedication and sensitivity with which you have treated the problem. It is hard to keep an open mind when you are emotional about an issue. If your rating is high, tell colleagues that you care deeply about the issue and ask whether they think you are overreacting to their suggestions. Simply being aware of your level of emotional investment will help you to manage your reactions.",
              },
              {
                id: "pf-2:4-b",
                da: " Identify your red buttons - we all have issues or comments that touch our most sensitive spots. Carefully consider why you are so sensitive. Talk to a mentor or coach to get a realistic perspective on your thoughts and for guidance on how to address some of these feelings.",
              },
              {
                id: "pf-2:4-c",
                da: " Remain composed when your buttons are pushed during conversation. Do not respond immediately. Instead, count to 10, then ask a question that seeks to clarify the issue. Giving the other person an opportunity to explain and perhaps rephrase what they have said will give you time to consider the comment and compose yourself.",
              },
              {
                id: "pf-2:4-d",
                da: " Be honest about your motives. Are you approaching the problem in an ethical manner or are you serving your interests?",
              },
              {
                id: "pf-2:4-e",
                da: " Let each team member, including you, contemplate a problem individually before convening to share ideas. It will allow independent thinking and prevent the pack-rat mentality from invading your problem-solving process.",
              },
              {
                id: "pf-2:4-f",
                da: " If you know you are overly sensitive or cannot remain objective, remove yourself. Ask someone else to handle the problem and to report back to you. Alternatively, choose only the elements you can deal with objectively. Sharing the weight of an issue can give you the necessary distance to approach a problem more fair-mindedly.",
              },
            ],
          },
          {
            id: "pf-3",
            icon: require("@/assets/Iconography/Attributes/13-01_Being Technology Savvy.svg"),
            comp: "Being technology savvy",
            wdd: "Quickly realizes the impact new technology can have and finds opportunities to integrate it into the business to create competitive advantage",
            progressMeasures: [
              {
                id: "pf-3-0",
                pm: "I understand the importance of technology in every business",
                pmMap:
                  "Recognize the relevance of technology in every business process",
              },
              {
                id: "pf-3-1",
                pm: "I find ways to integrate technology with existing processes",
                pmMap:
                  "Find ways to integrate technology with existing processes",
              },
              {
                id: "pf-3-2",
                pm: "I keep abreast of new technologies that could help me do what I do better",
                pmMap:
                  "Keep abreast of new technologies that could help me do what I do better",
              },
              {
                id: "pf-3-3",
                pm: "I see technology as a way to improve productivity",
                pmMap: "See technology as a way to improve productivity",
              },
            ],
            developmentActions: [
              {
                id: "pf-3:1-a",
                da: " Before adopting new technology, do in-depth research about the tool. Ask someone who has tested it and applies it successfully. It will help you to gain confidence about its benefits.",
              },
              {
                id: "pf-3:1-b",
                da: " Ask colleagues who are technologically savvy about their experience with a technology and its pros and cons.",
              },
              {
                id: "pf-3:1-c",
                da: " Keep gaining knowledge and confidence in technological areas and build on it. Small victories help you to gain the necessary confidence and, as you do, your fear is reduced and eventually it disappears.",
              },
              {
                id: "pf-3:1-d",
                da: " Do not become overwhelmed by all the features available. Technology such as web surfing tends to open up many tangential possibilities. Focus on the aspects that will help you to accomplish what you want. It is the best way to make learning pragmatic and uncomplicated.",
              },
              {
                id: "pf-3:1-e",
                da: " Ask someone who knows the technology well to demonstrate how it is used. Use resources in the IT department if available.",
              },
              {
                id: "pf-3:1-f",
                da: " Divide information about the technology into small pieces - an important concept in learning anything new. For example, it is impossible to learn a new language all at once, but if you learn progressively, word by word and phrase by phrase, you will gradually gain a complete understanding of the language. Technology is the same. Think about technology as just another subject to master.",
              },
              {
                id: "pf-3:1-g",
                da: " Set a goal to become skilled in using one or two small technological items, for example, an electronic organizer, a new cellphone or scheduling software. Learn how to use a new feature each week.",
              },
              {
                id: "pf-3:2-a",
                da: " Assess the impact of the technological change on employees. The checklist must consider which positions are likely to benefit, who would be disadvantaged in the change, what compensation there will be for them and whether there is a budget for such compensation.",
              },
              {
                id: "pf-3:2-b",
                da: " You will have to develop a strategy to communicate change to your employees. It should include how the technology will work, why it is being adopted and how training and support will be provided.",
              },
              {
                id: "pf-3:2-c",
                da: " Identify the people who will play critical roles if the technological change is accepted. Ensure you involve them in the change process.",
              },
              {
                id: "pf-3:2-d",
                da: " Be patient. Remember, people adapt to technology at a different pace and anxiety among employees will cause resistance to its acceptance and productive use.",
              },
              {
                id: "pf-3:2-e",
                da: " Compensate those employees who have been disadvantaged fairly. Promoters of technological change often argue that everyone is a winner with the implementation of new technology. But losses, ranging from work demotion to termination, do occur. Pay attention to the emotional and financial needs of those who lose their jobs or whose status drops due to technological change. It is a critical investment in the organization and sends the right message to other employees.",
              },
              {
                id: "pf-3:3-a",
                da: " Ensure you have the appropriate advocates to champion the technology and create acceptance before its roll-out. Executive-level managers are the most effective sponsors.",
              },
              {
                id: "pf-3:3-b",
                da: " Develop a clear communication strategy. It should include how the technology will work, why it is being adopted and how training and support will be provided. Determine whether the communication should be formal, such as a CEO announcement, or informal, such as discussion in management meetings. Consider branding options that tie the company's identity to the technology.",
              },
              {
                id: "pf-3:3-c",
                da: " Budget for and invest the appropriate resources in quality training. Building capacity among users is critical to the technology's successful application. Also consider periodical refresher courses and training.",
              },
              {
                id: "pf-3:3-d",
                da: " Carefully investigate software providers that can help you to draw a variety of applications into a cohesive unit, thereby helping you to align systems and processes more closely.",
              },
              {
                id: "pf-3:3-e",
                da: " If you need to grow your business, you may have to consider an application - SAP - which allows real-time access to data, business processes and suppliers.",
              },
              {
                id: "pf-3:4-a",
                da: " Consider the positive changes you have experienced in your life that were brought about by technological advances. We are surrounded by examples of how technology has benefited mankind: thermostatically controlled heating and cooling, telephone answering machines, automated assembly lines, knowledge of the universe, medical advancements and many more.",
              },
              {
                id: "pf-3:4-b",
                da: " Reflect on the positive outcomes you experience from the use of technology, such as time saved, new business opportunities created, the ability to stay in contact with friends and family.",
              },
              {
                id: "pf-3:4-c",
                da: " Make a list of the technologies you appreciate most and without which you could not live. We complain about technology when it does not work, but your lifestyle would be highly disrupted without it. Would you really want to return to no cellphones or e-mail, no automation, poor medical advances etcetera?",
              },
              {
                id: "pf-3:4-d",
                da: " If you cannot shake your adverse attitude to technology and your position demands that you do, consider whether you should get another job.",
              },
              {
                id: "pf-3:5-a",
                da: " Make a list of how the organization would benefit if all employees were capable of utilizing existing technology to its full extent.",
              },
              {
                id: "pf-3:5-b",
                da: " List how your lack of support for technological change would benefit you. Then imagine that you did make the change and it is now five years later. Which benefits do you personally stand to gain from the new technology?",
              },
              {
                id: "pf-3:5-c",
                da: " If you cannot find the obvious value that will be added by new technology, do the necessary research to obtain clear information on the returns on investment you can expect.",
              },
              {
                id: "pf-3:5-d",
                da: " Try to automate one process and become familiar with that tool. Once the benefits are clear and you are more comfortable with the technology, explore its other available features in which you can perhaps invest further.",
              },
            ],
          },
        ],
      },
      ccr: {
        characteristic: "Compassion and Care",
        wdd: "Being friendly and easy to approach; demonstrate genuine concern for an interest in others; listening with an interest in understanding the thoughts and feelings of others.",
        icon: require("@/assets/Iconography/Characteristics/04_Considerate Carer.svg"),
        competencies: [
          {
            id: "ccr-0",
            icon: require("@/assets/Iconography/Attributes/04-02_Demonstrating Empathy.svg"),
            comp: "Demonstrating empathy",
            wdd: "Demonstrates a genuine concern for and interest in others",
            progressMeasures: [
              {
                id: "ccr-0-0",
                pm: "I understand that people experience situations differently",
                pmMap:
                  "Understand that people experience situations differently",
              },
              {
                id: "ccr-0-1",
                pm: "I care about people’s feelings",
                pmMap: "Care about people’s feelings",
              },
              {
                id: "ccr-0-2",
                pm: "I am available to someone who needs to talk",
                pmMap: "Be available to someone who needs to talk",
              },
              {
                id: "ccr-0-3",
                pm: "I can imagine how someone might be feeling in certain circumstances",
                pmMap:
                  "Imagine how someone might be feeling in certain circumstances",
              },
              {
                id: "ccr-0-4",
                pm: "I think it makes me a better manager to care about others’ feelings",
                pmMap: "<Missing>",
              },
            ],
            developmentActions: [
              {
                id: "ccr-0:1-a",
                da: " How well do you know your peers? Or the people who work for you? Are most of them strangers because you do not give them the time of day? Schedule a lunch or take brief breaks during the day to interact and get the scoop on colleagues' lives.",
              },
              {
                id: "ccr-0:1-b",
                da: " Be available to listen, but set polite time limits. Tell the speaker that although you only have a short time, you really want to hear what is bothering them.",
              },
              {
                id: "ccr-0:1-c",
                da: " Sometimes it really is impossible to make time to talk during a particularly busy day. Suggest meeting with the person after hours or in lunchtime.",
              },
              {
                id: "ccr-0:1-d",
                da: " If you sincerely feel someone is monopolizing your time, diplomatically point out that you cannot give the person the adequate time they deserve and suggest they talk to someone who assists employees.",
              },
              {
                id: "ccr-0:2-a",
                da: " Create an environment in which people are encouraged to talk about their feelings. Set an example by being frank. Always ask people how they feel about situations or assignments.",
              },
              {
                id: "ccr-0:2-b",
                da: " How good are you at reading people? Someone may be upset but reluctant to say so. If you pay close attention and use your intuition, you will be able to sense when someone is battling with emotions. If you believe someone is upset, do not ignore it - ask the person about it, if appropriate.",
              },
              {
                id: "ccr-0:2-c",
                da: " If time is an issue, tell the person that although you can only talk for a short time, you really want to hear about their problem.",
              },
              {
                id: "ccr-0:2-d",
                da: " Use statements that convey your understanding and empathy, such as 'I am sorry for what you are going through' or 'I understand how you would feel that way'.",
              },
              {
                id: "ccr-0:2-e",
                da: " Ask yourself how you would feel if the tables were turned. How would you want someone to respond to you?",
              },
              {
                id: "ccr-0:3-a",
                da: " It is not necessary to provide answers or solutions when people share their feelings with you. You can give advice if it is solicited or, if you do not have an opinion, you can admit that you cannot comment although you certainly understand why the person feels the way they do.",
              },
              {
                id: "ccr-0:3-b",
                da: " Practice effective listening skills. Be available when someone needs to talk. Restate what the person has said so that they know you have listened. Try to understand the triggers that have led the person to their current emotional condition.",
              },
              {
                id: "ccr-0:3-c",
                da: " Become more comfortable by opening up somewhat to a trusted peer. The worst that can happen is that the person does not care. Avoid being that type of person.",
              },
              {
                id: "ccr-0:4-a",
                da: " Consider hidden biases or stereotypes you may harbor and which may prevent you from caring about people from a particular group. You cannot pick and choose your peers or clients, so selective empathy is not productive.",
              },
              {
                id: "ccr-0:4-b",
                da: " Do not try to agree or disagree with the person, just be open to what is being said. Imagine the person as a close friend or family member who shares an experience with you. How sensitively would you act?",
              },
              {
                id: "ccr-0:4-c",
                da: " Spend time in the company of people with whom you have difficulty to relate. Ask them to explain their experience to you. You will be surprised to learn about things other people have to endure, which you may not have to face.",
              },
            ],
          },
          {
            id: "ccr-1",
            icon: require("@/assets/Iconography/Attributes/04-01_Listening well.svg"),
            comp: "Listening well",
            wdd: "Listens with the intention of genuinely understanding others' thoughts and feelings",
            progressMeasures: [
              {
                id: "ccr-1-0",
                pm: "I believe that, at times, others will know more than me",
                pmMap: "Believe that, at times, others will know more than me",
              },
              {
                id: "ccr-1-1",
                pm: "I let people finish before I suggest a solution or course of action",
                pmMap:
                  "Let people finish before I suggest a solution or course of action",
              },
              {
                id: "ccr-1-2",
                pm: "I can understand what people are trying to say even if they have difficulty expressing themselves",
                pmMap:
                  "Understand what people are trying to say even if they have difficulty expressing themselves",
              },
              {
                id: "ccr-1-3",
                pm: "I show interest regardless what people are talking about",
                pmMap: "Show interest regardless what people are talking about",
              },
              {
                id: "ccr-1-4",
                pm: "I am not easily distracted while people are talking to me",
                pmMap:
                  "Not be easily distracted while people are talking to me",
              },
            ],
            developmentActions: [
              {
                id: "ccr-1:1-a",
                da: " Prioritize carefully how much time you can give to others and to whom you give it.",
              },
              {
                id: "ccr-1:1-b",
                da: " If time is really a constraint, try appointing or selecting a key person who represents the interests of the group.",
              },
              {
                id: "ccr-1:1-c",
                da: " Ask people beforehand to summarize what they need to tell you in a few key points. Make it clear what your time constraints are and how much time you have available before you will have to leave.",
              },
              {
                id: "ccr-1:1-d",
                da: " If possible, make use of lunchtime or travel time to catch up with others.",
              },
              {
                id: "ccr-1:1-e",
                da: " Manage the time you do make available for others. If the topic requires a full hour of conversation but you have allotted only twenty minutes, it is likely you will get impatient and stop listening properly as time begins to run out.",
              },
              {
                id: "ccr-1:2-a",
                da: " Show interest and listen, even if you are already familiar with the topic or have a solution yourself. There may be a fresh perspective from which you can benefit or additional data that has not been considered. Even if nothing new emerges from the discussion, being attentive encourages people to get involved and makes them excited about thinking problems through.",
              },
              {
                id: "ccr-1:2-b",
                da: " Remain silent on purpose and do not interrupt others to give your opinions before they have had ample time to express themselves. Interruptions are very frustrating for the person trying to talk and it means you are focusing on what you have to say instead of the other way round. Be aware of how often you routinely interrupt people.",
              },
              {
                id: "ccr-1:2-c",
                da: " In some situations, being attentive requires you to step away from the situation to allow what has been said to sink in. If appropriate, give yourself time before making comments to people, but be sure to get back to them later.",
              },
              {
                id: "ccr-1:2-d",
                da: " Be aware of dismissive behavior that indicates you are bored or disinterested, for example, looking around while someone is talking to you, checking your watch, going through work on your desk, avoiding eye contact etcetera.",
              },
              {
                id: "ccr-1:2-e",
                da: " Stop whatever you are working on and show the person that you are willing to listen and think about what they have to say. If it really is not the best time to do so, schedule a time to meet soon.",
              },
              {
                id: "ccr-1:2-f",
                da: " Choose to mentor someone. It is one of the best ways to share your knowledge and expertise and, at the same time, practice being attentive with someone at a different professional level than you.",
              },
              {
                id: "ccr-1:3-a",
                da: " A meditation is one of the most effective ways to still the mind. The many techniques for meditation include chanting or exercises to control your breathing. Try meditation as a calming exercise you routinely do outside of work.",
              },
              {
                id: "ccr-1:3-b",
                da: " It is better to be 100% present for 15 minutes than barely present for an hour. During a conversation, be aware when irrelevant thoughts creep into your mind. Keep reining in your thoughts to the situation at hand.",
              },
              {
                id: "ccr-1:3-c",
                da: " Keep your mind focused and attentive by rephrasing or summarizing what the person has said. Ask if you have understood the person correctly. Use language and gestures that show concern and understanding during the conversation, for example, nod often and use phrases such as 'I see', 'I understand' and 'That makes sense'.",
              },
              {
                id: "ccr-1:3-d",
                da: " If you are concerned about a pressing deadline, consider asking the person to wait a day or two until you can listen without distractions. Schedule that time on your calendar and be absolutely sure to honor it.",
              },
              {
                id: "ccr-1:3-e",
                da: " Give yourself time to switch gears before starting a new conversation. You may find yourself far into a new meeting still thinking about the previous one. Take a quick walk, if possible, or grab a beverage. Spend a few minutes connecting at a personal level with the new person.",
              },
              {
                id: "ccr-1:3-f",
                da: " Reduce the amount of distractions that compete with your attention. When lending your ear to someone, shut off the phone. You can always get your messages afterwards. Do not sit in front of the computer and continue using it when someone is talking to you.",
              },
              {
                id: "ccr-1:4-a",
                da: " When someone is not doing well getting their point across or taking too long and you find yourself getting impatient, act as a facilitator instead of zoning out, getting frustrated or interrupting. Help the person to get their point across by asking simple questions or restating what they are trying to say. Steer them diplomatically through the conversation. If you teach a person how to articulate effectively, you do not have to work so hard at figuring out what they are trying to say.",
              },
              {
                id: "ccr-1:4-b",
                da: " Put yourself in the other person's shoes. Imagine what they may be feeling. Perhaps the person is nervous or shy. Some extra patience may be required, depending on the circumstances.",
              },
              {
                id: "ccr-1:4-c",
                da: " Teach those around you how you like to be briefed or which type of communication you prefer. Do not assume people can read you well.",
              },
              {
                id: "ccr-1:4-d",
                da: " Are you attentive to some but not others? Unknowingly, you may be discriminating against certain people. Identify with whom you tend to be less attentive - younger people, women, minorities? Strive to be fair in listening. Write a list of the people with whom you are not attentive. Try to identify common patterns or themes among them.",
              },
              {
                id: "ccr-1:4-e",
                da: " If you have a particular dislike for someone or they have upset you, take the person aside and discuss your differences professionally. You want to set an example for others, show that differences can be resolved and demonstrate that everyone in the organization will be heard.",
              },
            ],
          },
          {
            id: "ccr-2",
            icon: require("@/assets/Iconography/Attributes/04-01_Listening well.svg"),
            comp: "Being Approachable",
            wdd: "",
            progressMeasures: [
              {
                id: "ccr-2-0",
                pm: "I enjoy talking or listening to others ",
                pmMap: "Enjoy talking or listening to others ",
              },
              {
                id: "ccr-2-1",
                pm: "I can build good rapport, even with strangers",
                pmMap: "Build good rapport, even with strangers",
              },
              {
                id: "ccr-2-2",
                pm: "I appear friendly even if I am in a bad mood or stressed",
                pmMap: "Appear friendly even if I am in a bad mood or stressed",
              },
              {
                id: "ccr-2-3",
                pm: "I allow people to express themselves without interruption",
                pmMap:
                  "Allow people to express themselves without interruption",
              },
              {
                id: "ccr-2-4",
                pm: "I keep judgment or criticism of others to a minimum",
                pmMap: "Keep judgment or criticism of others to a minimum",
              },
            ],
            developmentActions: [
              {
                id: "ccr-2:1-a",
                da: "Be aware of acting frenzied or disorganized in your day-to-day duties. If you constantly complain about all the meetings you have and the work you ` cannot get done, you send out a signal that you should not be disturbed. ",
              },
              {
                id: "ccr-2:1-b",
                da: "Be realistic about your schedule. Are you overbooking yourself? Identify the activities that would be good to do, versus those that are critical. Some people enjoy the thrill of a hectic pace, but cutting corners both exhausts you and makes you unapproachable. ",
              },
              {
                id: "ccr-2:1-c",
                da: "Take one or two breaks a day to check in with people, not their tasks. ",
              },
              {
                id: "ccr-2:1-d",
                da: "Remember humor. Use your sense of humor to make light of your impossible demands and encourage others to share their woes. ",
              },
              {
                id: "ccr-2:1-e",
                da: "Improve your composure. Remaining calm and attentive, even under pressure, sends the message that you are available when people need you. It sets a great example to show you are approachable, even in stressful situations when people may need you the most. ",
              },
              {
                id: "ccr-2:1-f",
                da: "Are your values and behavior compatible? If you value being friendly and approachable, consider whether you are prioritizing accordingly. ",
              },
              {
                id: "ccr-2:1-g",
                da: "What does your body language signal? For example, if your eyes dart around when someone talks to you, you send a message that you are disinterested or have better things to do. Be aware of fidgeting or looking at your watch. 8. Delegate effectively, especially if you are in a management position. You may be mired in tasks that could be delegated instead of focusing on your most important role: providing direction and vision for others.",
              },
              {
                id: "ccr-2:2-a",
                da: "Find a balance between interaction with others and time on your own. Because making time for others will not come naturally to you, schedule &ldquo;people breaks&rdquo; during the day in which you make yourself available to simply chat. ",
              },
              {
                id: "ccr-2:2-b",
                da: "Try to stay in the present and mentally engaged during conversations with people. Restate what the person has told you and show interest by asking questions and providing feedback. ",
              },
              {
                id: "ccr-2:2-c",
                da: "People cannot instinctively know which information you need or whether they are bothering you with issues they could handle themselves. Explain the information you require and when would be a good time for them to approach you with problems. ",
              },
              {
                id: "ccr-2:2-d",
                da: "Be aware of the signals you may be sending out that keep people at bay. Avoid frowning all the time; make direct eye contact and smile. ",
              },
              {
                id: "ccr-2:2-e",
                da: "Ask yourself when was the last time you actually asked after someone&rsquo;s welfare? If you cannot remember, it has been too long. ",
              },
              {
                id: "ccr-2:2-f",
                da: "Do you have friends at work? Cultivate friendships and give yourself a well-deserved break by spending time with these colleagues. ",
              },
              {
                id: "ccr-2:2-g",
                da: "Openly acknowledge and celebrate others&rsquo; personal milestones such as birthdays and anniversaries. Be sure to attend such events, if only for a few minutes. ",
              },
              {
                id: "ccr-2:2-h",
                da: "Try to lighten up and approach your world less seriously. You may have a lot on your mind, but you can share it with others with some humor. It lets others know that even though you are busy, you are willing to make the time to laugh at yourself and share your worries. When possible, share funny stories about things that have happened to you. ",
              },
              {
                id: "ccr-2:2-i",
                da: "Try laughter therapy, which claims beneficial effects from the use of positive emotions associated with laughter. The benefits of laughter are well documented, yet a study showed that preschool children laugh up to 400 times a day, while adults laugh only 17 times a day on average. Research has shown that laughing can help to reduce blood pressure and stress hormones, trigger endorphins, the body&rsquo;s natural painkiller, boost immune function by raising levels of infection-fighting T-cells, increase muscle flexion and produce a general sense of wellbeing. Take advantage of all these benefits by injecting some laughter into your workday. ",
              },
              {
                id: "ccr-2:2-j",
                da: "Chances are that if you are too serious at work, you are too serious at home. Do more things that help you to relax in your personal life. Watch more comedies, play games with your kids, do more things that make you laugh, get away from daily stress by taking frequent breaks. ",
              },
              {
                id: "ccr-2:2-k",
                da: "Spend time with people who have a positive attitude. We model much of our behavior on that of our peers and people with whom we spend time.",
              },
              {
                id: "ccr-2:2-l",
                da: "Breed a culture of humor in the workplace by encouraging people with a sunny disposition to share their humor with everyone. ",
              },
              {
                id: "ccr-2:2-m",
                da: "Smile as often as possible. Studies show the positive effects of smiling occur whether the smile is fake or real. ",
              },
              {
                id: "ccr-2:2-n",
                da: "Meditation brings stillness to the mind. Try to build meditation time into your daily routine with practices such as mindfulness, a method that focuses on awareness of the here and now. There are many workshops and books available to help you get started.",
              },
              {
                id: "ccr-2:3-a",
                da: "Maintain an open-door policy for everyone at all times. If it is not a good time to converse, schedule another appointment and keep it. ",
              },
              {
                id: "ccr-2:3-b",
                da: "Stay in touch with people to check how they are, and not just when you need a favor. ",
              },
              {
                id: "ccr-2:3-c",
                da: "Schedule a set time in the office during the week when you will be available for anyone to come and talk to you. Ensure you have cleared your schedule and can offer your undivided attention. ",
              },
              {
                id: "ccr-2:3-d",
                da: "Practice management by walking around. Commit yourself to spending a dedicated amount of time with employees on the floor or in various offices each day, in essence walking through the organization to find opportunities to make positive comments and receive input or feedback. This approach permits direct access to you and promotes the exchange of ideas. Make sure you do it authentically, in other words, be yourself and do it in your own unique way. ",
              },
              {
                id: "ccr-2:3-e",
                da: "Find ways to help others. Volunteer without being asked. Do not help others just because they have helped you.",
              },
              {
                id: "ccr-2:4-a",
                da: "Maximize your opportunities to interact with people one on one. Schedule a set time during the week when you are available for anyone to come and talk to you. Drop by people&rsquo;s offices to talk one on one at least once a week. ",
              },
              {
                id: "ccr-2:4-b",
                da: "Use humor to break the ice and bond with others. ",
              },
              {
                id: "ccr-2:4-c",
                da: "Do you have friends at work? Just one or two close relationships can help to bring you out of your shell, especially if your friends are more extroverted than you. ",
              },
              {
                id: "ccr-2:4-d",
                da: "Attend some work-related social activities. It gives people a less formal opportunity to get to know you and gives you a chance to nurture friendships. ",
              },
              {
                id: "ccr-2:4-e",
                da: "Be aware of the signals you may be sending out that keep people at bay. Make direct eye contact, smile as much as possible, uncross your arms. ",
              },
              {
                id: "ccr-2:4-f",
                da: "Show interest in others&rsquo; lives and ask them to tell you about themselves. Most people like to talk about their lives, which takes the pressure to talk off you.",
              },
              {
                id: "ccr-2:5-a",
                da: "Let people finish expressing themselves before you interrupt with an opinion or solution. ",
              },
              {
                id: "ccr-2:5-b",
                da: "Always respond with a positive comment or observation, for example, &ldquo;It is good that you are thinking about this&rdquo;, or &ldquo;I know it seems like an impossible task but I have confidence in you, how can I help?&rdquo;, or &ldquo;There are always challenging people you must work with. Are there other team members with whom you get along?&rdquo; ",
              },
              {
                id: "ccr-2:5-c",
                da: "Spend time with people who are positive and upbeat. Just like negativity, optimism is contagious. ",
              },
              {
                id: "ccr-2:5-d",
                da: "Keep a journal about the positive things in your life. Small or big, raising your awareness about these things on a daily basis can prompt you to think more positively. ",
              },
              {
                id: "ccr-2:5-e",
                da: "Try to recognize and limit the following: blaming, defending, judging, stonewalling, excluding and being unforgiving. ",
              },
              {
                id: "ccr-2:5-f",
                da: "Ask peers, friends and family members whether they think you are generally negative. Sometimes we are unaware of how negative we are or the impact it has on others. ",
              },
              {
                id: "ccr-2:5-g",
                da: "Engage a coach or therapist to identify the areas in your life you might be neglecting or which leave you feeling unfulfilled.",
              },
            ],
          },
        ],
      },
      cp: {
        characteristic: "Calming Influence",
        wdd: "Remaining calm under pressure; recognizing the contribution of others and acts humbly about strengths and achievements; being patient with people and knowing when to slow down to let others catch up; balancing work and personal priorities.",
        icon: require("@/assets/Iconography/Characteristics/02_Calming Presence.svg"),
        competencies: [
          {
            id: "cp-0",
            icon: require("@/assets/Iconography/Attributes/02-04_Balancing my personal.svg"),
            comp: "Balancing my personal life and work life",
            wdd: "Balances the need to meet work responsibilities with factors that ensure a quality life",
            progressMeasures: [
              {
                id: "cp-0-0",
                pm: "I participate in a hobby or activity outside of work that helps me to relax and recharge",
                pmMap:
                  "Participate in a hobbies or activities outside of work that helps me to relax and recharge",
              },
              {
                id: "cp-0-1",
                pm: "When I am away from the office I am not stressed about work",
                pmMap: "Remain unstressed about work when away from work",
              },
              {
                id: "cp-0-2",
                pm: "My goal is to do the best I can, not to be perfect",
                pmMap: "Try to do the best I can, not to be perfect",
              },
              {
                id: "cp-0-3",
                pm: "Occasionally I am willing to spend some personal time to meet a work target",
                pmMap:
                  "Demonstrate a willingness to spend some personal time to meet a work target",
              },
            ],
            developmentActions: [
              {
                id: "cp-0:1-a",
                da: " Set an alarm clock to mark the time to leave the office and make a commitment to do so when it goes off. Ask a colleague or assistant to check in with you to ensure that you have left.",
              },
              {
                id: "cp-0:1-b",
                da: " Do not bring your computer when you are traveling with your family for leisure. If you have to stay connected, agree with your family on a set time daily during which you will check and respond to e-mail.",
              },
              {
                id: "cp-0:1-c",
                da: " Use your vacation time, no matter what. Schedule your vacations at the beginning of the year. Inevitably, something will always come up, so ignore it and go ahead with your plans.",
              },
              {
                id: "cp-0:1-d",
                da: " Talk to your family about your schedule and make sure you reach an acceptable compromise about it. You may be assuming that your schedule has not affected anyone because no one has brought it up.",
              },
              {
                id: "cp-0:1-e",
                da: " Find other interests and activities that make you happy and which you can share with your family or friends. Remember, work is not the only thing that could possibly give you the rush you seek.",
              },
              {
                id: "cp-0:2-a",
                da: " Diversify your interests and apply the same strengths to them that you exhibit at work. For example, get involved in volunteering. If you are detailoriented or a great planner, you can help to organize a major fund raising event. Take up hobbies that you have thought you might be good at but never pursued.",
              },
              {
                id: "cp-0:2-b",
                da: " Participate in stress-releasing activities such as exercise or meditation.",
              },
              {
                id: "cp-0:2-c",
                da: " Never underestimate the importance of a supportive group of friends. You may have shut yourself out from close relationships if you have been buried in your job. Reconnect with old friends or take the time to meet new people with whom you enjoy spending time.",
              },
              {
                id: "cp-0:2-d",
                da: " If you know you have been avoiding personal issues for a long time by escaping in work, seek professional counseling.",
              },
              {
                id: "cp-0:3-a",
                da: " Prioritize your workload. Some things are simply more important than others, so spend your time wisely and get the important tasks done first. You will feel less pressure if the things you have not managed to do are of less consequence. Identify and write down the activities or tasks that take up most of your time. You will be surprised how much time gets spent on following up issues that are not important. Can your assistant help you with those tasks?",
              },
              {
                id: "cp-0:3-b",
                da: " If you feel you are constantly behind and cannot get your work accomplished in the allotted time, are you (or your boss",
              },
              {
                id: "cp-0:3-c",
                da: " When you are feeling overwhelmed, talk to a trusted colleague. Talking things through with a peer will provide a reality check and a much-needed break from worry. Other people are usually good at giving us a better perspective about what really needs to get done.",
              },
              {
                id: "cp-0:3-d",
                da: " Are you a perfectionist? Not all tasks require equal attention or polishing. To which tasks can you give less attention because they will not have much of an impact on your bigger objectives? Always assess the amount of energy and time you put into your assignments and check whether it is really necessary.",
              },
              {
                id: "cp-0:3-e",
                da: " Consider taking time management courses that are available through the company or elsewhere.",
              },
              {
                id: "cp-0:4-a",
                da: " Are you asking for more work than you can handle, biting off more than you can chew? Being ambitious is commendable, but being overly ambitious can harm your performance and your health. Compare your workload to that of others to get a realistic gauge of how much should be on your plate.",
              },
              {
                id: "cp-0:4-b",
                da: " Keep track of the hours you work. This will give you a realistic picture of the time you are investing away from home.",
              },
              {
                id: "cp-0:4-c",
                da: " Talk to the relevant people if you have concerns about meeting their expectations. You are likely to be harder on yourself than anyone else. Sometimes, all people need to hear is reassurance that they are on track and meeting or exceeding expectations.",
              },
              {
                id: "cp-0:4-d",
                da: " Say no to work you cannot handle. Do not accept more work because you think it will reflect poorly if you say no. It will reflect more poorly when you cannot get the job done. It is okay to be honest about your workload. It is not going to cost you your career if you clearly have too much on your plate. Discuss your responsibilities with the person who reviews your work.",
              },
              {
                id: "cp-0:4-e",
                da: " Write down everything you want to accomplish personally, in your private life, as well as the things you would like to achieve professionally by the time you retire. Look at the list once a week to remind you of the things that constitute your life and interests outside of work and for which you need to make time.",
              },
              {
                id: "cp-0:4-f",
                da: " Find a mentor who has balanced a successful career with personal priorities. How did they manage to accomplish both?",
              },
              {
                id: "cp-0:5-a",
                da: " Be judicial about what really needs your attention and how much work is necessary to accomplish the purpose of the assignment. Set completion deadlines for tasks.",
              },
              {
                id: "cp-0:5-b",
                da: " Let go of tasks that others can do and delegate these. You will not learn to rely on people until you delegate and give them a chance to prove themselves.",
              },
              {
                id: "cp-0:5-c",
                da: " Observe the realistic expectations others set for their work.",
              },
              {
                id: "cp-0:5-d",
                da: " Take advantage of the resources in the company and those outside available to you to get your work done more efficiently. Consider outsourcing work, if that is an option.",
              },
              {
                id: "cp-0:6-a",
                da: " Engage a life coach, if possible, to get clarification on your personal priorities and goals.",
              },
              {
                id: "cp-0:6-b",
                da: " Assess how much on your plate involves taking care of others. Whether it is helping co-workers with their projects or doing favors for friends, where do your interests and needs fit into the picture?",
              },
              {
                id: "cp-0:6-c",
                da: " Get comfortable with politely saying no. Do not explain why, just state that you have other commitments. Practice turning down small commitments on people with whom you are comfortable and move on to people you find difficult to turn down.",
              },
              {
                id: "cp-0:7-a",
                da: " Keep an eye on the big picture. Each month, take a step back and review how much time you have spent on your work versus your personal life. If you are starting to notice one area taking over, make a point to increase your focus on the other area. You may do this every couple of months, but do not go too long without assessing your commitments.",
              },
              {
                id: "cp-0:7-b",
                da: " When you are starting to feel burnt out because of too much work or too many personal demands, immerse yourself in the opposite realm.",
              },
              {
                id: "cp-0:7-c",
                da: " Talk to individuals who you know are successful at work. Ask them how they balance their work and personal demands. You may be surprised to find that many of these individuals do, indeed, juggle their life commitments without compromising their work, and vice versa.",
              },
              {
                id: "cp-0:7-d",
                da: " Be clear about the things that matter most to you and that keep your personal and work lives happy and healthy. Be sure to honor these commitments and juggle the less important ones. For example, opt out of happy hour for professional networking if it is your child's birthday. You can also opt out of a dinner engagement with friends because the dinner with the company head was rescheduled for that same night. Honor what is truly important and use good judgment.",
              },
            ],
          },
          {
            id: "cp-1",
            icon: require("@/assets/Iconography/Attributes/02-03_Being composed.svg"),
            comp: "Being composed",
            wdd: "Remains calm under pressure",
            progressMeasures: [
              {
                id: "cp-1-0",
                pm: "I do not take it personally when someone is upset",
                pmMap: "Not take it personally when someone is upset",
              },
              {
                id: "cp-1-1",
                pm: "I stay calm and collected even when under a lot of stress",
                pmMap:
                  "Stay calm and collected even when under a lot of stress",
              },
              {
                id: "cp-1-2",
                pm: "People come to me when there is a crisis",
                pmMap:
                  "Reassure people if they come to me when there is a crisis",
              },
              {
                id: "cp-1-3",
                pm: "I never have tantrums or become overly emotional in public",
                pmMap:
                  "Never have tantrums or become overly emotional in public",
              },
            ],
            developmentActions: [
              {
                id: "cp-1:1-a",
                da: " Try to think more with your head than your heart. If you feel your emotions welling up, imagine how an emotionally detached person would approach the situation.",
              },
              {
                id: "cp-1:1-b",
                da: " If you are feeling overwhelmed by your emotions, politely ask to take a quick break to collect your thoughts. Step outside the room or phone back in a few minutes. It is better to do this than break down in front of others.",
              },
              {
                id: "cp-1:1-c",
                da: " If possible, take a day off to get perspective and let your emotions settle. It is remarkable how differently we see things after we have stepped away from the situation for a moment.",
              },
              {
                id: "cp-1:1-d",
                da: " Focus on controlling your breathing by taking deep breaths. This is a very effective way to calm yourself.",
              },
              {
                id: "cp-1:1-e",
                da: " Consider carefully to whom you are talking in a given situation. Not everyone expresses themselves through emotion or may be comfortable around people that are emotionally expressive. Instead of getting sympathy or support, you may put people off.",
              },
              {
                id: "cp-1:1-f",
                da: " Make sure you have outlets for your feelings outside of work. Trusted friends, family members, a coach or counselor can provide you with a productive outlet for your emotions.",
              },
              {
                id: "cp-1:2-a",
                da: " When you feel you are losing your composure, try deep-breathing exercises, an effective way to slow down the body's adrenaline response to stress. There are many techniques for breathing that you can practice daily.",
              },
              {
                id: "cp-1:2-b",
                da: " Research has shown that stress can negatively affect the clarity of our thinking. Sometimes it is necessary to get away. Take a short break to clear your head. Take a walk or go to lunch, whatever is necessary to leave the situation behind. This will not change the situation but will give you a chance to collect yourself.",
              },
              {
                id: "cp-1:2-c",
                da: " Take action. Write down the steps that must be taken to resolve the problem. Focus on the priority items.",
              },
              {
                id: "cp-1:2-d",
                da: " Ask for help before you blow a fuse. Under stress we often forget that there are other resources available. Do not assume you have to do it all yourself. Engage other people to help. Just talking to someone about the stress you are under can be cathartic.",
              },
              {
                id: "cp-1:2-e",
                da: " Model your behavior on that of a respected peer or person who is skilled at staying calm under pressure. Ask them how they succeed in doing it.",
              },
              {
                id: "cp-1:2-f",
                da: " Use a tool such as the Birkman personality assessment.The information it provides delivers insight into your underlying needs and associated stress behavior, based on 11 behavioral components. Just being aware of these reactions allows you to adopt better attitudes and more productive behavior. A certified consultant can help you to interpret the results.",
              },
              {
                id: "cp-1:3-a",
                da: " Give yourself a few minutes before speaking to consider the consequences of your reaction. You may feel like you have evened the score or brought justice to the situation, but once you have said hurtful or unfair words the damage cannot be undone, only forgiven.",
              },
              {
                id: "cp-1:3-b",
                da: " Apologize for your outburst immediately. This is difficult to do while you are angry, but if you recognize that your behavior was inappropriate and take responsibility for it people are usually willing to continue engaging with you.",
              },
              {
                id: "cp-1:3-c",
                da: " Consider your attitudes and expectations of others and situations. If they are inappropriate or unrealistic, you are setting yourself up for emotional frustration and, possibly, conflict.",
              },
              {
                id: "cp-1:3-d",
                da: " Even when the other person makes it difficult for you to respect them by provoking you, you will need to disengage yourself from their comments and value the person. Unless you do so, you will never be able to re-engage them in cooperative behavior.",
              },
              {
                id: "cp-1:3-e",
                da: " When you are provoked, first try to put yourself in the other person's shoes. Whether the accusation or situation is fair or not, try to understand the reasons or motives behind the comments. Use comments such as 'I understand how you might feel that way' to defuse the situation and calm both of you.",
              },
              {
                id: "cp-1:3-f",
                da: " Adopt some form of daily relaxation technique to manage your tension and frustration. Exercise, meditate, do yoga or get a hobby that brings you peace.",
              },
              {
                id: "cp-1:3-g",
                da: " Share your thoughts and talk your issues through with a trusted peer or friend. This has great therapeutic advantages.",
              },
              {
                id: "cp-1:3-h",
                da: " Identify the particular triggers that make you defensive or produce an anger response. Know that you will need to remain particularly patient when exposed to those situations, people or topics.",
              },
              {
                id: "cp-1:3-i",
                da: " Try an anger management course if you are aware that your behavior is negatively affecting your relationships at work or in your personal life.",
              },
              {
                id: "cp-1:4-a",
                da: " Be respectful of whom you are talking to. It may be important for you to be expressive and painfully honest at home or with a co-worker, but more than likely you will want to edit what you say when speaking to clients or a superior.",
              },
              {
                id: "cp-1:4-b",
                da: " Before speaking, ask yourself how the other person would want to hear what you have to say. Some people need others to be direct and to the point; others require more concern about their feelings and a more diplomatic style of expression.",
              },
              {
                id: "cp-1:4-c",
                da: " Defend what you believe in with well-considered discussion, evidence to support your point of view and personal example, not through emotion.",
              },
            ],
          },
          {
            id: "cp-2",
            icon: require("@/assets/Iconography/Attributes/02-02_Acting with modesty.svg"),
            comp: "Acting with modesty",
            wdd: "Recognizes the contribution of others and acts humbly about strengths and achievements",
            progressMeasures: [
              {
                id: "cp-2-0",
                pm: "I share the credit of a joint effort with my collaborators",
                pmMap:
                  "Share the credit of a joint effort with my collaborators",
              },
              {
                id: "cp-2-1",
                pm: "I encourage others to take credit if it is important to them",
                pmMap:
                  "Encourage others to take credit if it is important to them",
              },
              {
                id: "cp-2-2",
                pm: "I can feel good about my accomplishments without others recognizing them",
                pmMap:
                  "Feel good about my accomplishments without others recognizing them",
              },
              {
                id: "cp-2-3",
                pm: "I do not exaggerate my accomplishments",
                pmMap: "Not exaggerate my accomplishments",
              },
            ],
            developmentActions: [
              {
                id: "cp-2:1-a",
                da: " Regardless of the size of their contributions, make it a point to thank the people who worked on a project during and after completion. Do this formally in a group e-mail or meeting.",
              },
              {
                id: "cp-2:1-b",
                da: " Let a person know when their contribution has improved your work. Admit openly that your work would be more difficult without their assistance.",
              },
              {
                id: "cp-2:1-c",
                da: " Regularly recognize the efforts of the person reporting directly to you. Make this a routine part of your management practice at meetings and in the office.",
              },
              {
                id: "cp-2:1-d",
                da: " Compliments let employees and peers feel appreciated, and it is an easy way to make people feel valued. The compliment does not have to be related to your work specifically. A simple affirmation of someone's pleasant demeanor, for example, lets them know you recognize a special quality.",
              },
              {
                id: "cp-2:1-e",
                da: " Focus on 'we' and not 'me'. Approach every project as a team effort that could not be accomplished without the contribution of many people. Rarely is only one individual involved in an assignment. Promote the team's efforts by circulating e-mail messages and memos that recap your team's performance. Forward customer praise to your supervisor.",
              },
              {
                id: "cp-2:2-a",
                da: " Do not forget the people who supported you during your rise to the top. Make their names public and encourage others to do the same. It allows you to be modest about the part you played while gaining the respect of supportive staff.",
              },
              {
                id: "cp-2:2-b",
                da: " Encourage people to treat you the same way they did before you became successful. Show former colleagues as well as family and friends that the relationships you share continue to be important.",
              },
              {
                id: "cp-2:2-c",
                da: " Be authentic. You have not changed simply because your position or level of authority has. Maintain the friendships you had prior to becoming successful.",
              },
              {
                id: "cp-2:2-d",
                da: " Resist the urge to be flashy, show off or live beyond your means. Refuse to obtain possessions or be involved in activities that only serve the purpose of drawing attention to you.",
              },
              {
                id: "cp-2:2-e",
                da: " Accept praise from others graciously. Show genuine gratitude for admiration of your success, but change the topic when people talk about your achievements too much. Turn the conversation to others' accomplishments and qualities.",
              },
              {
                id: "cp-2:3-a",
                da: " Ask relevant people who are important to you to provide consistent feedback about your work. Some of us require more reassurance and recognition than others. Do not assume your peers or superiors know or can read your needs.",
              },
              {
                id: "cp-2:3-b",
                da: " Work on self-praise. People will not always be available to recognize your hard work, so ensure you have a private reward system that relies on what you think of yourself, not what others think of you.",
              },
              {
                id: "cp-2:3-c",
                da: " Be humble about your strengths and achievements. Relish your accomplishments privately and build on them. Instead of boasting about a job well done, use the knowledge gained from its success and move forward.",
              },
              {
                id: "cp-2:3-d",
                da: " Find a balanced place from which you draw your sense of accomplishment. List the things of which you are proud in addition to your achievements at work. You may be a great parent, friend or highly skilled at a hobby, for example. It is not just your work that defines your accomplishments - look for recognition in other areas of your life as well.",
              },
              {
                id: "cp-2:3-e",
                da: " Ensure that you do not overstate your accomplishments and exaggerate your success to gain greater praise or attention. Be truthful and authentic, or you will appear fake and your real accomplishments will be lost in the noise.",
              },
              {
                id: "cp-2:3-f",
                da: " Develop a reputation for quietly striving for success instead of chasing praise.",
              },
              {
                id: "cp-2:3-g",
                da: " Ensure you are not spending more time grandstanding than getting work done. Colleagues and customers will quickly become frustrated and resentful.",
              },
              {
                id: "cp-2:3-h",
                da: " A modest person believes in working hard without expecting repayment. Do not expect recognition for your work. You are more likely to be praised once your peers see that you are modest about your achievements.",
              },
              {
                id: "cp-2:3-i",
                da: " Do not make assumptions about the cultural norms in your work environment. Identify them correctly and act accordingly.",
              },
            ],
          },
          {
            id: "cp-3",
            icon: require("@/assets/Iconography/Attributes/02-01_Being patient.svg"),
            comp: "Being patient",
            wdd: "Is tolerant with others and knows when to slow down to let them catch up",
            progressMeasures: [
              {
                id: "cp-3-0",
                pm: "I am patient when others take longer than me to grasp a concept",
                pmMap:
                  "Be patient when others take longer than me to grasp a concept",
              },
              {
                id: "cp-3-1",
                pm: "I can adjust my expectations when things do not go as planned",
                pmMap:
                  "Adjust my expectations when things do not go as planned",
              },
              {
                id: "cp-3-2",
                pm: "I do things well, even if it takes longer that way",
                pmMap: "Do things well, even if it takes longer that way",
              },
              {
                id: "cp-3-3",
                pm: "I can curb my impulse to act when the timing is not right",
                pmMap: "Curb my impulse to act when the timing is not right",
              },
            ],
            developmentActions: [
              {
                id: "cp-3:1-a",
                da: " Face reality. Have you overestimated what a person or even you can do? What can you reasonably expect a person to know and be able to produce based on their experience? Is this person the right resource to use in this project, given their skills set? If not, it may really be beyond their control if they cannot succeed.",
              },
              {
                id: "cp-3:1-b",
                da: " Be clear about your expectations and in providing direction. Do not leave anything open to misinterpretation. People often hear information selectively and two can interpret the same conversation entirely differently. Make a note of your expectations and review them with the team to ensure everyone is on the same page. Add details such as timelines, milestones, targets etcetera.",
              },
              {
                id: "cp-3:1-c",
                da: " Strongly encourage people to voice their objections upfront, if they have any. Managers are often not challenged about their unrealistic goals, which lead to disappointment or frustration when these are not accomplished.",
              },
              {
                id: "cp-3:1-d",
                da: " Check routinely how high you set the bar. Are you expecting no mistakes ever to be made? Are your deadlines unrealistic or your timeframes unnecessarily short? Are you overly competitive with peers? Are team members unmotivated? Are you allowing subordinates time to learn? Are they continually trying to leave for other departments? Are they forced to work late hours and on weekends on a regular basis? Ask if you do not know, because these are all clues that your expectations could be unrealistic.",
              },
              {
                id: "cp-3:1-e",
                da: " Look for signs that people need time to recharge, and allow them the break. It may slow down the process in the short term, but in the long term you will avoid good talent getting burnout.",
              },
              {
                id: "cp-3:1-f",
                da: " Do you become impatient when you compare different people's performance? Do not fall into this trap. No two individuals are the same and they will perform differently in different contexts. Getting impatient with someone because you found them lacking compared with another is unfair and unproductive. Rather try to exploit, in a positive sense, people's strengths and develop their weaknesses into strengths. The latter requires patience but will pay off for both you and your colleague in the long term.",
              },
              {
                id: "cp-3:2-a",
                da: " Try to isolate exactly what about an individual stirs your impatience. Does it have an impact on the person's work? It may be something inconsequential such as their tone of voice, demeanor, the way they dress, an annoying habit. If this is the case, try to overlook or accept their idiosyncrasies, especially if these have no relevance to your work.",
              },
              {
                id: "cp-3:2-b",
                da: " If your impatience stems from something that does affect your work, such as a betrayal of trust or irreconcilable work styles, initiate an honest discussion with the person. These conversations are not easy, but ignoring your concerns will not make them go away. They are likely to interfere with your performance and level of comfort at work. Ensure you make it clear that you are having the conversation because you want to improve your working relationship. Try your best to understand the other person's position. If necessary, ask a mediator from the human resources department to facilitate the discussion, especially if the topic is emotionally charged.",
              },
              {
                id: "cp-3:2-c",
                da: " Look for the positive traits in people everyone has some. Which talents does an individual bring to the table? Before interacting with someone who is difficult, prepare by reminding yourself of those talents.",
              },
              {
                id: "cp-3:2-d",
                da: " Try to understand the motivation behind people's acts or the particular way they have acted in the past. For example, someone may appear rude but, in fact, may just not be comfortable in certain situations in general.",
              },
              {
                id: "cp-3:2-e",
                da: " Are you being disrespectful? A lack of patience breeds disrespect. Ensure you do not treat someone you dislike differently from others, for example, interrupting unnecessarily, raising your voice or discounting their opinion rudely.",
              },
              {
                id: "cp-3:3-a",
                da: " Relax! Try to relieve stress with relaxation techniques such as deep breathing and self-motivation. Many books are available to teach you about relaxation techniques.",
              },
              {
                id: "cp-3:3-b",
                da: " Draw on your humor. Stressful things are often funny after the fact, but not at the time. Try to find the humor there and then and laugh - it relieves stress.",
              },
              {
                id: "cp-3:3-c",
                da: " Recognize when you are losing your patience and ask a trusted peer with a calming influence to help you refocus.",
              },
              {
                id: "cp-3:3-d",
                da: " Focus your energy on solutions to the problem instead of allowing frustrations and impatience to build.",
              },
              {
                id: "cp-3:3-e",
                da: " Quick fixes cannot always apply. Sit back and go with the flow, if necessary.",
              },
              {
                id: "cp-3:3-f",
                da: " Try to be flexible and spontaneous. Whether at work or in your private life, go along when there is a change of plans. The more comfortable you are with plans changing at the last minute, the more patience you will develop for when thing are beyond your control.",
              },
              {
                id: "cp-3:4-a",
                da: " Delegate what you can, even if you can do it quicker yourself. Create a comprehensive list of tasks or projects others can do and commit to let them.",
              },
              {
                id: "cp-3:4-b",
                da: " When delegating, allow people enough space and time to work through problems, tasks or answers before you intervene, even if you had the answer early. It will give them the chance to consider the problem and, potentially, they could offer a route you have not considered.",
              },
              {
                id: "cp-3:4-c",
                da: " If you are an expert in your field, use every opportunity to be a teacher or mentor. Identify those who struggle and coach them where possible. When your impatience grows, ask yourself what a good teacher would do.",
              },
              {
                id: "cp-3:4-d",
                da: " Instead of micro-managing, take on new responsibilities that will improve your ability to monitor processes and keep others on track.",
              },
              {
                id: "cp-3:4-e",
                da: " Do not assume your experience of doing something is the only or best way to tackle a task. Someone else may take more time but yield more accurate results or take a more creative approach. Encourage innovative ways of thinking and new methodologies.",
              },
              {
                id: "cp-3:5-a",
                da: " Calculate the risk. What are the consequences of taking the wrong action too soon? If it will result in grave and irreparable consequences, allow yourself more time to consider your options and get input from others.",
              },
              {
                id: "cp-3:5-b",
                da: " If you feel the need to take action, do so by separating the problem into smaller parts and making decisions on a smaller scale. You will satisfy your need for action but will do so in a manageable way.",
              },
              {
                id: "cp-3:5-c",
                da: " Assemble a team to make the decision do not make it on your own. Ensure the team is well represented with a combination of people with varied styles, including analytical thinkers. Ensure the atmosphere allows for open discussion and that one person does not yield all the decision-making power. Try to reach consensus.",
              },
              {
                id: "cp-3:6-a",
                da: " Read about great leaders who brought about change with perseverance and patience.",
              },
              {
                id: "cp-3:6-b",
                da: " Support individuals who request more time to consider a proposition or decision.",
              },
              {
                id: "cp-3:6-c",
                da: " Pick your battles: not all situations require immediate action, so practice patience when the urgency is self-imposed.",
              },
            ],
          },
        ],
      },
      rc: {
        characteristic: "Trust and Responsibility",
        wdd: "Acting ethically; treating people fairly regardless of race, gender, cultural differences; accepting accountability for personal actions; being considered trustworthy by others.",
        icon: require("@/assets/Iconography/Characteristics/14_Responsible Citizen.svg"),
        competencies: [
          {
            id: "rc-0",
            icon: require("@/assets/Iconography/Attributes/14-04_Acting Ethically.svg"),
            comp: "Acting ethically",
            wdd: "Acts in line with the dominant values of the organization",
            progressMeasures: [
              {
                id: "rc-0-0",
                pm: "I can adjust to the dominant values of the people I work with without comprising my own values",
                pmMap:
                  "Adjust to the dominant values of the people I work with without comprising my own values",
              },
              {
                id: "rc-0-1",
                pm: "I make amends if I have behaved inappropriately",
                pmMap: "Make amends if I have behaved inappropriately",
              },
              {
                id: "rc-0-2",
                pm: "I think about the dominant values of the context I am in when faced with an ambiguous decision",
                pmMap:
                  "Act in line with the dominant values of the context I am in when faced with an ambiguous decision",
              },
              {
                id: "rc-0-3",
                pm: "My values stay consistent regardless of the situation",
                pmMap:
                  "Stay consistent in terms of values regardless of the situation",
              },
            ],
            developmentActions: [
              {
                id: "rc-0:1-a",
                da: " Familiarize yourself with your company's values.",
              },
              {
                id: "rc-0:1-b",
                da: " Initiate a discussion among your colleagues and team mates to examine how well your group is doing at abiding by the company's values.",
              },
              {
                id: "rc-0:1-c",
                da: " Try the following exercise: List the company values on paper. Then, for each value, list the things you do that promote the value and the things that contradict it. Write down what you can do differently to bridge any shortcomings.",
              },
              {
                id: "rc-0:1-d",
                da: " Let the company values guide you during difficult and ambiguous decision-making times.",
              },
              {
                id: "rc-0:2-a",
                da: " Think of someone who is considered to act unethically. Write down what it is about them that makes you consider their behavior unethical. Would you make the same decisions the person made under the same circumstances?",
              },
              {
                id: "rc-0:2-b",
                da: " When facing a tough decision, think of someone who is respected for their ethical behavior. What would that person do in your shoes? Ask them, if possible.",
              },
              {
                id: "rc-0:2-c",
                da: " Ask yourself before taking action: 'Even if everyone involved does not get what they want, will their dignity and rights be respected through my decision?'",
              },
              {
                id: "rc-0:2-d",
                da: " Reflect on any ambiguous decision afterwards. How did it turn out for all concerned? If you had to do it over again, what would you do differently?",
              },
              {
                id: "rc-0:2-e",
                da: " Do the 'publicity test': If you had to explain your decision on national television, would you be comfortable doing so?",
              },
              {
                id: "rc-0:3-a",
                da: " Weigh the consequences of your behavior. Is it worth risking your position?",
              },
              {
                id: "rc-0:3-b",
                da: " Is there any work situation in which your values are unrealistic? Will you have difficulties to accept the culture in a similar organization?",
              },
              {
                id: "rc-0:3-c",
                da: " Can you concede that there are some values not important enough to risk your position for?",
              },
              {
                id: "rc-0:3-d",
                da: " If you cannot adhere to anyone else's values, including those of your company, then perhaps you should consider working independently. If you do so, keep in mind that you may nonetheless need to take your client's values into consideration.",
              },
              {
                id: "rc-0:4-a",
                da: " Talk to a respected colleague or your superior about how you could reconcile gaps.",
              },
              {
                id: "rc-0:4-b",
                da: " Realize that your work will not necessarily fulfill all your values. You can also satisfy your personal values through your life outside of work. Get involved in activities that promote the values you are not able to address through work.",
              },
              {
                id: "rc-0:4-c",
                da: " Consider whether it is really the values of the organization with which you have an issue, or the behavior of particular individuals or your team. If necessary or possible, find a reassignment.",
              },
              {
                id: "rc-0:4-d",
                da: " If you cannot reconcile your values and those of the company, you should consider moving to another organization.",
              },
              {
                id: "rc-0:5-a",
                da: " Do not assume that everyone is aware of the situation or feels differently about it. If your superior is not receptive, identify who in the chain of command will be open to your concerns so that you will have an alternative listener.",
              },
              {
                id: "rc-0:5-b",
                da: " Collect as much documentation as possible to support your position and provide evidence.",
              },
              {
                id: "rc-0:5-c",
                da: " There is safety in numbers. Are you the only one with objections? Identify others that have raised concerns and present your objections collectively.",
              },
              {
                id: "rc-0:5-d",
                da: " Know your legal rights. There are laws to protect whistle-blowers. Talk to a human resources representative in confidence about your concerns and advise them if the matter has great implications and cannot be resolved at your level.",
              },
              {
                id: "rc-0:5-e",
                da: " If the unethical behavior is pervasive in your industry or organization's culture, you will be better off leaving. You may be leaving your job, but you will be taking a huge step towards a career of which you can be proud.",
              },
            ],
          },
          {
            id: "rc-1",
            icon: require("@/assets/Iconography/Attributes/14-03_Acting Fairly.svg"),
            comp: "Acting fairly",
            wdd: "Treats people fairly regardless of race, gender, cultural differences or personal styles",
            progressMeasures: [
              {
                id: "rc-1-0",
                pm: "I give everyone appropriate opportunities",
                pmMap: "Give everyone appropriate opportunities",
              },
              {
                id: "rc-1-1",
                pm: "I consider whether I am being fair before I act",
                pmMap: "Act fairly towards others",
              },
              {
                id: "rc-1-2",
                pm: "I do not let my personal feelings about someone dictate how I behave towards them. I consider everybody’s interests, not only mine",
                pmMap:
                  "Not let my personal feelings about someone dictate how I behave towards them.",
              },
              {
                id: "rc-1-3",
                pm: "I am comfortable around people who are different to me",
                pmMap: "Be comfortable around people who are different to me",
              },
            ],
            developmentActions: [
              {
                id: "rc-1:1-a",
                da: " Subtle behavior says just as much as overt action. Examine closely whether you recognize yourself doing any of the following on a regular basis: directing most of your questions to one particular person, being less attentive to certain people and cutting them off more often, making yourself more available to some than others, being more judgmental or negative about a particular person's ideas, inviting some people to lunch and not others, and giving unequal praise or recognition. If you answer yes to one or any of the above, you should try to act more fairly.",
              },
              {
                id: "rc-1:1-b",
                da: " Hand out assignments fairly to avoid sending a message that you have favorites. Giving one or two people the most desired projects all the time lessens your ability to develop your team's talents and denies people the opportunity to prove themselves. Consider creative ways to engage a person who is not performing well, instead of alienating them. For example, pair a strong and less strong performer together on a team assignment.",
              },
              {
                id: "rc-1:1-c",
                da: " Ensure you do not compare employees, publicly or privately, or constantly use one person as an example of excellence. You may foster a loss of respect or resentment for the person among team members.",
              },
              {
                id: "rc-1:1-d",
                da: " In discussions and meetings, encourage input from everyone and give everyone a chance to be heard.",
              },
              {
                id: "rc-1:1-e",
                da: " Be aware of adverse body language when the person is talking to you, such as rolling your eyes, keeping your arms tightly crossed or not smiling when appropriate.",
              },
              {
                id: "rc-1:1-f",
                da: " If you harbor resentment towards a particular person, talk to them in private. Strong negative feelings that go unaddressed will become disruptive and can lead to passiveaggressive behavior.",
              },
              {
                id: "rc-1:1-g",
                da: " Let a mediator facilitate the discussion if the issues cannot be resolved among yourselves.",
              },
              {
                id: "rc-1:2-a",
                da: " Identify unavoidable differences that will have a negative impact on people and take these into account when interacting with them. For example, if someone has just joined your team, they will need time to form relationships and may require more effort than members who have worked with each other for some time.",
              },
              {
                id: "rc-1:2-b",
                da: " Some differences are temporary, for example, technical skills can be acquired. But if a team member takes beyond a reasonable time to acquire these skills and you continue to compensate for them, it will be seen as unfair by the others.",
              },
              {
                id: "rc-1:2-c",
                da: " Not everyone dislikes being treated unfairly, especially the person who benefits. And not everyone makes a fuss when unfairness is at play, but everyone reacts to it. People may withdraw, be less cooperative or even sabotage others. Remain aware of how people perceive their environment.",
              },
              {
                id: "rc-1:2-d",
                da: " Use a so-called cloak of ignorance, a philosophy which first removes all characteristics from the people involved. Then it asks you to make a decision about them based on a characteristic, provided you are prepared to be put in that situation and assume that characteristic. For example, there are 10 people in a lifeboat and you have to decide which one to throw off. If you decide to throw the oldest person overboard, you must be prepared to be put in the boat as the oldest person.",
              },
              {
                id: "rc-1:3-a",
                da: " It is vital to be aware of any bias you may have towards one particular group or more. It may seem obvious, but many people do not recognize their prejudices. Get feedback from others, too. Give some thought to the groups which make you most uncomfortable. Once you are honest with yourself, you can begin to address your issues.",
              },
              {
                id: "rc-1:3-b",
                da: " Get to know a few individuals from groups that are different to you. Working with people closely on a project or spending social time with them could change your assumptions.",
              },
              {
                id: "rc-1:3-c",
                da: " Examine your behavior around people from the groups against which you are biased. Do you avoid asking them questions? Do you limit the time and attention you give them? Are you less approachable, more judgmental or spend little or no time socially with people from different cultures?",
              },
              {
                id: "rc-1:4-a",
                da: " Stereotype yourself. With which group would other people lump you? List the stereotypes you will face based on how you may be categorized. Do they accurately describe who you are and how you perform?",
              },
              {
                id: "rc-1:4-b",
                da: " Learn to link things you like with diversity. For example, increase your exposure to diverse groups through hobbies you enjoy. If you like reading, read about other religions; if you enjoy travel, visit foreign places with unfamiliar cultures; if you enjoy eating, tour the ethnic restaurants in your city.",
              },
              {
                id: "rc-1:4-c",
                da: " Attend a diversity awareness course through your company, if available.",
              },
              {
                id: "rc-1:4-d",
                da: " At work, maximize your exposure to talented people from diverse groups. Invite people from other groups to your meetings or to work on your projects. Find a wellrespected person in the company who falls into a group against which you may feel biased and ask them for advice or expert opinion.",
              },
              {
                id: "rc-1:4-e",
                da: " List the things you may have in common with the person that makes you feel uncomfortable. Challenge yourself to define at least 10 things, big or small.",
              },
              {
                id: "rc-1:5-a",
                da: " Give credit to others for their hard work and promote the entire group's accomplishments whenever possible, even if you played the largest part in them. Promoting the team's work is the same as promoting yourself, but adds a small dose of humility.",
              },
              {
                id: "rc-1:5-b",
                da: " Do not withhold information that others need to do their jobs. It is not only unfair, but creates a highly inefficient work environment.",
              },
              {
                id: "rc-1:5-c",
                da: " Consider what other people stand to lose because of your comments or decisions. Would you want to be in their shoes?",
              },
              {
                id: "rc-1:6-a",
                da: " Attend cultural events such as foreign films and exhibitions in your city.",
              },
              {
                id: "rc-1:6-b",
                da: " Take advantage of international assignments whenever possible.",
              },
              {
                id: "rc-1:6-c",
                da: " You do not have to cross oceans to be exposed to diverse groups. Ask for assignments that involve global teams.",
              },
              {
                id: "rc-1:6-d",
                da: " Mentor people in your company who have diverse cultural backgrounds or are from a different gender or race, or seek a mentor from a different background.",
              },
              {
                id: "rc-1:6-e",
                da: " Observe people. Which differences based on the group they belong to do you see in their behavior?",
              },
            ],
          },
          {
            id: "rc-2",
            icon: require("@/assets/Iconography/Attributes/14-02_Taking Accountability.svg"),
            comp: "Taking accountability",
            wdd: "Accepts accountability for all areas of responsibility, even the unpopular or tough ones",
            progressMeasures: [
              {
                id: "rc-2-0",
                pm: "I admit when I have made a mistake, without being asked",
                pmMap: "Admit when I have made a mistake, without being asked",
              },
              {
                id: "rc-2-1",
                pm: "I do not make excuses for poor performance",
                pmMap: "Not make excuses for poor performance.",
              },
              {
                id: "rc-2-2",
                pm: "I deliver on my promises",
                pmMap: "Deliver on my promises",
              },
              {
                id: "rc-2-3",
                pm: "I do not blame outside factors for my circumstances or problems",
                pmMap:
                  "Not blame outside factors for my circumstances or problems",
              },
            ],
            developmentActions: [
              {
                id: "rc-2:1-a",
                da: " Be assertive and take control. Ask for what you need to do your job instead of assuming things will happen automatically. The more proactive you are, the less likely you will have reason to blame others. When necessary, confront situations and people in an assertive style that is straightforward and truthful, without being threatening or overly aggressive. Ask for what you need to do your job effectively, such as information, assistance and support. Also, do not be afraid to say no.",
              },
              {
                id: "rc-2:1-b",
                da: " Make a list of the external obstacles you might face during the task ahead and plan how to deal with them.",
              },
              {
                id: "rc-2:1-c",
                da: " Differentiate between excuses and explanations and ensure you use the latter. An explanation clarifies the situation without blame or justification. Its goal should be to point out ways to improve in the future, nothing more.",
              },
              {
                id: "rc-2:1-d",
                da: " Focus your attention on delivering results. Create solutions for the obstacles, not excuses to avoid them. Approach the unexpected hurdles creatively.",
              },
              {
                id: "rc-2:1-e",
                da: " Resist pointing fingers when things get difficult. What will really be gained by spending your time and energy on finding someone or something to blame? Rally together, as a team should, and focus again on the solutions to the problem. Create two columns: in one list the ways other people can improve in future so as not to repeat the same mistakes, and in the other column how you can do the same.",
              },
              {
                id: "rc-2:1-f",
                da: " Do not focus on the origin of the problem. It does not matter where a problem stems from, or whether you created or inherited it. The crucial question to ask yourself is: 'What can I do about it?'",
              },
              {
                id: "rc-2:1-g",
                da: " Be aware of the language you use. If you hear yourself making statements such as 'Nobody told me', 'I'm just following orders' or 'The mistake couldn't have been avoided', be sure to question the honesty and validity of these comments.",
              },
              {
                id: "rc-2:2-a",
                da: " If you are overly sensitive to criticism, ask for feedback when you have done an assignment well. It is easier to accept constructive criticism when you are feeling good about your accomplishments. This will prepare you to be more open to feedback when you have not performed as well. Remember that there is always, always room for improvement.",
              },
              {
                id: "rc-2:2-b",
                da: " Understand the reason why you are being held accountable. It is not a punishment or admonishment of you as a person. You are being held accountable for improving your skills or because people trusted you. If you recognize your weaknesses, it will create opportunities to learn about process management, problem solving and quality decision making.",
              },
              {
                id: "rc-2:2-c",
                da: " A little humility goes a long way. Admit your mistake and assure your boss or co-workers that you will learn from your mistakes. People are more inclined to have sympathy for your situation when you demonstrate genuine humility.",
              },
              {
                id: "rc-2:2-d",
                da: " Getting defensive or angry or feeling insecure may be your first reaction, but it will not improve the situation. On the contrary, it could alienate you from others and make it more difficult for you to accept constructive suggestions. Be aware of your emotional reaction and give yourself time to calm down before responding.",
              },
              {
                id: "rc-2:2-e",
                da: " Not holding yourself accountable for your mistakes shifts the responsibility to someone else. Consider the impact on your peers or team members if you are dishonest about the part you played.",
              },
              {
                id: "rc-2:2-f",
                da: " Do not pass difficult decisions on to others because you do not want to make them. Get input, if needed, to make the best decision, but then make it and proceed.",
              },
              {
                id: "rc-2:3-a",
                da: " Question whether your behavior and output are positively contributing to the organization's objectives. If not, hold yourself accountable for making improvements. For example, examine how much time you spend on personal issues or talking to peers about things unrelated to work.",
              },
              {
                id: "rc-2:3-b",
                da: " Examine the procedures and controls in place to ensure accountability. If the organization lacks such measures, establish a taskforce to address the minimum standards that need to be defined, adhered to and monitored.",
              },
              {
                id: "rc-2:3-c",
                da: " Establish a culture of accountability within your group by demonstrating humility and admitting your mistakes. Take ownership of poor decisions and, to show you have considered the matter, inform others how you will do things differently next time. Ensure that there are consequences for a lack of accountability, but that these are fair and administered even-handedly.",
              },
              {
                id: "rc-2:4-a",
                da: " Once you have come to an agreement with someone, be sure to respect it. It does not matter whether it is something small, such as a document you have promised to peruse, or something major, such as a merger to which you have agreed. Ensure your word can be trusted or people will lose respect for you.",
              },
              {
                id: "rc-2:4-b",
                da: " If you are unable to meet promised deadlines, be proactive and let others know in advance. Do not wait for them to ask you what is going on - it is unfair and demoralizing.",
              },
              {
                id: "rc-2:4-c",
                da: " Do not make people wait for your response to their requests. It sends the message that their needs are not important to you.",
              },
              {
                id: "rc-2:4-d",
                da: " It is reasonable that your plate may be too full. Be realistic about what you can and cannot do. Do not make promises on which you cannot deliver. It is better to be honest upfront about when you will be able to do things.",
              },
              {
                id: "rc-2:5-a",
                da: " When a mistake has occurred, talk to your superior immediately. Be honest about what has happened and express your concern about the potential consequences. You may be relieved to hear that they are not as bad as you thought, and if not, you will at least know where you stand.",
              },
              {
                id: "rc-2:5-b",
                da: " Offer solutions or the options available to address or correct the mistake. It shows a willingness to learn and move forward.",
              },
              {
                id: "rc-2:5-c",
                da: " If the company's culture is such that mistakes are unforgivable, you may want to consider working elsewhere. It is difficult, if not downright impossible, to develop and learn where there is no room for mistakes.",
              },
            ],
          },
          {
            id: "rc-3",
            icon: require("@/assets/Iconography/Attributes/14-01_Being Trustworthy.svg"),
            comp: "Being trustworthy",
            wdd: "Is trusted by others and can be relied on to keep promises and protect confidential information",
            progressMeasures: [
              {
                id: "rc-3-0",
                pm: "I can be counted on to do what I committed to do",
                pmMap: "Be counted on to do what I committed to do",
              },
              {
                id: "rc-3-1",
                pm: "I am honest with people about my intentions",
                pmMap: "Be honest with people about my intentions",
              },
              {
                id: "rc-3-2",
                pm: "I am consistent in how I act towards different people",
                pmMap: "Be consistent in how I act towards different people",
              },
              {
                id: "rc-3-3",
                pm: "I am quick to admit when things are my fault",
                pmMap: "Be quick to admit when things are my fault",
              },
            ],
            developmentActions: [
              {
                id: "rc-3:1-a",
                da: " Write down reasons why the other party's interests should be considered. Are your actions worth the short-term benefits? What are the long-term benefits of a mutually beneficial approach?",
              },
              {
                id: "rc-3:1-b",
                da: " Consider creative ways to achieve the same result through fairer means.",
              },
              {
                id: "rc-3:1-c",
                da: " Ask yourself if you would do the same to someone about whom you personally care. The same standards should apply to a professional setting.",
              },
              {
                id: "rc-3:1-d",
                da: " Are your actions in the best interest of the organization?",
              },
              {
                id: "rc-3:1-e",
                da: " Which negative political ramifications might your actions have?",
              },
              {
                id: "rc-3:2-a",
                da: " If you have a problem with someone, resolve it by talking directly to that person.",
              },
              {
                id: "rc-3:2-b",
                da: " Do not try to qualify the information you have received. It is not up to you to decide whether it really must be kept confidential. If you have been asked to keep it confidential, do it.",
              },
              {
                id: "rc-3:2-c",
                da: " Resist the temptation to share confidential information as a way to bond with others. You would only lose because you would be compromising your relationship with the one who trusted you. Try to bond with others over positive things you have in common, such as hobbies and work experiences.",
              },
              {
                id: "rc-3:3-a",
                da: " Instead of assuming what people may want to hear, focus on what they really need to hear. Use this as a guide when deciding which information you want to withhold.",
              },
              {
                id: "rc-3:3-b",
                da: " Honesty is well served with a dose of diplomacy. In the workplace, it is important to be able to manage sensitive discussions, especially because parties often have much at stake. Groom your diplomacy skills to become more successful at communicating difficult information.",
              },
              {
                id: "rc-3:3-c",
                da: " Are you less likely to be scrupulous with certain people? For example, are you hesitant to be completely honest with your superior, a particular client or a close peer? Identifying these people will provide clues to your motives. Ask a coach to help you improve your sincerity and openness with these individuals.",
              },
              {
                id: "rc-3:4-a",
                da: " Be realistic and honest about what you can get done or to how much you can commit. Explain your situation or commitments to those involved and give them other options if you do not want to make a delivery promise. Perhaps you can make a smaller commitment on which you can deliver that will serve as your contribution.",
              },
              {
                id: "rc-3:4-b",
                da: " Be organized and know your workload. Sometimes people commit to too much because they are ignorant of their true workload. Keep an accurate calendar with timelines for other projects due and review it carefully before you commit. Share your calendar with others to raise awareness of your workload and justify why you cannot commit at this point.",
              },
              {
                id: "rc-3:4-c",
                da: " Commit yourself, but on the condition that obstacles in your way are removed. For example, perhaps another project can be moved or a co-worker can be assigned to help.",
              },
              {
                id: "rc-3:4-d",
                da: " Learn to say no. It really is okay to do so. As long as you can motivate it, you have the right to say no.",
              },
              {
                id: "rc-3:4-e",
                da: " Ensure that you fully understand the scope of a project and the resources available before you commit to a deadline.",
              },
              {
                id: "rc-3:5-a",
                da: " Promote your contribution only if you were involved in the majority of the work.",
              },
              {
                id: "rc-3:5-b",
                da: " If you were only tangentially involved, praise others' accomplishments without including yourself in the accolades.",
              },
              {
                id: "rc-3:5-c",
                da: " Admit your mistakes. You will be perceived as honest and open to improvement.",
              },
              {
                id: "rc-3:5-d",
                da: " When taking credit for work done, be sure to include the efforts of your team and everyone involved. Few projects' success is based on one person's contribution.",
              },
              {
                id: "rc-3:5-e",
                da: " Is your information based on fact and truth, or your interpretation of the truth? Be careful when walking that fine line. Are you able to back your statements with evidence?",
              },
            ],
          },
        ],
      },
    },
  },
  playerJourney: {
    t1_1: "Player has created account",
    t1_2: "Player has not created account",
    t2_1: "Skills Added  ",
    t2_2: "Has not Started adding skills",
    t3_1: "Motivation Survey Complete",
    t3_2: "Motivation Survey Overdue",
    t3_3: "Yet to complete first motivation Survey",
    t4_1: "Coaching Survey Complete",
    t4_2: "Coaching Survey Overdue",
    t4_3: "Yet to complete first Coaching Survey",
  },
  tblHeadings: {
    th1: "ID",
    th2: "NAME",
    th3: "EMAIL",
    th4: "ADVISOR NAME",
    th5: "COMPETENCIES",
    th6: "COACHING EXPERIENCE",
    th7: "ONBOARDING",
    th8: "MONITORING",
    th9: "EXPERIENCE",
    th10: "ACTION",
    th11: "ACTIONS",
    th12: "COMPANY",
    th13: "USER TYPE",
    th14: "STATUS",
    th15: "COMPANY NAME",
    th16: "COACHING",
    th17: "MOTIVATION",
    th21: "FEEDBACK",
    th18: "PLAYER",
    th19: "COACH",
    th20: "COMPETENCY NAME",
    th21: "PROGRESS",
  },
};
